import React, { useId, SVGAttributes } from "react";
import { styled, css, Theme } from "@mui/material/styles";
import { theme } from "./src/app/styles/theme";

import AccountBoxIconMui from "@mui/icons-material/AccountBox";
import AccountCircleOutlineIconMui from "@mui/icons-material/AccountCircleOutlined";
import AccountGroupIconMui from "@mui/icons-material/Group";
import AccountGroupOutlinedIconMui from "@mui/icons-material/GroupOutlined";
import ArrowDropDownIconMui from "@mui/icons-material/ArrowDropDown";
import ArrowLeftIconMui from "@mui/icons-material/ArrowBack";
import ArrowRightIconMui from "@mui/icons-material/ArrowForward";
import BookOpenVariantIconMui from "@mui/icons-material/MenuBookOutlined";
import BlockIconMui from "@mui/icons-material/Block";
import CancelCircleIconMui from "@mui/icons-material/Cancel";
import CheckCircleIconMui from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIconMui from "@mui/icons-material/RadioButtonUnchecked";
import CalendarBlankIconMui from "@mui/icons-material/CalendarToday";
import ChevronDownIconMui from "@mui/icons-material/KeyboardArrowDown";
import ChevronUpIconMui from "@mui/icons-material/KeyboardArrowUp";
import ChevronLeftIconMui from "@mui/icons-material/ChevronLeft";
import ChevronRightIconMui from "@mui/icons-material/ChevronRight";
import CloseIconMui from "@mui/icons-material/Close";
import DeleteIconMui from "@mui/icons-material/Delete";
import DownloadForOfflineIconMui from "@mui/icons-material/DownloadForOffline";
import EyeIconMui from "@mui/icons-material/Visibility";
import EyeOutlinedIconMui from "@mui/icons-material/RemoveRedEyeOutlined";
import ErrorOutlineIconMui from "@mui/icons-material/ErrorOutline";
import FileDocumentIconMui from "@mui/icons-material/Description";
import LabelIconMui from "@mui/icons-material/Label";
import LockIconMui from "@mui/icons-material/Lock";
import PenIconMui from "@mui/icons-material/Create";
import VideoCamIconMui from "@mui/icons-material/Videocam";
import VideoCamOffIconMui from "@mui/icons-material/VideocamOff";
import ImageIconMui from "@mui/icons-material/Image";
import ImageIconOutlinedMui from "@mui/icons-material/ImageOutlined";
import PdfIconMui from "@mui/icons-material/PictureAsPdf";
import PlusIconMui from "@mui/icons-material/Add";
import TagIconMui from "@mui/icons-material/LocalOffer";
import TagOutlinedIconMui from "@mui/icons-material/LocalOfferOutlined";
import ViewDashboardIconMui from "@mui/icons-material/Dashboard";
import ViewStreamIconMui from "@mui/icons-material/ViewStream";
import WarningIconMui from "@mui/icons-material/Warning";
import QuestionMarkIconMui from "@mui/icons-material/QuestionMark";
import QuestionMarkOutlinedIconMui from "@mui/icons-material/HelpOutlineOutlined";
import LinkIconMui from "@mui/icons-material/Link";
import LaunchIconMui from "@mui/icons-material/Launch";
import ExpandMoreIconMui from "@mui/icons-material/ExpandMore";
import FirstPageIconMui from "@mui/icons-material/FirstPage";
import KeyboardArrowLeftMui from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightMui from "@mui/icons-material/KeyboardArrowRight";
import LastPageIconMui from "@mui/icons-material/LastPage";
import EditIconMui from "@mui/icons-material/Edit";
import InfoIconMui from "@mui/icons-material/Info";
import InfoOutlinedIconMui from "@mui/icons-material/InfoOutlined";
import DragHandleIconMui from "@mui/icons-material/DragHandle";
import MagnifyIconMui from "@mui/icons-material/Search";
import KeyIconMui from "@mui/icons-material/VpnKey";
import FileUploadMui from "@mui/icons-material/Publish";
import MicrophoneOutlineIconMui from "@mui/icons-material/MicNone";
import PlayIconMui from "@mui/icons-material/PlayArrow";
import PauseIconMui from "@mui/icons-material/Pause";
import FilterIconMui from "@mui/icons-material/FilterList";
import ThumbUpOutlineIconMui from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlineIconMui from "@mui/icons-material/ThumbDownOutlined";
import ThumbUpIconMui from "@mui/icons-material/ThumbUp";
import ThumbDownIconMui from "@mui/icons-material/ThumbDown";
import TranslateIconMui from "@mui/icons-material/Translate";
import CopyIconMui from "@mui/icons-material/FileCopy";
import SyncIconMui from "@mui/icons-material/Sync";
import AddCircleOutlineMui from "@mui/icons-material/AddCircleOutline";
import MenuIconMui from "@mui/icons-material/Menu";
import MenuOpenIconMui from "@mui/icons-material/MenuOpen";
import SortIconMui from "@mui/icons-material/Sort";
import StoreIconMui from "@mui/icons-material/Store";
import StoreOutlinedIconMui from "@mui/icons-material/StoreOutlined";
import TerminalIconMui from "@mui/icons-material/Terminal";
import PersonIconMui from "@mui/icons-material/Person";
import PersonOutlinedIconMui from "@mui/icons-material/PersonOutlineOutlined";
import KeyOutlinedIconMui from "@mui/icons-material/VpnKeyOutlined";
import DashboardOutlinedIconMui from "@mui/icons-material/DashboardOutlined";
import SubscriptionsOutlinedIconMui from "@mui/icons-material/SubscriptionsOutlined";
import SubscriptionsIconMui from "@mui/icons-material/Subscriptions";
import TopicIconMui from "@mui/icons-material/Topic";
import TopicOutlinedIconMui from "@mui/icons-material/TopicOutlined";
import FileTreeIconMui from "@mui/icons-material/AccountTree";
import FileTreeOutlinedIconMui from "@mui/icons-material/AccountTreeOutlined";
import AccountCircleIconMui from "@mui/icons-material/AccountCircle";
import ArchiveIconMui from "@mui/icons-material/Archive";
import UnarchiveIconMui from "@mui/icons-material/Unarchive";
import BlurOnIconMui from "@mui/icons-material/BlurOn";
import MoreVertIconMui from "@mui/icons-material/MoreVert";
import TextFieldsIconMui from "@mui/icons-material/TextFields";
import FormatClearIconMui from "@mui/icons-material/FormatClear";
import MicOnIconMui from "@mui/icons-material/Mic";
import MicOffIconMui from "@mui/icons-material/MicOff";
import ClearIconMui from "@mui/icons-material/Clear";
import CheckIconMui from "@mui/icons-material/Check";
import PhotoCameraIconMui from "@mui/icons-material/PhotoCamera";
import FlipCameraIosIconMui from "@mui/icons-material/FlipCameraIos";
import AccessAlarmIconMui from "@mui/icons-material/AccessAlarm";
import PresentToAllIconMui from "@mui/icons-material/PresentToAll";
import PriorityHighIconMui from "@mui/icons-material/PriorityHigh";
import PausePresentationIconMui from "@mui/icons-material/PausePresentation";
import SettingsIconMui from "@mui/icons-material/Settings";
import MagicIconMui from "@mui/icons-material/AutoFixHigh";
import TextBoxIconMui from "@mui/icons-material/Article";
import TextBoxOutlinedIconMui from "@mui/icons-material/ArticleOutlined";
import RefreshIconMui from "@mui/icons-material/Refresh";
import ErrorIconMui from "@mui/icons-material/Error";
import GetAppIconMui from "@mui/icons-material/GetApp";
import ExportIconMui from "@mui/icons-material/ExitToApp";
import DecagramCheckIcon from "@mui/icons-material/Verified";
import TuneRoundedIconMui from "@mui/icons-material/TuneRounded";
import { withTransientProps } from "./src/lib/emotion";

export type IconProps = {
  $active?: boolean;
  $small?: boolean;
  $medium?: boolean;
  $large?: boolean;
  height?: number;
  width?: number;
} & Pick<SVGAttributes<SVGElement>, "style">;

const base = ({ theme, $small, $large }: IconProps & { theme: Theme }) => css`
  width: ${theme.kinetic.iconSizes.medium.width};
  height: ${theme.kinetic.iconSizes.medium.height};

  ${$small &&
  css`
    width: ${theme.kinetic.iconSizes.small.width};
    height: ${theme.kinetic.iconSizes.small.height};
  `}
  ${$large &&
  css`
    width: ${theme.kinetic.iconSizes.large.width};
    height: ${theme.kinetic.iconSizes.large.height};
  `}
`;

// TODO: This file became pretty big. We should move these inline CSV to their own files.
export const BeakerIcon = styled(
  (props: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.8 18.4 14 10.67V6.5l1.35-1.69c.26-.33.03-.81-.39-.81H9.04c-.42 0-.65.48-.39.81L10 6.5v4.17L4.2 18.4c-.49.66-.02 1.6.8 1.6h14c.82 0 1.29-.94.8-1.6z" />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AccountCircleOutlineIcon = styled(
  AccountCircleOutlineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export function SettingSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.14 10.94C17.18 10.64 17.2 10.33 17.2 10C17.2 9.68 17.18 9.36 17.13 9.06L19.16 7.48C19.34 7.34 19.39 7.07 19.28 6.87L17.36 3.55C17.24 3.33 16.99 3.26 16.77 3.33L14.38 4.29C13.88 3.91 13.35 3.59 12.76 3.35L12.4 0.810001C12.36 0.570001 12.16 0.400002 11.92 0.400002H8.07999C7.83999 0.400002 7.64999 0.570001 7.60999 0.810001L7.24999 3.35C6.65999 3.59 6.11999 3.92 5.62999 4.29L3.23999 3.33C3.01999 3.25 2.76999 3.33 2.64999 3.55L0.739988 6.87C0.619988 7.08 0.659988 7.34 0.859988 7.48L2.88999 9.06C2.83999 9.36 2.79999 9.69 2.79999 10C2.79999 10.31 2.81999 10.64 2.86999 10.94L0.839988 12.52C0.659988 12.66 0.609988 12.93 0.719988 13.13L2.63999 16.45C2.75999 16.67 3.00999 16.74 3.22999 16.67L5.61999 15.71C6.11999 16.09 6.64999 16.41 7.23999 16.65L7.59999 19.19C7.64999 19.43 7.83999 19.6 8.07999 19.6H11.92C12.16 19.6 12.36 19.43 12.39 19.19L12.75 16.65C13.34 16.41 13.88 16.09 14.37 15.71L16.76 16.67C16.98 16.75 17.23 16.67 17.35 16.45L19.27 13.13C19.39 12.91 19.34 12.66 19.15 12.52L17.14 10.94ZM9.99999 13.6C8.01999 13.6 6.39999 11.98 6.39999 10C6.39999 8.02 8.01999 6.4 9.99999 6.4C11.98 6.4 13.6 8.02 13.6 10C13.6 11.98 11.98 13.6 9.99999 13.6Z"
        fill="#707070"
      />
    </svg>
  );
}

export function AiLargeIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="36"
      height="42"
      viewBox="0 0 36 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.941 8.15399L15.1455 11.499C16.4835 15.2115 19.407 18.135 23.1195 19.473L26.4645 20.6775C26.766 20.787 26.766 21.2145 26.4645 21.3225L23.1195 22.527C19.407 23.865 16.4835 26.7885 15.1455 30.501L13.941 33.846C13.8315 34.1475 13.404 34.1475 13.296 33.846L12.0915 30.501C10.7535 26.7885 7.83001 23.865 4.11751 22.527L0.772512 21.3225C0.471012 21.213 0.471012 20.7855 0.772512 20.6775L4.11751 19.473C7.83001 18.135 10.7535 15.2115 12.0915 11.499L13.296 8.15399C13.404 7.85099 13.8315 7.85099 13.941 8.15399Z"
        fill="#0C5CD4"
      />
      <path
        d="M28.9981 0.115494L29.6086 1.80899C30.2866 3.68849 31.7671 5.16899 33.6466 5.84699L35.3401 6.45749C35.4931 6.51299 35.4931 6.72899 35.3401 6.78449L33.6466 7.39499C31.7671 8.07299 30.2866 9.55349 29.6086 11.433L28.9981 13.1265C28.9426 13.2795 28.7266 13.2795 28.6711 13.1265L28.0606 11.433C27.3826 9.55349 25.9021 8.07299 24.0226 7.39499L22.3291 6.78449C22.1761 6.72899 22.1761 6.51299 22.3291 6.45749L24.0226 5.84699C25.9021 5.16899 27.3826 3.68849 28.0606 1.80899L28.6711 0.115494C28.7266 -0.0390065 28.9441 -0.0390065 28.9981 0.115494Z"
        fill="#0C5CD4"
      />
      <path
        d="M28.9981 28.875L29.6086 30.5685C30.2866 32.448 31.7671 33.9285 33.6466 34.6065L35.3401 35.217C35.4931 35.2725 35.4931 35.4885 35.3401 35.544L33.6466 36.1545C31.7671 36.8325 30.2866 38.313 29.6086 40.1925L28.9981 41.886C28.9426 42.039 28.7266 42.039 28.6711 41.886L28.0606 40.1925C27.3826 38.313 25.9021 36.8325 24.0226 36.1545L22.3291 35.544C22.1761 35.4885 22.1761 35.2725 22.3291 35.217L24.0226 34.6065C25.9021 33.9285 27.3826 32.448 28.0606 30.5685L28.6711 28.875C28.7266 28.722 28.9441 28.722 28.9981 28.875Z"
        fill="#0C5CD4"
      />
    </svg>
  );
}

export function ArchiveIconV2Svg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_546_6217"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect
          x="24"
          y="24"
          width="24"
          height="24"
          transform="rotate(-180 24 24)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_546_6217)">
        <path
          d="M13 8H11V12.15L9.4 10.575L7.975 12L12 16L16 12L14.575 10.6L13 12.175V8ZM20 4C20.55 4 21.0207 4.19567 21.412 4.587C21.804 4.979 22 5.45 22 6V18C22 18.55 21.804 19.0207 21.412 19.412C21.0207 19.804 20.55 20 20 20L4 20C3.45 20 2.979 19.804 2.587 19.412C2.19567 19.0207 2 18.55 2 18V6C2 5.45 2.19567 4.979 2.587 4.587C2.979 4.19567 3.45 4 4 4L20 4Z"
          fill="#555553"
        />
      </g>
    </svg>
  );
}

export function CoinSvg(props?: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.6001 7.99998C1.6001 4.46498 4.4651 1.59998 8.0001 1.59998C11.5351 1.59998 14.4001 4.46498 14.4001 7.99998C14.4001 11.535 11.5351 14.4 8.0001 14.4C4.4651 14.4 1.6001 11.535 1.6001 7.99998ZM8.0001 4.39998C9.9876 4.39998 11.6001 6.01248 11.6001 7.99998C11.6001 9.98748 9.9876 11.6 8.0001 11.6C6.0126 11.6 4.4001 9.98748 4.4001 7.99998C4.4001 6.01248 6.0126 4.39998 8.0001 4.39998ZM8.0001 12.8C10.6501 12.8 12.8001 10.65 12.8001 7.99998C12.8001 5.34998 10.6501 3.19998 8.0001 3.19998C5.3501 3.19998 3.2001 5.34998 3.2001 7.99998C3.2001 10.65 5.3501 12.8 8.0001 12.8ZM8.6001 6.79998C8.6001 6.46748 8.3326 6.19998 8.0001 6.19998C7.6676 6.19998 7.4001 6.46748 7.4001 6.79998V9.19998C7.4001 9.53248 7.6676 9.79998 8.0001 9.79998C8.3326 9.79998 8.6001 9.53248 8.6001 9.19998V6.79998Z"
        fill="#CEA623"
      />
    </svg>
  );
}

export function SynapsePortfolioSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.5 2.16667V13.8333C0.5 14.75 1.24167 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5H2.16667C1.24167 0.5 0.5 1.25 0.5 2.16667ZM10.5 5.5C10.5 6.88333 9.38333 8 8 8C6.61667 8 5.5 6.88333 5.5 5.5C5.5 4.11667 6.61667 3 8 3C9.38333 3 10.5 4.11667 10.5 5.5ZM3 12.1667C3 10.5 6.33333 9.58333 8 9.58333C9.66667 9.58333 13 10.5 13 12.1667V13H3V12.1667Z"
        fill="currentColor"
      />
    </svg>
  );
}
function NavBarFeedbackIconSvg({
  $active,
}: IconProps & SVGAttributes<SVGElement>) {
  return $active ? (
    <svg
      width="100%"
      height="100%"
      viewBox="-2 -3 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V2C20 0.9 19.1 0 18 0ZM8 14H3V12H8V14ZM8 10H3V8H8V10ZM8 6H3V4H8V6ZM12.82 12L10 9.16L11.41 7.75L12.82 9.17L15.99 6L17.41 7.42L12.82 12Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 19H4V5H20V19Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.41 10.42L17.99 9L14.82 12.17L13.41 10.75L12 12.16L14.82 15L19.41 10.42Z"
        fill="currentColor"
      />
      <path d="M10 7H5V9H10V7Z" fill="currentColor" />
      <path d="M10 11H5V13H10V11Z" fill="currentColor" />
      <path d="M10 15H5V17H10V15Z" fill="currentColor" />
    </svg>
  );
}
export function SettingsIcon(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6684 13.1434C20.7151 12.77 20.7501 12.3967 20.7501 12C20.7501 11.6034 20.7151 11.23 20.6684 10.8567L23.1301 8.93171C23.3517 8.75671 23.4101 8.44171 23.2701 8.18504L20.9367 4.14837C20.8317 3.96171 20.6334 3.85671 20.4234 3.85671C20.3534 3.85671 20.2834 3.86837 20.2251 3.89171L17.3201 5.05837C16.7134 4.59171 16.0601 4.20671 15.3484 3.91504L14.9051 0.823374C14.8701 0.543374 14.6251 0.333374 14.3334 0.333374H9.66672C9.37506 0.333374 9.13006 0.543374 9.09506 0.823374L8.65172 3.91504C7.94006 4.20671 7.28672 4.60337 6.68006 5.05837L3.77506 3.89171C3.70506 3.86837 3.63506 3.85671 3.56506 3.85671C3.36672 3.85671 3.16839 3.96171 3.06339 4.14837L0.730057 8.18504C0.57839 8.44171 0.64839 8.75671 0.870057 8.93171L3.33172 10.8567C3.28506 11.23 3.25006 11.615 3.25006 12C3.25006 12.385 3.28506 12.77 3.33172 13.1434L0.870057 15.0684C0.64839 15.2434 0.590057 15.5584 0.730057 15.815L3.06339 19.8517C3.16839 20.0384 3.36672 20.1434 3.57672 20.1434C3.64672 20.1434 3.71672 20.1317 3.77506 20.1084L6.68006 18.9417C7.28672 19.4084 7.94006 19.7934 8.65172 20.085L9.09506 23.1767C9.13006 23.4567 9.37506 23.6667 9.66672 23.6667H14.3334C14.6251 23.6667 14.8701 23.4567 14.9051 23.1767L15.3484 20.085C16.0601 19.7934 16.7134 19.3967 17.3201 18.9417L20.2251 20.1084C20.2951 20.1317 20.3651 20.1434 20.4351 20.1434C20.6334 20.1434 20.8317 20.0384 20.9367 19.8517L23.2701 15.815C23.4101 15.5584 23.3517 15.2434 23.1301 15.0684L20.6684 13.1434ZM18.3584 11.1484C18.4051 11.51 18.4167 11.755 18.4167 12C18.4167 12.245 18.3934 12.5017 18.3584 12.8517L18.1951 14.17L19.2334 14.9867L20.4934 15.9667L19.6767 17.3784L18.1951 16.7834L16.9817 16.2934L15.9317 17.0867C15.4301 17.46 14.9517 17.74 14.4734 17.9384L13.2367 18.44L13.0501 19.7584L12.8167 21.3334H11.1834L10.9617 19.7584L10.7751 18.44L9.53839 17.9384C9.03672 17.7284 8.57006 17.46 8.10339 17.11L7.04172 16.2934L5.80506 16.795L4.32339 17.39L3.50672 15.9784L4.76672 14.9984L5.80506 14.1817L5.64172 12.8634C5.60672 12.5017 5.58339 12.2334 5.58339 12C5.58339 11.7667 5.60672 11.4984 5.64172 11.1484L5.80506 9.83004L4.76672 9.01337L3.50672 8.03337L4.32339 6.62171L5.80506 7.21671L7.01839 7.70671L8.06839 6.91337C8.57006 6.54004 9.04839 6.26004 9.52672 6.06171L10.7634 5.56004L10.9501 4.24171L11.1834 2.66671H12.8051L13.0267 4.24171L13.2134 5.56004L14.4501 6.06171C14.9517 6.27171 15.4184 6.54004 15.8851 6.89004L16.9467 7.70671L18.1834 7.20504L19.6651 6.61004L20.4817 8.02171L19.2334 9.01337L18.1951 9.83004L18.3584 11.1484ZM12.0001 7.33337C9.42172 7.33337 7.33339 9.42171 7.33339 12C7.33339 14.5784 9.42172 16.6667 12.0001 16.6667C14.5784 16.6667 16.6667 14.5784 16.6667 12C16.6667 9.42171 14.5784 7.33337 12.0001 7.33337ZM12.0001 14.3334C10.7167 14.3334 9.66672 13.2834 9.66672 12C9.66672 10.7167 10.7167 9.66671 12.0001 9.66671C13.2834 9.66671 14.3334 10.7167 14.3334 12C14.3334 13.2834 13.2834 14.3334 12.0001 14.3334Z"
        fill="#606366"
      />
    </svg>
  );
}

export function LeaderBoardIcon(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6666 9.83333V0.5H7.33325V7.5H0.333252V21.5H23.6666V9.83333H16.6666ZM9.66659 2.83333H14.3333V19.1667H9.66659V2.83333ZM2.66659 9.83333H7.33325V19.1667H2.66659V9.83333ZM21.3333 19.1667H16.6666V12.1667H21.3333V19.1667Z"
        fill="#606366"
      />
    </svg>
  );
}

export function LearnerSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM12 8C13.66 8 15 6.66 15 5C15 3.34 13.66 2 12 2C10.34 2 9 3.34 9 5C9 6.66 10.34 8 12 8Z" />
    </svg>
  );
}

export function LearnerOutlineSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 9C14.21 9 16 7.21 16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9ZM12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5C10 3.9 10.9 3 12 3ZM12 11.55C9.64 9.35 6.48 8 3 8V19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55ZM19 17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.17C7.1 10.55 9.05 11.52 10.64 13L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13Z" />
    </svg>
  );
}

export function RepSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M18 1H6C4.9 1 4 1.9 4 3V21C4 22.1 4.9 23 6 23H18C19.1 23 20 22.1 20 21V3C20 1.9 19.1 1 18 1ZM18 15.21C16.5 14.44 13.8 14 12 14C10.2 14 7.5 14.44 6 15.21V3H18V15.21Z" />
      <path d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" />
    </svg>
  );
}

export function RepSvgNew({ $active }: IconProps) {
  if ($active) {
    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 2V18C18.7738 18 20 18.1208 20 17V3C20 1.87923 18.7738 2 18 2Z"
          fill="#e50063"
        />
        <path
          d="M24 5V15C24 16.1208 22.7738 16 22 16V4C22.7738 4 24 3.87923 24 5Z"
          fill="#e50063"
        />
        <path
          d="M14 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM14 13.21C12.5 12.44 9.8 12 8 12C6.2 12 3.5 12.44 2 13.21V3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V13.21Z"
          fill="#e50063"
        />
        <path
          d="M8 10C9.65685 10 11 8.65685 11 7C11 5.34315 9.65685 4 8 4C6.34315 4 5 5.34315 5 7C5 8.65685 6.34315 10 8 10Z"
          fill="#e50063"
        />
      </svg>
    );
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1208_4087)">
        <path
          d="M18 4V20C18.7742 20 20 20.119 20 19V5C20 3.87923 18.7738 4 18 4Z"
          fill="#959592"
        />
        <path
          d="M24 7V17C24 18.1208 22.7738 18 22 18V6C22.7738 6 24 5.87923 24 7Z"
          fill="#959592"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2H14C15.1 2 16 2.9 16 4V20C16 21.1 15.1 22 14 22H2C0.9 22 0 21.1 0 20V4C0 2.9 0.9 2 2 2ZM8 14C9.8 14 12.5 14.44 14 15.21V5C14 4.44772 13.5523 4 13 4H3C2.44772 4 2 4.44772 2 5V15.21C3.5 14.44 6.2 14 8 14ZM8 16C3.5 16 2 17.5 2 17.5V19C2 19.5523 2.44772 20 3 20H13C13.5523 20 14 19.5523 14 19V17.5C14 17.5 12.5 16 8 16Z"
          fill="#959592"
        />
        <path
          d="M8 12.5C9.93375 12.5 11.5 10.9338 11.5 9C11.5 7.06625 9.93375 5.5 8 5.5C6.06625 5.5 4.5 7.06625 4.5 9C4.5 10.9338 6.06625 12.5 8 12.5ZM8 7.25C8.9625 7.25 9.75 8.0375 9.75 9C9.75 9.9625 8.9625 10.75 8 10.75C7.0375 10.75 6.25 9.9625 6.25 9C6.25 8.0375 7.0375 7.25 8 7.25Z"
          fill="#959592"
        />
      </g>
      <defs>
        <clipPath id="clip0_1208_4087">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CoachIconSvg({ $active }: IconProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8334 0.833496H14.1667V17.1668H11.8334V0.833496ZM4.83342 9.00016C6.11675 9.00016 7.16675 7.95016 7.16675 6.66683C7.16675 5.3835 6.11675 4.3335 4.83342 4.3335C3.55008 4.3335 2.50008 5.3835 2.50008 6.66683C2.50008 7.95016 3.55008 9.00016 4.83342 9.00016ZM8.07675 10.8435C7.08508 10.4118 5.98842 10.1668 4.83342 10.1668C3.67842 10.1668 2.58175 10.4118 1.59008 10.8435C0.726748 11.2168 0.166748 12.0568 0.166748 13.0018V13.6668H9.50008V13.0018C9.50008 12.0568 8.94008 11.2168 8.07675 10.8435ZM21.1667 9.00016C22.4501 9.00016 23.5001 7.95016 23.5001 6.66683C23.5001 5.3835 22.4501 4.3335 21.1667 4.3335C19.8834 4.3335 18.8334 5.3835 18.8334 6.66683C18.8334 7.95016 19.8834 9.00016 21.1667 9.00016ZM24.4101 10.8435C23.4184 10.4118 22.3217 10.1668 21.1667 10.1668C20.0117 10.1668 18.9151 10.4118 17.9234 10.8435C17.0601 11.2168 16.5001 12.0568 16.5001 13.0018V13.6668H25.8334V13.0018C25.8334 12.0568 25.2734 11.2168 24.4101 10.8435Z"
        // fill='#959592'
        fill={$active ? "#e50063" : "#959592"}
      />
    </svg>
  );
}

export function NewIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="32"
      height="18"
      viewBox="0 0 32 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7979_2503)">
        <rect x="2" y="2" width="28" height="14" rx="3" fill="#FF37C7" />
        <path
          d="M5.95867 12V5.65869H6.94305L10.0588 10.0269H10.1291V5.65869H11.2189V12H10.2389L7.12322 7.63184H7.05291V12H5.95867ZM12.9678 12V5.65869H17.0723V6.6123H14.1016V8.33057H16.9097V9.23145H14.1016V11.0464H17.0723V12H12.9678ZM19.9637 12L18.263 5.65869H19.4451L20.5306 10.418H20.5965L21.8446 5.65869H22.8509L24.1165 10.418H24.178L25.2635 5.65869H26.4368L24.7362 12H23.6727L22.3807 7.46045H22.3148L21.0316 12H19.9637Z"
          fill="white"
        />
      </g>
      <rect
        x="1"
        y="1"
        width="30"
        height="16"
        rx="4"
        stroke="white"
        strokeWidth="2"
      />
      <defs>
        <clipPath id="clip0_7979_2503">
          <rect x="2" y="2" width="28" height="14" rx="3" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CheckShieldIconMui(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Action/Mentor approved" clipPath="url(#clip0_2389_502)">
        <path
          id="Vector"
          d="M19 1H5C3.9 1 3.01 1.9 3.01 3L3 15.93C3 16.62 3.35 17.23 3.88 17.59L12 23L20.11 17.59C20.64 17.23 20.99 16.62 20.99 15.93L21 3C21 1.9 20.1 1 19 1ZM10 16L5 11L6.41 9.59L10 13.17L17.59 5.58L19 7L10 16Z"
          fill="#20B107"
        />
      </g>
      <defs>
        <clipPath id="clip0_2389_502">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PortfolioSvg({ $active }: IconProps) {
  return $active ? (
    <svg
      width="100%"
      height="100%"
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 4H14V2C14 0.89 13.11 0 12 0H8C6.89 0 6 0.89 6 2V4H2C0.89 4 0.00999999 4.89 0.00999999 6L0 17C0 18.11 0.89 19 2 19H18C19.11 19 20 18.11 20 17V6C20 4.89 19.11 4 18 4ZM12 4H8V2H12V4Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      width="100%"
      height="100%"
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 4V2H8V4H12ZM2 6V17H18V6H2ZM18 4C19.11 4 20 4.89 20 6V17C20 18.11 19.11 19 18 19H2C0.89 19 0 18.11 0 17L0.00999999 6C0.00999999 4.89 0.89 4 2 4H6V2C6 0.89 6.89 0 8 0H12C13.11 0 14 0.89 14 2V4H18Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CommunitySvg({ $active }: IconProps) {
  return $active ? (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_309_8960"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_309_8960)">
        <path
          d="M0 18V16.425C0 15.6917 0.371 15.104 1.113 14.662C1.85433 14.2207 2.81667 14 4 14C4.21667 14 4.425 14.004 4.625 14.012C4.825 14.0207 5.01667 14.0417 5.2 14.075C4.96667 14.4083 4.79167 14.7667 4.675 15.15C4.55833 15.5333 4.5 15.9417 4.5 16.375V18H0ZM6 18V16.375C6 15.2917 6.55433 14.4167 7.663 13.75C8.771 13.0833 10.2167 12.75 12 12.75C13.8 12.75 15.25 13.0833 16.35 13.75C17.45 14.4167 18 15.2917 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4457 15.5333 19.337 15.15C19.229 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.221 14.0207 19.413 14.012C19.6043 14.004 19.8 14 20 14C21.2 14 22.1667 14.2207 22.9 14.662C23.6333 15.104 24 15.6917 24 16.425V18H19.5ZM4 13C3.45 13 2.97933 12.804 2.588 12.412C2.196 12.0207 2 11.55 2 11C2 10.4333 2.196 9.95833 2.588 9.575C2.97933 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0207 5.425 12.412C5.04167 12.804 4.56667 13 4 13ZM20 13C19.45 13 18.979 12.804 18.587 12.412C18.1957 12.0207 18 11.55 18 11C18 10.4333 18.1957 9.95833 18.587 9.575C18.979 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0207 21.425 12.412C21.0417 12.804 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.43733 9.875 6.862C10.4583 6.28733 11.1667 6 12 6C12.85 6 13.5623 6.28733 14.137 6.862C14.7123 7.43733 15 8.15 15 9C15 9.83333 14.7123 10.5417 14.137 11.125C13.5623 11.7083 12.85 12 12 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ) : (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_309_8960"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_309_8960)">
        <path
          d="M0 18V16.425C0 15.6917 0.371 15.104 1.113 14.662C1.85433 14.2207 2.81667 14 4 14C4.21667 14 4.425 14.004 4.625 14.012C4.825 14.0207 5.01667 14.0417 5.2 14.075C4.96667 14.4083 4.79167 14.7667 4.675 15.15C4.55833 15.5333 4.5 15.9417 4.5 16.375V18H0ZM6 18V16.375C6 15.2917 6.55433 14.4167 7.663 13.75C8.771 13.0833 10.2167 12.75 12 12.75C13.8 12.75 15.25 13.0833 16.35 13.75C17.45 14.4167 18 15.2917 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4457 15.5333 19.337 15.15C19.229 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.221 14.0207 19.413 14.012C19.6043 14.004 19.8 14 20 14C21.2 14 22.1667 14.2207 22.9 14.662C23.6333 15.104 24 15.6917 24 16.425V18H19.5ZM4 13C3.45 13 2.97933 12.804 2.588 12.412C2.196 12.0207 2 11.55 2 11C2 10.4333 2.196 9.95833 2.588 9.575C2.97933 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0207 5.425 12.412C5.04167 12.804 4.56667 13 4 13ZM20 13C19.45 13 18.979 12.804 18.587 12.412C18.1957 12.0207 18 11.55 18 11C18 10.4333 18.1957 9.95833 18.587 9.575C18.979 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0207 21.425 12.412C21.0417 12.804 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.43733 9.875 6.862C10.4583 6.28733 11.1667 6 12 6C12.85 6 13.5623 6.28733 14.137 6.862C14.7123 7.43733 15 8.15 15 9C15 9.83333 14.7123 10.5417 14.137 11.125C13.5623 11.7083 12.85 12 12 12Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export function SearchSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="-4 -4 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </svg>
  );
}

export function HomeSvg({ $active }: IconProps & SVGAttributes<SVGElement>) {
  return $active ? (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_59_552)">
        <path
          d="M14.0001 3.5L4.66675 10.5V24.5H11.6667V16.9167H16.3334V24.5H23.3334V10.5L14.0001 3.5Z"
          fill="#E50063"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_552">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ) : (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_59_551)">
        <path
          d="M14.0001 3.5L4.66675 10.5V24.5H11.6667V16.9167H16.3334V24.5H23.3334V10.5L14.0001 3.5Z"
          fill="#555553"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_551">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CreateSvg({ $active }: IconProps & SVGAttributes<SVGElement>) {
  return $active ? (
    <svg
      width="100%"
      height="100%"
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM15 11H11V15H9V11H5V9H9V5H11V9H15V11Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      width="100%"
      height="100%"
      viewBox="-2 -2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function RepOutlineSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 1H18C19.1 1 20 1.9 20 3V21C20 22.1 19.1 23 18 23H6C4.9 23 4 22.1 4 21V3C4 1.9 4.9 1 6 1ZM12 14C13.8 14 16.5 14.44 18 15.21V3H6V15.21C7.5 14.44 10.2 14 12 14ZM12 16C7.5 16 6 17.5 6 17.5V21H18V17.5C18 17.5 16.5 16 12 16Z"
      />
      <path d="M12 13C14.21 13 16 11.21 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9C8 11.21 9.79 13 12 13ZM12 7C13.1 7 14 7.9 14 9C14 10.1 13.1 11 12 11C10.9 11 10 10.1 10 9C10 7.9 10.9 7 12 7Z" />
    </svg>
  );
}

export function BigSpringBaseSvg({
  wordMark = false,
  ...props
}: {
  wordMark?: boolean;
}) {
  const id = useId();

  const { blue, blueDarker, fluoro, fluoroLight } =
    theme.kinetic.v2.palette.rgb;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${wordMark ? 204 : 34} 40`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {wordMark && (
        <path
          d="M186.415 35.1l3.651-2.473a6.593 6.593 0 001.969 2.417 4.845 4.845 0 002.821.759 4.601 4.601 0 003.075-.979 3.881 3.881 0 001.106-3.12V29.23h-.077a4.605 4.605 0 01-1.958 1.714 6.453 6.453 0 01-3.02.726 8.566 8.566 0 01-3.524-.689 8.512 8.512 0 01-2.926-2.07 10.636 10.636 0 01-2.599-7.593 10.448 10.448 0 012.677-7.55 8.452 8.452 0 012.847-2.062 8.5 8.5 0 013.447-.729 6.278 6.278 0 012.949.569 6.235 6.235 0 012.339 1.87h.066v-1.9h4.724V31.11a8.382 8.382 0 01-.546 3.574 8.45 8.45 0 01-1.998 3.02 9.466 9.466 0 01-6.582 2.285 10.009 10.009 0 01-5.255-1.34 7.819 7.819 0 01-3.142-3.55h-.044zm12.677-11.781v-4.044a3.828 3.828 0 00-1.172-2.835 4.23 4.23 0 00-3.131-1.165 4.429 4.429 0 00-3.562 1.56 6.566 6.566 0 00-1.361 4.484 6.57 6.57 0 001.383 4.483 4.55 4.55 0 003.54 1.56 4.24 4.24 0 003.131-1.175 3.855 3.855 0 001.172-2.868zm-33.928 7.802V11.517h4.702v1.89h.077a6.396 6.396 0 012.213-1.737 6.672 6.672 0 013.009-.703 6.878 6.878 0 012.801.427 6.839 6.839 0 012.387 1.518 7.394 7.394 0 011.88 5.374V31.12h-4.801V19.473a4.964 4.964 0 00-.785-3.044 3.212 3.212 0 00-2.71-1.011 3.828 3.828 0 00-2.821 1.01 3.69 3.69 0 00-1.007 2.715v11.978h-4.945zm-9.226-22.56h4.901V4h-4.879l-.022 4.56zm0 22.56h4.901V11.517h-4.879l-.022 19.604zm-12.766 0v-19.78h4.624v2.088h.078a4.404 4.404 0 011.67-1.792 4.514 4.514 0 012.423-.67 4.45 4.45 0 011.792.374l-.741 4.703a4.664 4.664 0 00-1.549-.308c-2.272 0-3.407 1.506-3.407 4.517V31.11l-4.89.011zm-21.981 8.319V11.517h4.668v1.879h.078l.188-.275c.175-.21.372-.401.586-.572a8.06 8.06 0 011.04-.747c.48-.262.994-.458 1.527-.582a7.79 7.79 0 012.057-.264 8.327 8.327 0 013.399.735 8.282 8.282 0 012.796 2.056 10.514 10.514 0 012.666 7.56 10.746 10.746 0 01-2.588 7.594 8.129 8.129 0 01-2.806 2.071 8.18 8.18 0 01-3.422.71 7.37 7.37 0 01-2.014-.264 6.235 6.235 0 01-1.493-.605 9.747 9.747 0 01-.974-.703 4.437 4.437 0 01-.608-.615l-.144-.253h-.077V39.44h-4.879zm4.89-20.165v4.044a3.855 3.855 0 001.172 2.868 4.23 4.23 0 003.131 1.176 4.55 4.55 0 003.54-1.56 6.57 6.57 0 001.383-4.484 6.56 6.56 0 00-1.361-4.484 4.429 4.429 0 00-3.562-1.56 4.232 4.232 0 00-3.131 1.165 3.845 3.845 0 00-1.172 2.835zm-27.424 3.132l5.299-1.154a9.494 9.494 0 001.593 4.395A4.452 4.452 0 00109.155 27a6.604 6.604 0 003.396-.758 2.487 2.487 0 001.261-2.253 2.717 2.717 0 00-.287-1.354 2.738 2.738 0 00-.918-1.041 24.424 24.424 0 00-5.532-2.198 13.18 13.18 0 01-5.774-3.066 6.23 6.23 0 01-1.693-4.396 6.836 6.836 0 012.368-5.22 9.208 9.208 0 016.438-2.198c2.256-.06 4.478.562 6.372 1.78a7.865 7.865 0 013.319 5.308l-4.835 1.253a5.183 5.183 0 00-1.179-2.042 5.24 5.24 0 00-4.315-1.635 5.253 5.253 0 00-2.249.743 2.394 2.394 0 00-.952 1.967 1.957 1.957 0 001.107 1.77l.143.076a43.777 43.777 0 004.425 1.704l1.029.351a15 15 0 015.941 3.21 6.567 6.567 0 011.582 4.67 7.268 7.268 0 01-2.611 5.714 10.266 10.266 0 01-6.98 2.275c-2.603.119-5.16-.71-7.191-2.33a10.27 10.27 0 01-3.319-6.923h-.044zM78.38 35.099l3.65-2.472a6.602 6.602 0 001.958 2.417 4.87 4.87 0 002.832.759 4.623 4.623 0 003.076-.979 3.898 3.898 0 001.106-3.12V29.23h-.078a4.604 4.604 0 01-1.958 1.714 6.451 6.451 0 01-3.02.726 8.546 8.546 0 01-3.525-.687 8.495 8.495 0 01-2.924-2.072 10.593 10.593 0 01-2.6-7.593 10.452 10.452 0 012.677-7.55 8.427 8.427 0 012.847-2.064 8.478 8.478 0 013.448-.727 6.23 6.23 0 012.945.566 6.186 6.186 0 012.332 1.874h.077v-1.901h4.68V31.11a8.4 8.4 0 01-.546 3.574 8.446 8.446 0 01-1.999 3.02 9.475 9.475 0 01-6.637 2.285 9.92 9.92 0 01-5.3-1.33 7.819 7.819 0 01-3.14-3.549l.099-.01zm12.677-11.78v-4.044a3.834 3.834 0 00-1.172-2.835 4.229 4.229 0 00-3.164-1.165 4.45 4.45 0 00-3.551 1.56 6.563 6.563 0 00-1.361 4.484 6.564 6.564 0 001.405 4.483 4.527 4.527 0 003.507 1.56 4.262 4.262 0 003.141-1.175 3.877 3.877 0 001.173-2.868h.022zM69.021 8.56h4.89V4h-4.89v4.56zm0 22.561h4.89V11.517h-4.89V31.12zM51.155 15.54h5.41a3.656 3.656 0 002.4-.726 2.67 2.67 0 00.874-2.197 2.873 2.873 0 00-.852-2.198 3.601 3.601 0 00-2.422-.748h-5.41v5.869zm0 10.747h6.15c2.412 0 3.618-1.14 3.618-3.418a3.124 3.124 0 00-.962-2.44 3.8 3.8 0 00-2.622-.856h-6.184v6.714zM46 31.12V5.077h11.118a7.79 7.79 0 013.01.463c.963.35 1.846.888 2.598 1.58a6.657 6.657 0 011.585 2.263c.364.855.544 1.777.528 2.705a5.367 5.367 0 01-.717 2.863 5.414 5.414 0 01-2.126 2.06 6.286 6.286 0 012.755 2.253 6.355 6.355 0 011.106 3.703 7.898 7.898 0 01-.546 3.243 7.94 7.94 0 01-1.821 2.746c-1.52 1.466-4.027 2.198-7.523 2.198L46 31.121z"
          fill={blueDarker}
        />
      )}
      <path
        d="M7.66778 12.4469C3.3864 11.1108 0 11.2071 0 5.3691V0.000534279H18.9759C20.7258 -0.0106801 22.4723 0.154673 24.1886 0.494057C25.6523 0.771508 27.0485 1.32734 28.3006 2.13111C29.4274 2.88561 30.333 3.92399 30.9251 5.14039C31.5855 6.59462 31.904 8.17955 31.8564 9.77469C31.9291 11.5399 31.4426 13.2831 30.4655 14.7581C29.5661 16.0969 28.0799 17.3879 26.6074 18.0557"
        fill={blue}
      />
      <path
        d="M26.8614 17.8877C28.9054 18.9159 30.7069 20.3642 32.1466 22.1368C33.3911 23.9503 34.0378 26.1042 33.9971 28.2998C34.0394 30.1376 33.6239 31.9572 32.7876 33.5962C32.0238 35.0369 30.9249 36.2751 29.5826 37.2073C28.1845 38.1763 26.6242 38.8896 24.9747 39.3138C23.2386 39.7729 21.4496 40.0036 19.6532 39.9999H0V18.0562C0 13.9034 3.13242 12.0377 7.76454 12.5312C14.3364 13.4858 20.7558 15.2863 26.8614 17.8877Z"
        fill={`url(#bsp_mark_gradient-${id})`}
      />
      <defs>
        <linearGradient
          id={`bsp_mark_gradient-${id}`}
          x1="17"
          y1="12.4537"
          x2="17"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={fluoroLight} />
          <stop offset="1" stopColor={fluoro} />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function BigSpringBaseV2Svg({ ...props }) {
  return (
    <svg
      width="626"
      height="205"
      viewBox="0 0 626 205"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M578 203.1H418.4V176.2H578.3C587.6 176.2 596.1 168.7 596.5 159.4C597 149.3 588.9 140.9 578.9 140.9H538.7C514.3 140.9 493.8 121.7 493.3 97.4C492.7 72.4 512.9 51.8 537.8 51.8H607.7V78.7H538.4C529.1 78.7 520.6 86.2 520.2 95.5C519.7 105.6 527.8 114 537.8 114H578.9C603.8 114 624 134.5 623.4 159.6C622.8 184.7 602.3 203.1 578 203.1Z"
        fill="black"
      />
      <path
        d="M378.8 203.1H351.9V136.3C351.9 124 361.9 114.1 374.1 114.1H432.4C441.8 114.1 450 107 450.6 97.7C451.3 87.4 443.1 78.9 433 78.9H351.8V52H432C456.9 52 478 72.4 477.5 97.3C477.1 121.5 457.3 141.1 433 141.1H378.7V203.3L378.8 203.1Z"
        fill="black"
      />
      <path
        d="M222.9 97.6C223.5 107 231.7 114 241.1 114H318.5V140.9H241.1C231.7 140.9 223.5 148 222.9 157.4C222.2 167.7 230.4 176.2 240.5 176.2H325.5V203.1H240.5C215.9 203.1 196 183.1 196 158.6C196 134.1 200.8 135.6 208.7 127.5C200.7 119.2 195.8 107.9 196 95.4C196.5 71 217.1 51.8 241.5 51.8H325.5V78.7H240.5C230.4 78.7 222.2 87.3 222.9 97.6Z"
        fill="black"
      />
      <path
        d="M180.7 175.6V202.5H148.6C127.7 202.5 107.8 193.4 94 177.6L48.6 125.5C42.7 118.7 31.2 122.6 31.1 131.6C31.1 131.6 31.1 131.7 31.1 131.8V203.1H4.20001V131.8C4.20001 109.7 22.1 91.8 44.2 91.8H118.8C133.7 91.8 146.8 80.9 148.5 66.1C150.5 48.6 136.8 33.7 119.6 33.7H49.5C51.4 29.6 52.4 25 52.4 20.2C52.4 15.4 51.4 10.9 49.5 6.89999V6.79999C51.8 6.79999 91.3 6.79999 118.5 6.79999C146.9 6.79999 171.7 27.6 175.1 55.8C179.2 89.7 152.7 118.7 119.6 118.7H78.5L114.5 160C123.1 169.9 135.6 175.6 148.8 175.6H180.9H180.7Z"
        fill="black"
      />
      <path
        d="M38.8 19.4C38.8 24.4 36.9 29 33.8 32.5C30.2 36.4 25.1 38.9 19.4 38.9C13.7 38.9 8.6 36.4 5 32.5C1.9 29.1 0 24.5 0 19.4C0 14.3 1.90004 9.80002 5.10004 6.30002C8.60004 2.40002 13.8 0 19.4 0C25 0 30.2 2.40002 33.8 6.30002C37 9.70002 38.9 14.3 38.9 19.4H38.8Z"
        fill="#E50063"
      />
    </svg>
  );
}

export function RepsLogoBaseSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="256"
      height="256"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M218.1 201.7V228.6H186C165.1 228.6 145.2 219.5 131.4 203.7L86 151.6C80.1 144.8 68.6 148.7 68.5 157.7C68.5 157.7 68.5 157.8 68.5 157.9V229.2H41.6V157.9C41.6 135.8 59.5 117.9 81.6 117.9H156.2C171.1 117.9 184.2 107 185.9 92.2C187.9 74.7 174.2 59.8 157 59.8H86.9C88.8 55.7 89.8 51.1 89.8 46.3C89.8 41.5 88.8 37 86.9 33V32.9C89.2 32.9 128.7 32.9 155.9 32.9C184.3 32.9 209.1 53.7 212.5 81.9C216.6 115.8 190.1 144.8 157 144.8H115.9L151.9 186.1C160.5 196 173 201.7 186.2 201.7H218.3H218.1Z"
        fill="black"
      />
      <path
        d="M76.8 46.4C76.8 51.4 74.9 56 71.8 59.5C68.2 63.4 63.1 65.9 57.4 65.9C51.7 65.9 46.6 63.4 43 59.5C39.9 56.1 38 51.5 38 46.4C38 41.3 39.9 36.8 43.1 33.3C46.6 29.4 51.8 27 57.4 27C63 27 68.2 29.4 71.8 33.3C75 36.7 76.9 41.3 76.9 46.4H76.8Z"
        fill="#E50063"
      />
    </svg>
  );
}

export function FeedbackIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM4 7H16V9H4V7ZM12 12H4V10H12V12ZM16 6H4V4H16V6Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function FeedbackIconOutlineSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.33333 2.14616H15.6667V12.1462H3.30833L2.33333 13.1212V2.14616ZM2.33333 0.479492C1.41667 0.479492 0.675001 1.22949 0.675001 2.14616L0.666668 17.1462L4 13.8128H15.6667C16.5833 13.8128 17.3333 13.0628 17.3333 12.1462V2.14616C17.3333 1.22949 16.5833 0.479492 15.6667 0.479492H2.33333ZM4 8.81283H10.6667V10.4795H4V8.81283ZM4 6.31283H14V7.97949H4V6.31283ZM4 3.81283H14V5.47949H4V3.81283Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function VerifiedBadge({
  color,
}: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6667 0.666504H1.33333C0.6 0.666504 0.00666666 1.2665 0.00666666 1.99984L0 10.6198C0 11.0798 0.233333 11.4865 0.586667 11.7265L6 15.3332L11.4067 11.7265C11.76 11.4865 11.9933 11.0798 11.9933 10.6198L12 1.99984C12 1.2665 11.4 0.666504 10.6667 0.666504ZM4.66667 10.6665L1.33333 7.33317L2.27333 6.39317L4.66667 8.77984L9.72667 3.71984L10.6667 4.6665L4.66667 10.6665Z"
        fill={color}
      />
    </svg>
  );
}

export function ProfileBoxIconMui(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="2 2 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Primary navigation/Profile" clipPath="url(#clip0_2389_445)">
        <g id="Vector">
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM18.36 16.83C16.93 15.09 14.5 14 12 14C9.5 14 7.07 15.09 5.64 16.83C4.62 15.49 4 13.82 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 13.82 19.38 15.49 18.36 16.83Z"
            fill="#e50063"
          />
          <path
            d="M9 10C9 8.33714 10.3371 7 12 7C13.6629 7 15 8.33714 15 10C15 11.6629 13.6629 13 12 13C10.3371 13 9 11.6629 9 10Z"
            fill="#e50063"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2389_445">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ImageRepOutlineSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.6667 3.33366H14.0251L12.5001 1.66699H7.50008L5.97508 3.33366H3.33341C2.41675 3.33366 1.66675 4.08366 1.66675 5.00033V15.0003C1.66675 15.917 2.41675 16.667 3.33341 16.667H16.6667C17.5834 16.667 18.3334 15.917 18.3334 15.0003V5.00033C18.3334 4.08366 17.5834 3.33366 16.6667 3.33366ZM16.6667 15.0003H3.33341V5.00033H6.70842L8.23342 3.33366H11.7667L13.2917 5.00033H16.6667V15.0003ZM10.0001 5.83366C7.70008 5.83366 5.83342 7.70033 5.83342 10.0003C5.83342 12.3003 7.70008 14.167 10.0001 14.167C12.3001 14.167 14.1667 12.3003 14.1667 10.0003C14.1667 7.70033 12.3001 5.83366 10.0001 5.83366ZM10.0001 12.5003C8.62508 12.5003 7.50008 11.3753 7.50008 10.0003C7.50008 8.62532 8.62508 7.50033 10.0001 7.50033C11.3751 7.50033 12.5001 8.62532 12.5001 10.0003C12.5001 11.3753 11.3751 12.5003 10.0001 12.5003Z"
        fill="currentColor"
      />
    </svg>
  );
}

function VideoRepOutlineSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 6.66667V13.3333H4.16667V6.66667H12.5ZM13.3333 5H3.33333C2.875 5 2.5 5.375 2.5 5.83333V14.1667C2.5 14.625 2.875 15 3.33333 15H13.3333C13.7917 15 14.1667 14.625 14.1667 14.1667V11.25L17.5 14.5833V5.41667L14.1667 8.75V5.83333C14.1667 5.375 13.7917 5 13.3333 5Z"
        fill="currentColor"
      />
    </svg>
  );
}

function ApprovedIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="22"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14.93C0 15.62 0.35 16.23 0.88 16.59L9 22L17.11 16.59C17.64 16.23 17.99 15.62 17.99 14.93L18 2C18 0.9 17.1 0 16 0ZM7 15L2 10L3.41 8.59L7 12.17L14.59 4.58L16 6L7 15Z"
        fill="#3DA628"
      />
    </svg>
  );
}

function ApprovedOutlinedIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 -8 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_780_4980"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_780_4980)">
        <path
          d="M8.6 22.5L6.7 19.3L3.1 18.5L3.45 14.8L1 12L3.45 9.2L3.1 5.5L6.7 4.7L8.6 1.5L12 2.95L15.4 1.5L17.3 4.7L20.9 5.5L20.55 9.2L23 12L20.55 14.8L20.9 18.5L17.3 19.3L15.4 22.5L12 21.05L8.6 22.5ZM9.45 19.95L12 18.85L14.6 19.95L16 17.55L18.75 16.9L18.5 14.1L20.35 12L18.5 9.85L18.75 7.05L16 6.45L14.55 4.05L12 5.15L9.4 4.05L8 6.45L5.25 7.05L5.5 9.85L3.65 12L5.5 14.1L5.25 16.95L8 17.55L9.45 19.95ZM10.95 15.55L16.6 9.9L15.2 8.45L10.95 12.7L8.8 10.6L7.4 12L10.95 15.55Z"
          fill="#313130"
        />
      </g>
    </svg>
  );
}

function ToolTipSvg({ width, height }: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill="#606366"
      />
    </svg>
  );
}

function BlueAddIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99996 0.666748C4.39996 0.666748 0.666626 4.40008 0.666626 9.00008C0.666626 13.6001 4.39996 17.3334 8.99996 17.3334C13.6 17.3334 17.3333 13.6001 17.3333 9.00008C17.3333 4.40008 13.6 0.666748 8.99996 0.666748ZM13.1666 9.83342H9.83329V13.1667H8.16663V9.83342H4.83329V8.16675H8.16663V4.83342H9.83329V8.16675H13.1666V9.83342Z"
        fill="#0C5CD4"
      />
    </svg>
  );
}

function MoreHorizontalDotsSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="16"
      height="4"
      viewBox="0 0 16 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM14 0C12.9 0 12 0.9 12 2C12 3.1 12.9 4 14 4C15.1 4 16 3.1 16 2C16 0.9 15.1 0 14 0ZM8 0C6.9 0 6 0.9 6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0Z"
        fill="#606366"
      />
    </svg>
  );
}

function ClockSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C4.5 0 0 4.5 0 10C0 15.5 4.5 20 10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM14.2 14.2L9 11V5H10.5V10.2L15 12.9L14.2 14.2Z"
        fill="#606366"
      />
    </svg>
  );
}

function ClockOutlinedSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="-6 -8 28 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_780_4971)">
        <path
          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
          fill="#313130"
        />
        <path
          d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_780_4971">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function NoPracticeSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.1345 8.15472C1.56692 8.15472 1.92552 7.82776 2.02044 7.40589C2.20677 6.56565 2.53724 5.78167 2.98372 5.07854C3.21575 4.71292 3.19466 4.22776 2.88528 3.9219C2.5302 3.56683 1.94309 3.59143 1.66536 4.00979C1.02552 4.96956 0.56497 6.0594 0.332938 7.23011C0.234501 7.72229 0.631766 8.15472 1.1345 8.15472ZM5.24075 2.82503C5.94388 2.37854 6.72786 2.04807 7.56809 1.86175C7.98997 1.76682 8.31692 1.40823 8.31692 0.975809C8.31692 0.473075 7.8845 0.0758094 7.39231 0.174247C6.22161 0.406278 5.13177 0.866825 4.172 1.50667C3.75364 1.7844 3.72903 2.37151 4.08411 2.72659C4.38997 3.03245 4.87513 3.05706 5.24075 2.82503ZM10.0044 17.0246C10.0044 17.5274 10.4368 17.9246 10.929 17.8262C12.0997 17.5942 13.1896 17.1336 14.1493 16.4938C14.5677 16.216 14.5923 15.6289 14.2372 15.2739C13.9314 14.968 13.4462 14.9434 13.0806 15.1754C12.3775 15.6219 11.5935 15.9524 10.7533 16.1387C10.3314 16.2336 10.0044 16.5922 10.0044 17.0246ZM15.3341 12.9184C15.1021 13.284 15.1232 13.7692 15.4325 14.075C15.7876 14.4301 16.3747 14.4055 16.6525 13.9871C17.2923 13.0274 17.7529 11.9375 17.9849 10.7668C18.0833 10.2746 17.6861 9.84222 17.1833 9.84222C16.7509 9.84222 16.3923 10.1692 16.2974 10.591C16.1111 11.4313 15.7806 12.2153 15.3341 12.9184ZM4.08411 15.2668C3.72903 15.6219 3.75364 16.209 4.172 16.4867C5.13177 17.1266 6.22161 17.5871 7.39231 17.8192C7.8845 17.9176 8.31692 17.5203 8.31692 17.0176C8.31692 16.5852 7.98997 16.2266 7.56809 16.1317C6.72786 15.9453 5.94388 15.6149 5.24075 15.1684C4.87513 14.9364 4.38997 14.9574 4.08411 15.2668ZM1.66888 13.9871C1.94661 14.4055 2.53372 14.4301 2.8888 14.075C3.19466 13.7692 3.21927 13.284 2.98724 12.9184C2.54075 12.2153 2.21028 11.4313 2.02395 10.591C1.92903 10.1692 1.57044 9.84222 1.13802 9.84222C0.635282 9.84222 0.238016 10.2746 0.336454 10.7668C0.568485 11.9375 1.02903 13.0274 1.66888 13.9871ZM14.2372 2.72659C14.5923 2.37151 14.5677 1.7844 14.1493 1.50667C13.1896 0.866825 12.0997 0.406278 10.929 0.174247C10.4368 0.0758094 10.0044 0.473075 10.0044 0.975809C10.0044 1.40823 10.3314 1.76682 10.7533 1.86175C11.5935 2.04807 12.3775 2.37854 13.0806 2.82503C13.4462 3.05706 13.9314 3.03597 14.2372 2.72659ZM15.3341 5.07503C15.7806 5.77815 16.1111 6.56214 16.2974 7.40237C16.3923 7.82425 16.7509 8.1512 17.1833 8.1512C17.6861 8.1512 18.0833 7.71878 17.9849 7.22659C17.7529 6.05589 17.2923 4.96604 16.6525 4.00628C16.3747 3.58792 15.7876 3.56331 15.4325 3.91839C15.1267 4.22425 15.1021 4.7094 15.3341 5.07503Z"
        fill="#959592"
      />
    </svg>
  );
}

function CoachProgressSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8329_2273)">
        <path
          d="M16.4714 9C16.4714 10.9394 15.701 12.7994 14.3297 14.1707C12.9583 15.5421 11.0983 16.3125 9.15894 16.3125C7.21954 16.3125 5.35958 15.5421 3.98822 14.1707C2.61686 12.7994 1.84644 10.9394 1.84644 9C1.84644 7.0606 2.61686 5.20064 3.98822 3.82928C5.35958 2.45792 7.21954 1.6875 9.15894 1.6875C11.0983 1.6875 12.9583 2.45792 14.3297 3.82928C15.701 5.20064 16.4714 7.0606 16.4714 9ZM0.158936 9C0.158936 11.3869 1.10715 13.6761 2.79497 15.364C4.4828 17.0518 6.77199 18 9.15894 18C11.5459 18 13.8351 17.0518 15.5229 15.364C17.2107 13.6761 18.1589 11.3869 18.1589 9C18.1589 6.61305 17.2107 4.32387 15.5229 2.63604C13.8351 0.948212 11.5459 0 9.15894 0C6.77199 0 4.4828 0.948212 2.79497 2.63604C1.10715 4.32387 0.158936 6.61305 0.158936 9ZM8.31519 4.21875V9C8.31519 9.28125 8.45581 9.54492 8.69136 9.70312L12.0664 11.9531C12.4531 12.2133 12.9769 12.1078 13.2371 11.7176C13.4972 11.3273 13.3917 10.807 13.0015 10.5469L10.0027 8.55V4.21875C10.0027 3.75117 9.62651 3.375 9.15894 3.375C8.69136 3.375 8.31519 3.75117 8.31519 4.21875Z"
          fill="#D97302"
        />
      </g>
      <defs>
        <clipPath id="clip0_8329_2273">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(0.158936)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

function CoachSuccessSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 1.6875C10.9394 1.6875 12.7994 2.45792 14.1707 3.82928C15.5421 5.20064 16.3125 7.0606 16.3125 9C16.3125 10.9394 15.5421 12.7994 14.1707 14.1707C12.7994 15.5421 10.9394 16.3125 9 16.3125C7.0606 16.3125 5.20064 15.5421 3.82928 14.1707C2.45792 12.7994 1.6875 10.9394 1.6875 9C1.6875 7.0606 2.45792 5.20064 3.82928 3.82928C5.20064 2.45792 7.0606 1.6875 9 1.6875ZM9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM12.9727 7.34766C13.3031 7.01719 13.3031 6.48281 12.9727 6.15586C12.6422 5.82891 12.1078 5.82539 11.7809 6.15586L7.87852 10.0582L6.22617 8.40586C5.8957 8.07539 5.36133 8.07539 5.03437 8.40586C4.70742 8.73633 4.70391 9.2707 5.03437 9.59766L7.28437 11.8477C7.61484 12.1781 8.14922 12.1781 8.47617 11.8477L12.9727 7.34766Z"
        fill="#167C05"
      />
    </svg>
  );
}

function ProScoreSkillSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99951 2.90918C12.554 2.90918 14.5973 4.07282 16.0806 5.45215C17.5535 6.82123 18.5392 8.45388 19.0093 9.58008L19.0464 9.68262C19.1203 9.92424 19.1077 10.1842 19.0093 10.4199C18.5392 11.546 17.5536 13.1818 16.0806 14.5479C14.5974 15.9239 12.5541 17.0908 9.99951 17.0908C7.44524 17.0907 5.40262 15.9271 3.91943 14.5479C2.44649 13.1788 1.46082 11.5461 0.990723 10.4199C0.878216 10.1506 0.878216 9.84941 0.990723 9.58008C1.4608 8.45395 2.4464 6.81817 3.91943 5.45215C5.40261 4.07292 7.44526 2.90931 9.99951 2.90918ZM9.99951 4.09082C7.82937 4.09095 6.05929 5.0772 4.7251 6.31641C3.40578 7.5419 2.51824 9.01066 2.09912 10C2.51823 10.9893 3.40576 12.4581 4.7251 13.6836C6.0593 14.9228 7.82935 15.9091 9.99951 15.9092C12.1699 15.9092 13.9406 14.9229 15.2749 13.6836C16.5939 12.4584 17.4797 10.9893 17.8989 10C17.4797 9.01067 16.5939 7.54163 15.2749 6.31641C13.9406 5.07709 12.1699 4.09082 9.99951 4.09082ZM10.2378 5.91504H10.2524C12.3971 6.04299 14.0942 7.82356 14.0942 10C14.0942 12.2596 12.2629 14.0906 10.0034 14.0908C7.85601 14.0908 6.09489 12.436 5.92529 10.335H5.92139L5.91553 10.251C5.90896 10.1657 5.90869 10.0807 5.90869 10C5.90869 9.61022 5.96356 9.23592 6.06592 8.88086L6.06689 8.87793C6.07072 8.86646 6.07366 8.85418 6.07764 8.83984C6.08145 8.82613 6.08577 8.80958 6.09131 8.79297C6.48817 7.50246 7.50796 6.48714 8.79834 6.08789C9.17919 5.96953 9.58541 5.90918 10.0034 5.90918C10.0835 5.90919 10.1631 5.91193 10.2378 5.91504ZM11.0034 7.26953C11.0603 7.50384 11.0913 7.74879 11.0913 8C11.0913 9.70655 9.70606 11.0908 7.99951 11.0908C7.74867 11.0908 7.50402 11.0607 7.27002 11.0039C7.67778 12.115 8.74666 12.909 9.99951 12.9092C11.6055 12.9092 12.9087 11.606 12.9087 10C12.9087 8.74693 12.1152 7.67969 11.0034 7.26953ZM9.68311 7.11328C8.32648 7.25801 7.25205 8.33159 7.10498 9.6875C7.37089 9.82883 7.67415 9.91207 7.99658 9.91211C9.04942 9.91211 9.90576 9.05577 9.90576 8.00293C9.90573 7.68066 9.82567 7.37808 9.68311 7.11328Z"
        fill="#313130"
        stroke="#313130"
        strokeWidth="0.182114"
      />
    </svg>
  );
}

function ProScoreRepIconSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.76514 5.41016C10.7462 5.41016 11.6432 5.96344 12.0835 6.84082L13.0054 8.68164C13.0744 8.81961 13.215 8.90623 13.3716 8.90625H15.5024C15.8273 8.90625 16.0933 9.17218 16.0933 9.49707C16.0932 9.82191 15.8273 10.0869 15.5024 10.0869H13.3716C12.7686 10.0869 12.2191 9.74578 11.9507 9.20898H11.9497L11.7603 8.82715L10.6548 12.165L12.6353 12.7695C13.2623 12.9604 13.5796 13.6564 13.314 14.2559L11.5386 18.2402C11.4057 18.5388 11.0587 18.6715 10.7603 18.5391C10.4616 18.4063 10.3281 18.0592 10.4604 17.7607L12.188 13.8691L8.27393 12.6807H8.27295C7.30041 12.3848 6.75164 11.3554 7.04736 10.3828L8.20264 6.59082H6.82471C6.56059 6.59082 6.32168 6.74749 6.21729 6.98926L5.04248 9.73242H5.0415C4.91262 10.0307 4.56665 10.1714 4.26709 10.042C3.96887 9.91311 3.82816 9.5671 3.95752 9.26758L5.13232 6.52344C5.42165 5.84978 6.08872 5.41016 6.82471 5.41016H9.76514ZM6.82861 13.3799C7.08048 13.5832 7.36847 13.7508 7.68408 13.8691L7.76807 13.9004L7.73779 13.9834L7.47217 14.7275C7.32975 15.1256 7.09348 15.4817 6.78271 15.7666L3.89795 18.4102C3.65751 18.6319 3.28557 18.6128 3.06494 18.374C2.84293 18.1335 2.86203 17.7607 3.10107 17.54L5.98584 14.9023C6.15625 14.7466 6.2856 14.5529 6.36182 14.3359L6.68115 13.4365V13.2607L6.82861 13.3799ZM8.18018 10.7266C8.08647 11.0317 8.22556 11.3518 8.49561 11.4971L8.61963 11.5479L9.52295 11.8223L11.0093 7.33496C10.766 6.87809 10.2909 6.59082 9.76807 6.59082H9.43799L8.18018 10.7266ZM10.9995 0.910156C12.015 0.910156 12.8403 1.73449 12.8403 2.75C12.8403 3.76552 12.015 4.59082 10.9995 4.59082C9.98409 4.5907 9.15967 3.76545 9.15967 2.75C9.15968 1.73456 9.9841 0.910276 10.9995 0.910156ZM10.9995 2.09082C10.6339 2.09094 10.3403 2.38434 10.3403 2.75C10.3403 3.11567 10.6339 3.41004 10.9995 3.41016C11.3653 3.41016 11.6597 3.11575 11.6597 2.75C11.6597 2.38426 11.3653 2.09082 10.9995 2.09082Z"
        fill="#313130"
        stroke="#313130"
        strokeWidth="0.180647"
      />
    </svg>
  );
}

function ProScoreSocialRepSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5835 2.49463C11.9922 2.32432 12.4595 2.41657 12.7729 2.72998L17.7729 7.72998C18.1986 8.15585 18.1986 8.84712 17.7729 9.27295L12.7729 14.2729H12.772C12.459 14.5825 11.9927 14.6788 11.5835 14.5083C11.175 14.3381 10.9097 13.9393 10.9097 13.4995V11.0933H7.99951C6.39331 11.0933 5.08961 12.3963 5.08936 14.0024C5.08936 14.9204 5.47678 15.4477 5.75537 15.7085C5.93724 15.8773 6.08936 16.1155 6.08936 16.3843C6.0893 16.7712 5.77487 17.0901 5.38428 17.0903C5.28664 17.0903 5.18274 17.0723 5.0874 17.019C4.49314 16.6948 1.90967 15.0901 1.90967 11.4995C1.90982 8.41226 4.41222 5.90967 7.49951 5.90967H10.9097V3.49951C10.9098 3.05957 11.1754 2.66469 11.5835 2.49463ZM12.0894 6.24951C12.0894 6.71502 11.715 7.09033 11.2495 7.09033H7.49951C5.06512 7.09033 3.08951 9.06515 3.08936 11.4995C3.08936 12.737 3.4595 13.6821 3.92432 14.3794C3.91381 14.2571 3.90967 14.13 3.90967 13.9995C3.90982 11.7404 5.74035 9.90967 7.99951 9.90967H11.2495C11.7149 9.90967 12.0892 10.2841 12.0894 10.7495V13.2827L16.8716 8.49951L12.0894 3.71729V6.24951Z"
        fill="#313130"
        stroke="#313130"
        strokeWidth="0.180647"
      />
    </svg>
  );
}

function WaitingSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.75 8.41667H11.5V11.75L14 13.4167L14.625 12.3917L12.75 11.125V8.41667ZM12.3334 5.5L0.666687 0.5V6.33333L8.16669 8L0.666687 9.66667V15.5L6.72502 12.9083C7.40835 15.3583 9.65835 17.1667 12.3334 17.1667C15.55 17.1667 18.1667 14.55 18.1667 11.3333C18.1667 8.11667 15.55 5.5 12.3334 5.5ZM12.3334 15.5C10.0417 15.5 8.18335 13.65 8.16669 11.3583V11.3C8.18335 9.01667 10.0417 7.15833 12.3334 7.15833C14.6334 7.15833 16.5 9.025 16.5 11.325C16.5 13.625 14.6334 15.5 12.3334 15.5Z"
        fill="#A0A6AA"
      />
    </svg>
  );
}

function EnvelopeSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.6667 0.333008H2.33332C1.41666 0.333008 0.67499 1.08301 0.67499 1.99967L0.666656 11.9997C0.666656 12.9163 1.41666 13.6663 2.33332 13.6663H15.6667C16.5833 13.6663 17.3333 12.9163 17.3333 11.9997V1.99967C17.3333 1.08301 16.5833 0.333008 15.6667 0.333008ZM15.6667 3.66634L8.99999 7.83301L2.33332 3.66634V1.99967L8.99999 6.16634L15.6667 1.99967V3.66634Z"
        fill="#e50063"
      />
    </svg>
  );
}

function ProScoreCoinSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 15.5C3.935 15.5 0.5 13.9738 0.5 12.167V3.833C0.5 2.02625 3.935 0.5 8 0.5C12.065 0.5 15.5 2.02625 15.5 3.833V12.167C15.5 13.9738 12.0659 15.5 8 15.5ZM2.375 10.175V12.1693C2.44062 12.584 4.53969 13.8358 8 13.8358C11.4603 13.8358 13.5603 12.5803 13.625 12.1648V10.175C11.9182 10.9665 9.97243 11.3679 8 11.3353C6.02756 11.3679 4.08179 10.9666 2.375 10.175ZM2.375 6.00575V8C2.44062 8.41475 4.53969 9.6665 8 9.6665C11.4603 9.6665 13.5603 8.411 13.625 7.9955V6.00575C11.9183 6.79759 9.97253 7.19919 8 7.16675C6.02747 7.19923 4.08168 6.79762 2.375 6.00575ZM8 2.1665C4.53875 2.1665 2.43969 3.422 2.375 3.83825C2.44062 4.25 4.54156 5.4995 8 5.4995C11.4584 5.4995 13.5603 4.244 13.625 3.8285C13.5594 3.41525 11.4584 2.1665 8 2.1665Z"
        fill="#606366"
      />
    </svg>
  );
}

function HeadGearSvg() {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C6.25001 0 3.20001 2.94 3.02001 6.64L1.10001 9.2C0.850007 9.53 1.09001 10 1.50001 10H3.00001V13C3.00001 14.1 3.90001 15 5.00001 15H6.00001V18H13V13.32C15.36 12.2 17 9.79 17 7C17 3.13 13.87 0 10 0ZM13 7C13 7.13 12.99 7.26 12.98 7.39L13.81 8.05C13.89 8.11 13.91 8.21 13.86 8.3L13.06 9.69C13.01 9.78 12.9 9.81 12.82 9.78L11.83 9.38C11.62 9.54 11.4 9.67 11.16 9.77L11 10.83C10.99 10.93 10.9 11 10.8 11H9.20001C9.10001 11 9.02001 10.93 9.00001 10.83L8.85001 9.77C8.60001 9.67 8.38001 9.54 8.17001 9.38L7.18001 9.78C7.09001 9.81 6.98001 9.78 6.93001 9.69L6.13001 8.3C6.08001 8.22 6.10001 8.11 6.18001 8.05L7.02001 7.39C7.01001 7.26 7.00001 7.13 7.00001 7C7.00001 6.87 7.02001 6.73 7.04001 6.61L6.19001 5.95C6.11001 5.89 6.09001 5.79 6.14001 5.69L6.94001 4.31C6.99001 4.22 7.09001 4.19 7.18001 4.22L8.18001 4.62C8.38001 4.47 8.61001 4.33 8.85001 4.23L9.00001 3.17C9.02001 3.07 9.10001 3 9.20001 3H10.8C10.9 3 10.98 3.07 11 3.17L11.15 4.23C11.39 4.33 11.61 4.46 11.82 4.62L12.82 4.22C12.91 4.19 13.02 4.22 13.06 4.31L13.86 5.69C13.91 5.78 13.89 5.89 13.81 5.95L12.96 6.61C12.99 6.73 13 6.86 13 7Z"
        fill="#404244"
      />
    </svg>
  );
}

function ListCheckSvg() {
  return (
    <svg
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.54 8.00018L11 4.46018L12.41 3.05018L14.53 5.17018L18.77 0.930176L20.18 2.34018L14.54 8.00018ZM9 4.00018H0V6.00018H9V4.00018ZM19 10.4102L17.59 9.00018L15 11.5902L12.41 9.00018L11 10.4102L13.59 13.0002L11 15.5902L12.41 17.0002L15 14.4102L17.59 17.0002L19 15.5902L16.41 13.0002L19 10.4102ZM9 12.0002H0V14.0002H9V12.0002Z"
        fill="#404244"
      />
    </svg>
  );
}

function WaveFormSvg() {
  return (
    <svg
      fill="none"
      viewBox="85 -16 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="264" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="256" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="248" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="240" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="232" y="30" width="4" height="7" rx="2" fill="#A0A6AA" />
      <rect x="224" y="25" width="4" height="17" rx="2" fill="#A0A6AA" />
      <rect x="216" y="23" width="4" height="21" rx="2" fill="#A0A6AA" />
      <rect x="208" y="17" width="4" height="37" rx="2" fill="#A0A6AA" />
      <rect x="200" y="6" width="4" height="57" rx="2" fill="#A0A6AA" />
      <rect x="192" y="13" width="4" height="43" rx="2" fill="#A0A6AA" />
      <rect x="184" y="20" width="4" height="27" rx="2" fill="#A0A6AA" />
      <rect x="176" y="24" width="4" height="21" rx="2" fill="#A0A6AA" />
      <rect x="168" y="27" width="4" height="15" rx="2" fill="#A0A6AA" />
      <rect x="160" y="30" width="4" height="9" rx="2" fill="#A0A6AA" />
      <rect x="152" y="29" width="4" height="11" rx="2" fill="#A0A6AA" />
      <rect x="144" y="24" width="4" height="21" rx="2" fill="#A0A6AA" />
      <rect x="136" y="16" width="4" height="37" rx="2" fill="#A0A6AA" />
      <rect x="128" y="24" width="4" height="21" rx="2" fill="#A0A6AA" />
      <rect x="120" y="28" width="4" height="13" rx="2" fill="#A0A6AA" />
      <rect x="112" y="30" width="4" height="9" rx="2" fill="#A0A6AA" />
      <rect x="104" y="23" width="4" height="21" rx="2" fill="#A0A6AA" />
      <rect x="96" y="17" width="4" height="37" rx="2" fill="#A0A6AA" />
      <rect x="88" y="6" width="4" height="57" rx="2" fill="#A0A6AA" />
      <rect x="80" width="4" height="69" rx="2" fill="#A0A6AA" />
      <rect x="72" y="6" width="4" height="57" rx="2" fill="#A0A6AA" />
      <rect x="64" y="13" width="4" height="43" rx="2" fill="#A0A6AA" />
      <rect x="56" y="20" width="4" height="27" rx="2" fill="#A0A6AA" />
      <rect x="48" y="21" width="4" height="25" rx="2" fill="#A0A6AA" />
      <rect x="40" y="26" width="4" height="15" rx="2" fill="#A0A6AA" />
      <rect x="32" y="29" width="4" height="9" rx="2" fill="#A0A6AA" />
      <rect x="24" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="16" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect x="8" y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
      <rect y="31" width="4" height="5" rx="2" fill="#A0A6AA" />
    </svg>
  );
}

export function SkillCompletionSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2934 2934" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="1466.67" cy="1466.67" r="1466.67" fill="#E1E5E6" />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M2287.64 2531.38c0 54.54-372.81 98.75-832.7 98.75-459.89 0-832.68-44.21-832.68-98.75s372.8-98.75 832.68-98.75c459.88 0 832.7 44.21 832.7 98.75Z"
          opacity=".1"
        />
        <path
          fill="#F8B705"
          fillRule="nonzero"
          d="M1472.3 742.35v960.57a433.9 433.9 0 0 1-4.404-.129l.004 391.579h-129.82c35.122-133.9 54.366-256.145 58.635-399.964l-.006.02c-79.21-15.995-153.826-53.754-221.09-109.139l.006-.014-2.038.283-1.538.206-2.796.36-3.356.409-2.534.296-2.05.23-1.437.158-1.49.16-3.141.325-1.647.165-2.565.248-2.674.248-2.78.247-1.91.163-2.947.241-2.019.158-3.106.232-3.195.224-3.283.215-2.235.138-2.27.132-2.306.127-2.339.121-2.372.115-3.617.16-3.684.141-2.492.085-2.52.076-1.27.035-3.847.09-2.595.048-2.62.038c-.876.011-1.756.02-2.64.027l-2.662.016-2.682.005-1.348-.003c-70.12-.202-123.4-12.482-158.36-36.482-54.31-37.29-115.95-134.73-188.46-297.87a2758.52 2758.52 0 0 1-2.556-5.77l-2.531-5.747c-.42-.956-.839-1.911-1.256-2.865l-2.493-5.712-1.236-2.845-2.453-5.67a3011.59 3011.59 0 0 1-2.426-5.637l-2.397-5.605c-.398-.931-.794-1.86-1.189-2.789l-2.355-5.55-1.166-2.76-2.311-5.49-2.281-5.446-1.13-2.707-2.701-6.503-1.996-4.83-1.97-4.787-2.584-6.313-2.536-6.23-2.486-6.143-2.436-6.05-2.384-5.954-2.332-5.854-1.146-2.888-2.251-5.695-2.196-5.584-3.19-8.158-2.054-5.287-1.996-5.161-.976-2.532-1.907-4.964-1.846-4.828-2.652-6.975-1.69-4.467-1.625-4.315-1.56-4.159-2.216-5.937-2.717-7.33-2.438-6.629-2.152-5.894-2.275-6.283-1.48-4.116-1.832-5.147-.836-2.374a35.684 35.684 0 0 1 2.81-29.71 35.709 35.709 0 0 1 24.38-17.21l182.258-33.85c-.689-4.694-1.355-9.4-1.998-14.12-8.378-61.498-12.85-125.142-12.996-190.305l-.004-3.315h629.29Zm-602.065 278.144L730.31 1046.48l2.392 6.383 2.556 6.777 2.16 5.694 1.685 4.422 2.333 6.092 2.429 6.307 1.883 4.865 1.935 4.978 2.659 6.803 2.052 5.223 2.81 7.116 2.165 5.447 2.21 5.536 2.255 5.621 1.529 3.794 2.329 5.755 2.372 5.83 2.414 5.901 1.632 3.972 1.65 4 2.508 6.052 2.547 6.11 1.718 4.104 1.736 4.126 1.751 4.148 2.658 6.26 1.79 4.197 2.716 6.328 1.828 4.239 1.844 4.253 1.857 4.267 1.872 4.28 1.885 4.29 1.898 4.3 1.912 4.31c86.51 194.57 139.52 251.15 163.43 267.57 31.052 21.326 90.927 25.076 138.807 23.575l-.007.009c-111.344-121.78-195.51-296.208-236.275-498.92Zm944.195 533.896c-19.19-1.9-33.56-18.7-32.29-38.09 1.3-19.8 18.39-34.79 38.19-33.51 55.19 3.53 157.61-3.02 197.39-35.65 22.54-18.49 70.82-79.72 140.86-282.07l1.546-4.481 1.534-4.471 1.52-4.46 1.51-4.447 1.495-4.434 1.482-4.42 1.47-4.403 1.455-4.386 1.442-4.368 2.137-6.515.705-2.16 2.094-6.45 2.062-6.397 2.029-6.34 1.995-6.278 1.96-6.212 1.926-6.143 1.89-6.07 1.24-4.004 1.828-5.938 1.792-5.855 1.173-3.854 1.728-5.705 1.69-5.61 1.649-5.512 1.61-5.408 2.082-7.044 2.498-8.524 2.38-8.192 1.37-4.75 2.185-7.625 1.25-4.394 2.738-9.7 1.095-3.91-151.9-15.01c-19.74-1.95-34.17-19.54-32.22-39.28 1.95-19.74 19.54-34.17 39.28-32.22l194.15 19.18a35.923 35.923 0 0 1 25.9 15.16 35.918 35.918 0 0 1 5.36 29.53l-.958 3.684-.829 3.153-1.375 5.178-1.742 6.489-1.653 6.09-1.386 5.069-2.04 7.398-1.673 6.01-1.792 6.389-1.259 4.462-1.31 4.62-1.362 4.774-1.412 4.921-1.461 5.067-1.51 5.206-1.56 5.342-1.606 5.474-.82 2.784-1.677 5.662-.856 2.877-1.746 5.841-1.79 5.955-.913 3.019-1.857 6.118c-.94 3.085-1.896 6.208-2.869 9.368l-1.966 6.367-2.007 6.46-2.05 6.546-2.09 6.63-1.06 3.345-2.151 6.747a3028.55 3028.55 0 0 1-22.31 67.095c-58.68 169.66-112.12 272.56-163.34 314.57-32.97 27.04-85.3 43.89-155.54 50.1-1.983.175-3.952.34-5.906.493l-2.917.222-2.892.207c-.48.034-.959.066-1.436.098l-2.851.185-2.822.171-2.792.157-2.76.144-2.726.13c-.451.021-.901.042-1.35.061l-2.673.113-2.636.1-2.598.09-2.558.078-2.516.068-2.473.059-2.43.049-2.383.04-2.336.03c-.385.005-.768.01-1.15.013l-2.262.02-2.211.016h-5.296l-3.012-.023-2.88-.03-2.745-.039-2.604-.048-3.244-.075-1.522-.04-2.834-.088-3.137-.113-3.138-.132-2.748-.136-2.252-.13c-.41-.03-.81-.06-1.21-.1l-.01.02Z"
        />
        <path
          fill="#F9C809"
          fillRule="nonzero"
          d="M2097.38 742.35c0 66.32-4.48 131.08-13 193.62-54.328 398.678-273.111 707.386-545.265 759.352 4.311 143.418 23.557 265.431 58.605 399.048H1467.9v-423.58l.19-.001V742.35h629.29Z"
        />
        <path
          fill="#F5AE04"
          fillRule="nonzero"
          d="M1711.82 2091.62c11.54 0 20.98 7.85 20.98 17.44 0 1.12-.129 2.217-.375 3.28h27.645c23.07 0 41.95 13.63 41.95 30.28 0 16.66-18.88 30.29-41.95 30.29h-583.14c-23.07 0-41.95-13.63-41.95-30.29 0-16.66 18.88-30.28 41.95-30.28h36.025a14.523 14.523 0 0 1-.375-3.28c0-9.59 9.44-17.44 20.98-17.44h478.26Z"
        />
        <path
          fill="#F9C10A"
          fillRule="nonzero"
          d="M1134.98 2140.52h667.04v60.57h-667.04z"
        />
        <path
          fill="#9E9057"
          fillRule="nonzero"
          d="M1044.78 2169.89h855.83c11.58 0 20.98 9.4 20.98 20.98v251.71c0 11.58-9.4 20.98-20.98 20.98h-855.82c-11.58 0-20.98-9.4-20.98-20.98v-251.72c0-11.58 9.4-20.98 20.98-20.98l-.01.01Z"
        />
        <path
          fill="#7C7249"
          fillRule="nonzero"
          d="M1044.78 2169.89c-11.54 0-20.98 9.44-20.98 20.98v251.71c0 11.54 9.44 20.98 20.98 20.98h855.83c11.54 0 20.98-9.44 20.98-20.98l-876.8-272.69h-.01Z"
        />
        <path
          fill="#E9F5F9"
          fillRule="nonzero"
          d="M1212.59 2257.99h520.21v176.2h-520.21z"
        />
        <path
          fill="#F29803"
          fillRule="nonzero"
          d="M843.01 709.84h1254.37v32.51H843.01z"
        />
        <path
          fill="#8C8153"
          fillRule="nonzero"
          d="M910.53 2400.63h1124.32v125.85H910.53z"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="m1870.263 1901.91.057-9.43.057 9.43c.947 146.31 4.606 151.483 147.96 152.502l14.003.088-9.43.057c-147.85.947-151.586 4.683-152.533 152.533l-.057 9.43-.057-9.43c-.947-147.85-4.683-151.586-152.533-152.533l-9.43-.057 9.43-.057c147.85-.947 151.586-4.683 152.533-152.533Zm143.967-47.56.05 8.003.04 5.069c.675 74.465 4.973 78.763 79.438 79.438l5.07.04h-.001l5.281.034 2.722.016-8.004.05-5.07.04c-73.644.667-78.658 4.878-79.412 76.982l-.045 4.964-.053 7.842-.016 2.722-.05-8.003-.04-5.069c-.675-74.465-4.973-78.763-79.438-79.438l-5.07-.04-8.002-.05 8.004-.05 5.07-.04c73.644-.667 78.658-4.878 79.412-76.982l.045-4.964.053-7.842.016-2.722ZM1207.303 430.032l.087-14.412.087 14.412c1.456 225.977 7.155 231.684 233.14 233.14l14.413.088c-240.149 1.392-246.066 2.533-247.553 233.218l-.087 14.412-.087-14.412c-1.487-230.685-7.394-231.826-247.553-233.218l14.412-.087c225.977-1.457 231.684-7.164 233.14-233.14Zm158.906 65.28.021-3.492.02 3.492.024 3.354.03 3.217c.475 45.676 3.598 49.305 48.306 49.846l3.15.033 4.978.037 3.492.021-5.186.033-3.285.026-3.15.034c-1.028.012-2.034.027-3.019.043l-2.889.056c-38.617.861-41.87 6.051-42.38 48.189l-.033 3.15-.037 4.977-.021 3.492-.044-6.846-.03-3.217c-.475-45.676-3.598-49.305-48.306-49.846l-3.15-.033-4.978-.037-3.492-.021 6.846-.044 3.217-.03c45.676-.475 49.306-3.598 49.846-48.306l.033-3.15.037-4.978ZM707.44 1202.72l.067 11.053c1.099 171.497 5.397 177.561 173.43 178.754l16.413.103-11.053.067c-171.497 1.099-177.57 5.397-178.754 173.43l-.07 10.831-.033 5.582-.067-11.053c-1.108-171.497-5.398-177.57-173.43-178.754l-10.831-.07-5.582-.033 11.053-.067c171.497-1.108 177.57-5.398 178.754-173.43l.07-10.831.033-5.582Zm-92.26-39.474.05-7.756.037 5.876.03 3.722c.49 54.07 3.579 57.754 56.521 58.308l3.646.033 7.756.051-5.876.037-3.722.03c-53.46.484-57.656 3.51-58.286 54.756l-.038 3.569-.03 3.722-.038 5.876-.037-5.876-.03-3.722c-.484-53.46-3.51-57.656-54.747-58.286l-3.57-.038-3.72-.03-5.876-.038 5.876-.037 3.722-.03c54.068-.49 57.745-3.579 58.298-56.521l.033-3.646Zm1485.47 128.224 8.314-.052 5.266-.042c77.359-.699 81.826-5.159 82.526-82.525l.042-5.266.052-8.315.052 8.314.042 5.266c.691 76.498 5.06 81.71 79.973 82.5l5.158.047 8.147.056 2.828.017-8.315.053-5.266.042c-77.365.707-81.817 5.159-82.524 82.524l-.042 5.266-.036 5.487-.017 2.828-.053-8.314-.02-2.66-.047-5.157c-.782-74.064-5.885-79.167-79.948-79.949l-5.158-.047-8.147-.056-2.827-.017Zm-939.113 655.209-4.737-.029 7.034-.044 4.456-.036c65.452-.595 69.225-4.368 69.82-69.82l.051-6.753.029-4.737.029 4.737.05 6.753c.596 65.452 4.369 69.225 69.821 69.82l6.753.051 4.737.029-4.737.029-6.753.05c-65.452.596-69.225 4.369-69.82 69.821l-.051 6.753-.029 4.737-.044-7.034-.036-4.456c-.595-65.452-4.368-69.225-69.82-69.82l-6.753-.051Z"
        />
        <path
          fill="#E89C2D"
          fillRule="nonzero"
          d="M1460.77 878.82c4.25-13.08 11.2-13.08 15.45 0l59.13 181.97c4.25 13.08 18.98 23.78 32.73 23.78h191.34c13.75 0 15.9 6.61 4.77 14.69l-154.79 112.46c-11.12 8.08-16.75 25.39-12.5 38.47l59.13 181.97c4.25 13.08-1.38 17.16-12.5 9.08l-154.79-112.46c-11.12-8.08-29.33-8.08-40.45 0l-154.79 112.46c-11.12 8.08-16.75 4-12.5-9.08l59.13-181.97c4.25-13.08-1.38-30.39-12.5-38.47l-154.79-112.46c-11.12-8.08-8.98-14.69 4.77-14.69h191.34c13.75 0 28.48-10.7 32.73-23.78l59.12-181.97h-.03Z"
        />
        <path
          stroke="#E58800"
          d="M1460.77 878.82c4.25-13.08 11.2-13.08 15.45 0l59.13 181.97c4.25 13.08 18.98 23.78 32.73 23.78h191.34c13.75 0 15.9 6.61 4.77 14.69l-154.79 112.46c-11.12 8.08-16.75 25.39-12.5 38.47l59.13 181.97c4.25 13.08-1.38 17.16-12.5 9.08l-154.79-112.46c-11.12-8.08-29.33-8.08-40.45 0l-154.79 112.46c-11.12 8.08-16.75 4-12.5-9.08l59.13-181.97c4.25-13.08-1.38-30.39-12.5-38.47l-154.79-112.46c-11.12-8.08-8.98-14.69 4.77-14.69h191.34c13.75 0 28.48-10.7 32.73-23.78l59.12-181.97h-.03Z"
        />
      </g>
    </svg>
  );
}

export function QuizCompletionSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2934 2934" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="1466.67" cy="1466.67" r="1466.67" fill="#E1E5E6" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M1845.51 593.53H855.55c-42.24 0-76.48 34.25-76.48 76.49V2263.4c0 42.23 34.24 76.48 76.48 76.48h1221.79c42.24 0 76.48-34.24 76.48-76.48V901.84l-308.31-308.31Z"
        />
        <path
          fill="#C1C6C9"
          fillRule="nonzero"
          d="M1845.95 593.47v231.08c0 42.66 34.58 77.23 77.23 77.23h231.08l-308.31-308.31Zm-621.41 1104.87h576.58v72.04h-576.58v-72.04Zm0 132.03h237.86v72.07h-237.86v-72.07Zm-194.95-135.83c-59.945 0-108.54 48.595-108.54 108.54 0 59.945 48.595 108.54 108.54 108.54 59.945 0 108.54-48.595 108.54-108.54 0-59.945-48.595-108.54-108.54-108.54Zm0 20c48.9 0 88.54 39.64 88.54 88.54 0 48.9-39.64 88.54-88.54 88.54-48.9 0-88.54-39.64-88.54-88.54 0-48.9 39.64-88.54 88.54-88.54Zm465.33 116.34h91.82v72.07h-91.82v-72.07Zm341.2-132.54h166.17v72.04h-166.17v-72.04Zm-611.58-332.38h202.58V1438h-202.58v-72.04Zm0 132.03h241.86v72.07h-241.86v-72.07Zm-194.95-135.83c-59.945 0-108.54 48.595-108.54 108.54 0 59.945 48.595 108.54 108.54 108.54 59.945 0 108.54-48.595 108.54-108.54 0-59.945-48.595-108.54-108.54-108.54Zm0 20c48.9 0 88.54 39.64 88.54 88.54 0 48.9-39.64 88.54-88.54 88.54-48.9 0-88.54-39.64-88.54-88.54 0-48.9 39.64-88.54 88.54-88.54Zm474.36 116.34h165.82v72.07h-165.82v-72.07Zm-40.83-132.54h539.17V1438h-539.17v-72.04Z"
        />
        <path
          fill="#0C5CD4"
          fillRule="nonzero"
          d="M1224.54 1030.38h442.11v72.04h-442.11v-72.04Zm0 132.03h237.86v72.07h-237.86v-72.07Zm-194.95-135.83c59.945 0 108.54 48.595 108.54 108.54 0 59.945-48.595 108.54-108.54 108.54-59.945 0-108.54-48.595-108.54-108.54 0-59.945 48.595-108.54 108.54-108.54Zm0 20c-48.9 0-88.54 39.64-88.54 88.54 0 48.9 39.64 88.54 88.54 88.54 48.9 0 88.54-39.64 88.54-88.54 0-48.9-39.64-88.54-88.54-88.54Zm-.47 34.05c29.823 0 54 24.177 54 54s-24.177 54-54 54-54-24.177-54-54 24.177-54 54-54Zm465.8 82.29h91.82v72.07h-91.82v-72.07Zm122.03 0h165.82v72.07h-165.82v-72.07Zm82.72-132.54h302.62v72.04h-302.62v-72.04Z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="12"
          d="M1466.87 2124.31c84.5 0 153 68.5 153 153s-68.5 153-153 153-153-68.5-153-153 68.5-153 153-153"
        />
        <path
          fill="#F8B705"
          d="M1295.86 2412.57a110.71 110.71 0 0 1 1.555 4.681l.416 1.363.404 1.358.582 2.008 1.413 4.979.321 1.111.309 1.04.335 1.105.51 1.655.519 1.645.354 1.097.545 1.645.185.548.377 1.095.385 1.093.395 1.09.404 1.086.414 1.083.424 1.078.217.538.441 1.07c.224.534.452 1.065.685 1.594l.472 1.055c4.465 9.805 10.642 18.627 20.368 24.243 11.322 6.54 20.775 8.268 30.865 8.775l1.145.053.574.022 1.155.04 1.162.03 1.76.036 2.378.032 6.155.06 2.563.04 1.965.045 1.333.039 1.351.048 1.371.057 5.708.279 1.479.08 1.396.084 1.322.092.843.067.816.073.791.08.768.088.748.097.367.052.722.111.356.06.7.129c1.855.36 3.594.855 5.418 1.568l.688.278.348.147.705.31c.118.054.238.108.357.164l.727.345.37.181.753.382c.255.132.513.268.775.408l.798.434.409.228.837.476.867.506.445.264-77.71 157.45-39.96-80.98-82.74 20.42 85.09-172.41Zm342.24 1.26 84.46 171.15-82.74-20.42-39.96 80.98-78.18-158.41.01-.01.319-.215.627-.412c.207-.134.412-.265.615-.392l.604-.37a29.485 29.485 0 0 1 3.548-1.84l.6-.249c1.409-.566 2.89-1.018 4.578-1.403l.737-.161.764-.154.794-.147c.27-.048.546-.095.827-.141l.862-.136.444-.067.918-.13.959-.128 1.002-.126 1.588-.187.554-.062c9.01-1.001 17.547-1.101 26.53-.983l3.976.057 1.583.014c7.369.04 14.53-.294 21.691-2.738 6.12-2.09 11.41-5.44 16.12-9.85 7.787-7.292 12.404-16.625 16.117-26.416l.525-1.402.514-1.407.504-1.41.25-.707.492-1.416.73-2.125 1.68-4.955.724-2.113.486-1.402.492-1.397c.33-.928.665-1.852 1.006-2.77a52.72 52.72 0 0 1 2.236-5.138l.414-.812Zm-170.66-358.02c8.938 0 14.758 2.408 20.573 6.355l.794.548.795.566.398.29.801.593.807.61.815.628.824.643 1.259.996 4.04 3.225 2.001 1.577 1.043.808.532.41 1.088.826a146.673 146.673 0 0 0 11.53 7.897l1.21.738 1.311.792.818.489.777.459.741.43.709.404c.115.065.23.13.343.192l.667.365.644.342c.211.11.42.215.625.318l.61.297a26.01 26.01 0 0 0 5.105 1.832l.655.155.336.074.694.144.725.136.759.132.797.127.84.125.884.123 1.423.185 1.017.125.53.064c.535.064 1.066.125 1.59.185l1.561.17 1.531.16 1.501.146 1.473.136 1.443.124 1.416.113 1.387.103 1.36.094 1.333.085 1.307.076 1.28.068 1.872.088 1.217.05 1.192.044 2.31.07 1.672.04 1.62.031 2.59.036 7.845.072 1.65.028 1.583.042 1.144.042.743.034 1.086.061.707.049.692.055.678.062.665.07.652.079.64.087c7.04 1.02 12.24 4.613 15.308 7.756l.415.436c.133.144.262.287.386.428l.359.418c.287.344.544.676.772.992 8.428 11.704 12.24 22.042 15.129 31.447l.486 1.603.473 1.586 1.148 3.888.457 1.527.46 1.512c4.03 13.031 9.045 24.357 27.157 35.397l7.302 4.429 1.519.93 1.46.902 1.4.88.454.288 1.325.854.851.56.828.556c.271.185.539.369.803.552l.779.548c.256.182.508.364.756.546l.732.544c7.452 5.629 11.25 11.264 13.091 22.331 1.67 10.064-.02 17.714-2.68 24.78l-.352.918-.362.913-.37.908-.379.904-.579 1.35-.68 1.557-1.228 2.772-.49 1.115-.395.912-.392.917-.388.923-.38.93-.374.937-.365.945c-2.521 6.65-4.32 13.987-3.546 23.429.556 6.815 1.754 12.28 3.192 17.218l.336 1.131.17.56.347 1.106.353 1.094.357 1.083.542 1.61 1.456 4.256.361 1.068.357 1.074.353 1.082.347 1.094.17.55.337 1.114c2.38 8.033 4.106 17.317 3.362 31.58-.537 10.238-8.113 17.196-17.915 24.668l-1.45 1.097-2.227 1.666-3.05 2.271-1.55 1.164-1.566 1.185c-12.04 9.176-24.962 20.514-31.972 39.369l-.545 1.475-.782 2.156-.745 2.09-.942 2.684-2.75 7.974-.786 2.236-.387 1.082-.384 1.058-.384 1.036-.383 1.013-.385.992c-.064.163-.128.326-.193.487l-.388.96-.195.471-.395.928-.4.909c-.202.449-.406.89-.613 1.325l-.419.86c-2.045 4.112-4.422 7.58-7.694 10.644-6.077 5.69-12 7.165-19.886 7.462l-1.04.033c-.35.008-.704.015-1.063.02l-1.087.01-1.113.001-1.139-.006-1.76-.02-6.36-.096-1.37-.014-2.123-.01-1.46.002c-.74.004-1.494.01-2.263.021l-1.557.029-1.597.04-1.64.056-1.681.07c-3.407.16-7.075.423-11.043.843l-.998.109.01.02-1.79.207-1.145.141-1.109.145-1.074.148-1.042.153c-.342.052-.679.105-1.01.159l-.982.164-.953.17-.466.088-.914.182c-1.654.34-3.188.72-4.648 1.156l-.79.244c-2.739.874-5.238 1.967-7.818 3.397l-.74.417c-.371.214-.745.435-1.121.663l-.758.466-.768.486-.78.508-.793.529-.809.551-.825.575-.843.597-.864.622-.886.647-.908.672-1.411 1.056-1.473 1.117-.502.385-.98.762-.947.752-.918.74-.89.73-.862.717-1.248 1.055-1.198 1.026-4.048 3.507-1.035.883-.68.57-.672.554-.668.538-.664.523c-5.637 4.374-11.088 6.988-20.948 6.988-7.434 0-12.306-1.806-17.41-5.053l-.681-.442-.686-.458-.345-.236-1.046-.73-.708-.509-.718-.524-1.098-.815-1.514-1.143-3.669-2.79-1.32-.996-1.853-1.377-1.463-1.07-1.013-.728-1.045-.743-1.08-.756-1.114-.768-1.15-.781-.59-.395-1.208-.8-1.249-.812-1.29-.824-1.082-.68-1.051-.652-1.022-.624-.994-.597c-.327-.195-.65-.385-.969-.571l-.944-.545-.92-.52a82.512 82.512 0 0 0-3.07-1.633l-.84-.416-.827-.394a59.084 59.084 0 0 0-.408-.19l-.809-.363c-3.214-1.414-6.2-2.356-9.432-3.018l-.813-.16-.825-.148a58.995 58.995 0 0 0-.839-.138l-.854-.129-.87-.12-.442-.056-.899-.107-.92-.1-.942-.094-.966-.087-.993-.082-1.02-.077-1.584-.11-1.656-.101-2.932-.161-2.517-.127-1.396-.064-1.362-.055-1.33-.046-1.298-.038-1.89-.044-1.826-.031-2.34-.027-6.45-.048-1.498-.02-1.46-.03-.954-.028-.939-.033-.925-.04a92.233 92.233 0 0 1-.458-.024l-.908-.053-.45-.03-.891-.069c-6.653-.55-12.532-2.027-19.655-6.14-8.31-4.799-12.95-14.919-16.603-25.97l-.461-1.417a202.78 202.78 0 0 1-.227-.71l-.448-1.427-.44-1.433-.648-2.153-2.11-7.138-.422-1.405-.425-1.393c-.071-.231-.142-.462-.214-.691l-.432-1.371-.218-.68-.44-1.344c-1.706-5.115-3.585-9.783-5.952-13.488-4.041-6.326-9.657-11.114-15.748-15.436l-1.147-.805-.577-.4-1.161-.79-1.168-.785-1.762-1.168-3.81-2.497-1.727-1.139-1.373-.916-.911-.615-.906-.62-.9-.625-.895-.63-.887-.638-.44-.322-.876-.65-.867-.657c-7.754-5.962-14.33-13.064-17.195-23.767-3.157-11.764-1.888-18.203 3.016-27.288l.494-.902c14.673-26.413 9.479-46.006 3.326-63.42l-.728-2.04-1.812-5.02-.354-.993-.694-1.975c-4.438-12.8-7.269-24.86-.038-38.252 2.254-4.178 6.48-8.394 11.587-12.593l.967-.787.491-.393.996-.787 1.012-.785 1.028-.785 1.04-.785 1.053-.783 1.063-.782 1.61-1.172 1.624-1.169 1.088-.777 6.538-4.65 2.074-1.489 1.53-1.112 1.004-.739 1.481-1.104 1.446-1.099.942-.73.463-.364.912-.726c5.107-4.109 9.17-8.096 10.981-11.899 5.91-12.405 8.646-21.423 10.387-28.518l.306-1.27.287-1.228.271-1.19.864-3.892.351-1.552.236-1 .119-.492.243-.964c1.892-7.307 4.546-12.69 13.866-20.114 5.98-4.762 14.202-6.267 23.292-6.696l1.19-.05c.398-.015.798-.028 1.2-.04l1.208-.028 1.216-.02 1.837-.015 1.851-.001 1.24.005 7.885.072 1.87.01 1.87-.003c7.156-.031 14.225-.374 20.641-1.924.298-.072.593-.146.886-.221l.872-.233.431-.12.855-.25a50.666 50.666 0 0 0 2.099-.685l.83-.299c2.345-.868 4.657-1.925 7.126-3.25l.879-.478.444-.248.902-.514.457-.265.93-.55.471-.285.961-.588.984-.615 1.01-.642 1.036-.67 1.61-1.059 1.113-.743 1.733-1.173 1.201-.822 1.19-.826.579-.407 1.123-.801 1.082-.785.526-.386 1.022-.76.986-.743.479-.365.933-.718 1.34-1.045 1.685-1.333 3.443-2.75 1.063-.838.692-.537.68-.52.67-.502.66-.484a51.75 51.75 0 0 1 1.308-.914l.65-.43c4.869-3.162 9.724-4.806 18.259-4.806Zm-.77 70.33c-83.37 0-150.96 67.59-150.96 150.96s67.59 150.96 150.96 150.96 150.96-67.59 150.96-150.96-67.59-150.96-150.96-150.96Z"
        />
        <path
          fill="#EA5757"
          d="M1466.67 2148.9c70.8 0 128.2 57.4 128.2 128.2 0 70.8-57.4 128.2-128.2 128.2-70.8 0-128.2-57.4-128.2-128.2 0-70.8 57.4-128.2 128.2-128.2"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="m1417.8 2258.52 31.45 32.7 65.04-71.4 26.72 24.32-90.73 99.7-58.21-60.02z"
        />
      </g>
    </svg>
  );
}

export function QuizMissSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2934 2934" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="1466.67" cy="1466.67" r="1466.67" fill="#E1E5E6" />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M2287.64 2531.38c0 54.54-372.81 98.75-832.7 98.75-459.89 0-832.68-44.21-832.68-98.75s372.8-98.75 832.68-98.75c459.88 0 832.7 44.21 832.7 98.75Z"
          opacity=".1"
        />
        <path
          fill="#DDA00A"
          fillRule="nonzero"
          d="m554.67 1384.45-2.46-33.95 67.13 34.41 12.5 172.51-67.13-34.42-9.16-126.39 37.27 14-38.15-26.16ZM138.45 1606.2l-18.99-28.26 75.36-3.43 96.44 143.58-75.36 3.42-70.66-105.19 39.31-6.34-46.1-3.78Zm2100.24-108.13 17.08-29.45 36.11 66.23-86.78 149.61-36.11-66.23 63.59-109.62 22.92 32.56-16.81-43.1Z"
        />
        <path
          fill="#F8B705"
          fillRule="nonzero"
          d="m694.15 1386.68-36.38 59.95 38.65-28.66 6.71 92.63-61.47 43.74-12.5-172.51 61.47-43.74 3.52 48.59Zm-440.5 159.8-1.84 70.1 19.34-44.06 51.79 77.1-31.67 68.47-96.44-143.58 31.67-68.47 27.16 40.43-.01.01Zm2089.22 28.96-63.82 29.07 48.08-1.93-46.6 80.34-75.42 1.54 86.78-149.61 75.42-1.54-24.44 42.13Z"
        />
        <path
          fill="#1E9EBE"
          fillRule="nonzero"
          d="m2578.76 1443.36 13.43-31.29 43.79 61.42-68.18 158.95-43.8-61.42 49.96-116.46 26.66 29.57-21.86-40.77Zm-2239.67 73.77-14.77-30.68 75.08 7.35 75.01 155.85-75.08-7.35-54.96-114.19 39.81-.67-45.09-10.31Z"
        />
        <path
          fill="#28C1E5"
          fillRule="nonzero"
          d="m2691.47 1507.66-59.87 36.52c15.83-2.56 31.66-5.12 47.5-7.69l-36.62 85.35-74.69 10.59 68.19-158.95 74.69-10.59-19.2 44.76v.01Zm-2229.85-33.23-11.81 69.13c8.47-13.62 16.94-27.24 25.42-40.85l40.28 83.69-41.1 63.26-75-155.85 41.1-63.26 21.12 43.89-.01-.01Z"
        />
        <path
          fill="#3AA022"
          fillRule="nonzero"
          d="m2373.97 1379.71 5.04-33.67 57.95 48.3-25.62 171.05-57.95-48.3 18.77-125.32 33.3 21.83z"
        />
        <path
          fill="#50BA3A"
          fillRule="nonzero"
          d="m2499.31 1413.31-48.64 50.52c14.66-6.5 29.33-12.99 43.99-19.49l-13.76 91.85-69.56 29.19 25.63-171.05 69.56-29.19-7.22 48.17Z"
        />
        <path
          fill="#AF7337"
          fillRule="nonzero"
          d="M1463.9 2527.55c22.51 0 40.82-18.31 40.82-40.82v-480.5h-81.64v480.5c0 22.285 17.946 40.453 40.146 40.815l.674.005Zm820.55-1000.19c2.83-4.86 9.06-6.52 13.92-3.7 4.786 2.781 6.472 8.837 3.842 13.667l-.142.253-563.54 971.57c-2.83 4.87-9.06 6.52-13.92 3.7-4.134-2.4-5.946-7.266-4.664-11.656l.084-.274h-.01a10.25 10.25 0 0 1 .676-1.603l.214-.387 563.54-971.57Zm142.85-137.26c.84-5.56 6.02-9.39 11.58-8.56 5.467.826 9.272 5.849 8.598 11.302l-.038.278-113.745 759.19 294.025-685.36c2.182-5.071 7.995-7.476 13.102-5.45l.268.11c5.071 2.182 7.476 7.995 5.45 13.102l-.11.268-324.624 756.686-40.786 272.234c-.826 5.467-5.849 9.262-11.302 8.598l-.278-.038c-4.725-.706-8.211-4.564-8.629-9.126l-.021-.284a9.82 9.82 0 0 1 .034-1.732l.056-.438 29.282-195.454-86.552 201.754a10.175 10.175 0 0 1-13.102 5.45l-.268-.11c-4.48-1.92-6.88-6.69-5.98-11.29a9.7 9.7 0 0 1 .475-1.67l.165-.41 117.152-273.08L2427.3 1390.1Zm-1808.9-18.09c5.517-.403 10.327 3.67 10.866 9.14l.024.28 48.348 667.021L894.46 2498.97a10.178 10.178 0 0 1-4.5 13.46l-.26.13c-4.3 2.077-9.35.843-12.26-2.686l-.18-.224h-.01a10.556 10.556 0 0 1-.94-1.454l-.2-.396-194.465-404.064 14.406 198.748L828 2498.93a10.187 10.187 0 0 1-2.537 13.962l-.243.168c-4.05 2.72-9.35 2.14-12.73-1.11-.416-.4-.8-.832-1.147-1.306l-.253-.364-112.07-166.855 11.47 158.245c.403 5.516-3.67 10.317-9.14 10.866l-.28.024c-4.86.35-9.18-2.78-10.5-7.28a9.255 9.255 0 0 1-.35-1.699l-.04-.441-14.048-193.789L184.84 1577.9a10.176 10.176 0 0 1 2.527-13.962l.243-.168a10.187 10.187 0 0 1 13.962 2.537l.168.243 471.425 701.861-15.557-214.62L389.03 1495.73a10.178 10.178 0 0 1 4.5-13.46l.26-.13a10.178 10.178 0 0 1 13.46 4.5l.13.26 246.221 511.607L608.98 1382.9c-.403-5.517 3.67-10.317 9.14-10.866l.28-.024Z"
        />
        <path
          fill="#D8984A"
          fillRule="nonzero"
          d="M1962.44 2515.54c8 0 15.78-2.34 22.48-6.77 9.09-6.01 15.3-15.21 17.48-25.89 2.18-10.68.07-21.58-5.95-30.67l-341.32-516.2-68.1 45.03 341.32 516.21c7.58 11.47 20.32 18.31 34.08 18.31l.01-.02Zm-991.54 0c13.76 0 26.5-6.85 34.08-18.31l341.32-516.21-68.1-45.03-341.32 516.2c-12.41 18.78-7.24 44.15 11.54 56.56a40.661 40.661 0 0 0 21.865 6.765l.615.005v.02Z"
        />
        <circle
          cx="1466.67"
          cy="1470.1"
          r="666.99"
          fill="#1E9EBE"
          fillRule="nonzero"
        />
        <path
          fill="#EFEFEF"
          fillRule="nonzero"
          d="M1466.67 2004.45c72.2 0 142.16-14.11 207.95-41.94 63.61-26.91 120.77-65.45 169.89-114.57 49.12-49.12 87.66-106.28 114.57-169.89 27.83-65.79 41.94-135.76 41.94-207.95s-14.11-142.16-41.94-207.95c-26.91-63.61-65.45-120.77-114.57-169.89-49.12-49.12-106.28-87.66-169.89-114.57-65.79-27.83-135.76-41.94-207.95-41.94s-142.16 14.11-207.95 41.94c-63.61 26.91-120.77 65.45-169.89 114.57-49.12 49.12-87.66 106.28-114.57 169.89-27.83 65.79-41.94 135.76-41.94 207.95s14.11 142.16 41.94 207.95c26.91 63.61 65.45 120.77 114.57 169.89 49.12 49.12 106.28 87.66 169.89 114.57 65.79 27.83 135.76 41.94 207.95 41.94Z"
        />
        <path
          fill="#F8B705"
          fillRule="nonzero"
          d="M1466.67 1871.81c54.35 0 106.93-10.58 156.28-31.46 47.81-20.22 90.79-49.22 127.77-86.2 36.98-36.98 65.98-79.97 86.2-127.77 20.87-49.35 31.46-101.93 31.46-156.28 0-54.35-10.58-106.93-31.46-156.28-20.22-47.8-49.22-90.79-86.2-127.77-36.98-36.98-79.97-65.98-127.77-86.2-49.35-20.87-101.93-31.46-156.28-31.46-54.35 0-106.93 10.58-156.28 31.46-47.8 20.22-90.79 49.22-127.77 86.2-36.98 36.98-65.98 79.96-86.2 127.77-20.87 49.35-31.46 101.93-31.46 156.28 0 54.35 10.58 106.93 31.46 156.28 20.22 47.8 49.22 90.79 86.2 127.77 36.98 36.98 79.97 65.98 127.77 86.2 49.35 20.87 101.93 31.46 156.28 31.46Z"
        />
        <path
          fill="#EFEFEF"
          fillRule="nonzero"
          d="M1466.67 1739.17c36.5 0 71.69-7.06 104.61-20.98 32-13.53 60.81-32.99 85.65-57.83 24.84-24.84 44.3-53.66 57.83-85.65 13.92-32.92 20.98-68.11 20.98-104.61s-7.06-71.7-20.98-104.61c-13.53-31.99-32.99-60.81-57.83-85.65-24.84-24.84-53.66-44.3-85.65-57.83-32.91-13.92-68.11-20.98-104.61-20.98s-71.7 7.06-104.61 20.98c-31.99 13.53-60.81 32.99-85.65 57.83-24.84 24.84-44.29 53.65-57.83 85.65-13.92 32.92-20.98 68.11-20.98 104.61s7.06 71.7 20.98 104.61c13.53 31.99 32.99 60.81 57.83 85.65 24.84 24.84 53.65 44.29 85.65 57.82 32.92 13.92 68.11 20.98 104.61 20.98v.01Z"
        />
        <path
          fill="#EA5757"
          fillRule="nonzero"
          d="M1466.67 1606.53c18.65 0 36.46-3.53 52.94-10.5 16.18-6.85 30.83-16.76 43.53-29.46 12.7-12.7 22.61-27.35 29.46-43.53 6.97-16.48 10.5-34.29 10.5-52.94s-3.53-36.46-10.5-52.94c-6.85-16.18-16.75-30.83-29.45-43.53-12.71-12.71-27.35-22.62-43.53-29.46-16.48-6.97-34.29-10.5-52.94-10.5s-36.46 3.53-52.94 10.5c-16.18 6.84-30.83 16.76-43.53 29.46-12.7 12.7-22.61 27.34-29.45 43.53-6.97 16.48-10.5 34.29-10.5 52.94s3.53 36.46 10.5 52.94c6.85 16.18 16.76 30.83 29.46 43.53 12.7 12.7 27.34 22.61 43.52 29.45 16.48 6.97 34.29 10.5 52.94 10.5l-.01.01Z"
        />
        <path
          fill="#3F3F3F"
          fillRule="nonzero"
          d="m2226.584 2417.209 7.702 3.304a9.26 9.26 0 0 1 4.859 12.16l-32.752 76.342a9.26 9.26 0 0 1-12.115 4.878l-5.978 12.057-6.48-2.71 4.645-12.7-.183-.081a9.26 9.26 0 0 1-4.61-12.05l32.752-76.341a9.26 9.26 0 0 1 12.16-4.859Zm-454.474 5.1 7.25 4.204a9.26 9.26 0 0 1 3.364 12.656l-41.673 71.861a9.26 9.26 0 0 1-12.458 3.477l-7.513 11.443-6.11-3.47 6.238-12.253-.062-.036a9.26 9.26 0 0 1-3.365-12.655l41.673-71.861a9.26 9.26 0 0 1 12.656-3.365Zm-910.489.907 36.024 74.853a9.26 9.26 0 0 1-4.268 12.33l5.173 12.451-6.3 3.1-6.541-11.862-.19.09a9.26 9.26 0 0 1-12.113-4.444l-36.024-74.852a9.26 9.26 0 0 1 4.328-12.36l7.551-3.634a9.26 9.26 0 0 1 12.36 4.328Zm-153.904-4.238 6.012 82.852a9.26 9.26 0 0 1-8.44 9.896l.241 13.654-7 .57-1.745-13.608-.248.016a9.26 9.26 0 0 1-9.638-8.581l-6.011-82.853a9.26 9.26 0 0 1 8.565-9.905l8.358-.607a9.26 9.26 0 0 1 9.906 8.566Zm1572.658-7.99 8.287 1.241a9.26 9.26 0 0 1 7.786 10.53l-12.307 82.153a9.26 9.26 0 0 1-10.425 7.801l-2.736 13.237-6.96-.98 1.266-13.52-.227-.037a9.26 9.26 0 0 1-7.521-10.486l12.307-82.154a9.26 9.26 0 0 1 10.53-7.785ZM784.637 2428.57l46.32 68.958a9.26 9.26 0 0 1-2.441 12.793l6.934 11.659-5.8 3.97-8.208-10.878-.198.13a9.26 9.26 0 0 1-12.618-2.675l-46.32-68.957a9.26 9.26 0 0 1 2.524-12.85l6.956-4.673a9.26 9.26 0 0 1 12.85 2.523Z"
        />
      </g>
    </svg>
  );
}

export function SurveyCompletionSvg(
  props: IconProps & SVGAttributes<SVGElement>
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2934 2934" {...props}>
      <g fill="none" fillRule="evenodd">
        <circle cx="1466.67" cy="1466.67" r="1466.67" fill="#E1E5E6" />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M1845.51 593.53H855.55c-42.24 0-76.48 34.25-76.48 76.49V2263.4c0 42.23 34.24 76.48 76.48 76.48h1221.79c42.24 0 76.48-34.24 76.48-76.48V901.84l-308.31-308.31Z"
        />
        <path
          fill="#A0A6AA"
          fillRule="nonzero"
          d="M1077.59 1166h202.58v72.04h-202.58V1166Zm481.58 133.51h296.17v72.07h-296.17v-72.07Zm57.59 204.09h-539.17v-72.04h539.17v72.04Zm-539.47 53.02h202.58v72.04h-202.58v-72.04Zm278.97 132.03h287.91v72.07h-287.91v-72.07Z"
        />
        <path
          fill="#C1C6C9"
          fillRule="nonzero"
          d="M2012.17 1020.67v892h-1091v-892h1091Zm-20 20h-1051v852h1051v-852Zm-673.02 647.98v72.07h-241.86v-72.07h241.86Zm535.89-132.03v72.04h-539.17v-72.04h539.17Zm.3-125.06v72.04h-202.58v-72.04h202.58Zm-332.52-133.03v72.07H1357v-72.07h165.82Zm-203.37-.51v72.07h-241.86v-72.07h241.86ZM1855.34 1166v72.04h-539.17V1166h539.17Zm-9.39-572.53 308.31 308.31h-231.08c-42.224 0-76.538-33.882-77.22-75.953l-.01-1.277V593.47Z"
        />
        <path
          fill="#F8B705"
          d="M1295.86 2412.57a110.71 110.71 0 0 1 1.555 4.681l.416 1.363.404 1.358.582 2.008 1.413 4.979.321 1.111.476 1.592.508 1.66.514 1.644.529 1.646.545 1.645.185.548.377 1.095.385 1.093.395 1.09.404 1.086.414 1.083.424 1.078.217.538.441 1.07c.224.534.452 1.065.685 1.594l.472 1.055c4.465 9.805 10.642 18.627 20.368 24.243 11.322 6.54 20.775 8.268 30.865 8.775l1.145.053.574.022 1.155.04 1.162.03 1.76.036 2.378.032 6.155.06 2.563.04 1.965.045 1.333.039 1.351.048 1.371.057 5.708.279 1.479.08 1.396.084 1.322.092.843.067.816.073.791.08.768.088.748.097.367.052.722.111.356.06.7.129c1.855.36 3.594.855 5.418 1.568l.688.278.348.147.705.31c.118.054.238.108.357.164l.727.345.37.181.753.382c.255.132.513.268.775.408l.798.434.409.228.837.476.867.506.445.264-77.71 157.45-39.96-80.98-82.74 20.42 85.09-172.41Zm342.24 1.26 84.46 171.15-82.74-20.42-39.96 80.98-78.18-158.41.01-.01.319-.215.627-.412c.207-.134.412-.265.615-.392l.604-.37a29.485 29.485 0 0 1 3.548-1.84l.6-.249c1.409-.566 2.89-1.018 4.578-1.403l.737-.161.764-.154.794-.147c.27-.048.546-.095.827-.141l.862-.136.444-.067.918-.13.959-.128 1.002-.126 2.142-.249c9.01-1.001 17.547-1.101 26.53-.983l3.976.057 1.583.014c7.369.04 14.53-.294 21.691-2.738 6.12-2.09 11.41-5.44 16.12-9.85 7.787-7.292 12.404-16.625 16.117-26.416l.525-1.402.514-1.407.504-1.41.497-1.415.975-2.833 1.68-4.955.724-2.113.486-1.402.492-1.397c.165-.464.331-.927.499-1.389l.507-1.381a52.72 52.72 0 0 1 2.236-5.138l.414-.812Zm-170.66-358.02c8.938 0 14.758 2.408 20.573 6.355l.794.548.795.566.398.29.801.593.807.61.815.628.824.643 1.259.996 4.04 3.225 2.001 1.577 1.043.808.532.41 1.088.826a146.673 146.673 0 0 0 11.53 7.897l1.21.738 1.311.792.818.489.777.459.741.43.709.404c.115.065.23.13.343.192l.667.365.644.342c.211.11.42.215.625.318l.61.297a26.01 26.01 0 0 0 5.105 1.832l.655.155.336.074.694.144.725.136.759.132.797.127.84.125.884.123 1.423.185 1.017.125.53.064c.535.064 1.066.125 1.59.185l1.561.17 1.531.16 1.501.146 1.473.136 1.443.124 1.416.113 1.387.103 1.36.094 1.333.085 1.307.076 1.28.068 1.872.088 1.217.05 1.192.044 2.31.07 1.672.04 1.62.031 2.59.036 7.845.072 1.65.028 1.583.042 1.144.042.743.034 1.086.061.707.049.692.055.678.062.665.07.652.079.64.087c7.04 1.02 12.24 4.613 15.308 7.756l.415.436c.133.144.262.287.386.428l.359.418c.172.206.333.409.484.605l.288.387c8.428 11.704 12.24 22.042 15.129 31.447l.486 1.603.473 1.586 1.148 3.888.457 1.527.46 1.512c4.03 13.031 9.045 24.357 27.157 35.397l7.302 4.429 1.519.93 1.46.902 1.4.88.454.288.89.571 1.286.844.828.555c.271.185.539.369.803.552l.779.548c.256.182.508.364.756.546l.732.544c7.452 5.629 11.25 11.264 13.091 22.331 1.67 10.064-.02 17.714-2.68 24.78l-.352.918-.362.913-.37.908-.379.904-.579 1.35-.68 1.557-1.228 2.772-.49 1.115-.395.912-.392.917-.388.923-.38.93-.374.937-.365.945c-2.521 6.65-4.32 13.987-3.546 23.429.556 6.815 1.754 12.28 3.192 17.218l.336 1.131.17.56.347 1.106.353 1.094.357 1.083.542 1.61 1.456 4.256.361 1.068.357 1.074.353 1.082.347 1.094.17.55.337 1.114c2.38 8.033 4.106 17.317 3.362 31.58-.537 10.238-8.113 17.196-17.915 24.668l-1.45 1.097-2.227 1.666-3.05 2.271-1.55 1.164-1.566 1.185c-12.04 9.176-24.962 20.514-31.972 39.369l-.545 1.475-.782 2.156-.745 2.09-.942 2.684-2.75 7.974-.786 2.236-.387 1.082-.384 1.058-.384 1.036-.383 1.013-.385.992c-.064.163-.128.326-.193.487l-.388.96-.195.471-.395.928-.4.909c-.202.449-.406.89-.613 1.325l-.419.86c-2.045 4.112-4.422 7.58-7.694 10.644-6.077 5.69-12 7.165-19.886 7.462l-1.04.033-.528.011-1.075.015-.547.004-1.113.001-1.139-.006-1.76-.02-6.36-.096-1.37-.014-2.123-.01-1.46.002c-.74.004-1.494.01-2.263.021l-1.557.029-1.597.04-1.64.056-1.681.07c-3.407.16-7.075.423-11.043.843l-.998.109.01.02-1.79.207-1.145.141-1.109.145-1.074.148-1.042.153c-.342.052-.679.105-1.01.159l-.982.164-.953.17-.466.088-.914.182c-1.654.34-3.188.72-4.648 1.156l-.79.244c-2.739.874-5.238 1.967-7.818 3.397l-.74.417c-.371.214-.745.435-1.121.663l-.758.466-.768.486-.78.508-.793.529-.809.551-.825.575-.843.597-.864.622-.886.647-.908.672-1.411 1.056-1.473 1.117-.502.385-.98.762-.947.752-.918.74-.89.73-.862.717-1.248 1.055-1.198 1.026-4.048 3.507-1.035.883-.68.57-.672.554-.668.538-.664.523c-5.637 4.374-11.088 6.988-20.948 6.988-7.434 0-12.306-1.806-17.41-5.053l-.681-.442-.686-.458-.345-.236-1.046-.73-.708-.509-.718-.524-1.098-.815-1.514-1.143-3.669-2.79-1.32-.996-1.853-1.377-1.463-1.07-1.013-.728-1.045-.743-1.08-.756-1.114-.768-1.15-.781-.59-.395-1.208-.8-1.249-.812-1.29-.824-1.082-.68-1.051-.652-1.022-.624-.994-.597c-.327-.195-.65-.385-.969-.571l-.944-.545-.92-.52a82.512 82.512 0 0 0-3.07-1.633l-.84-.416-.827-.394a59.084 59.084 0 0 0-.408-.19l-.809-.363c-3.214-1.414-6.2-2.356-9.432-3.018l-.813-.16-.825-.148a58.995 58.995 0 0 0-.839-.138l-.854-.129-.87-.12-.442-.056-.899-.107-.92-.1-.942-.094-.966-.087-.993-.082-1.02-.077-1.584-.11-1.656-.101-2.932-.161-2.517-.127-1.396-.064-1.362-.055-1.33-.046-1.298-.038-1.89-.044-1.826-.031-2.34-.027-6.45-.048-1.498-.02-1.46-.03-.954-.028-.939-.033-.925-.04a92.233 92.233 0 0 1-.458-.024l-.908-.053-.45-.03-.891-.069c-6.653-.55-12.532-2.027-19.655-6.14-8.31-4.799-12.95-14.919-16.603-25.97l-.461-1.417-.227-.71-.448-1.427-.44-1.433-.648-2.153-2.11-7.138-.422-1.405-.425-1.393c-.071-.231-.142-.462-.214-.691l-.432-1.371-.218-.68-.44-1.344c-1.706-5.115-3.585-9.783-5.952-13.488-4.041-6.326-9.657-11.114-15.748-15.436l-1.147-.805-.577-.4-1.161-.79-1.168-.785-1.762-1.168-3.81-2.497-1.727-1.139-1.373-.916-.911-.615-.906-.62-.9-.625-.895-.63-.887-.638-.44-.322-.876-.65-.867-.657c-7.754-5.962-14.33-13.064-17.195-23.767-3.157-11.764-1.888-18.203 3.016-27.288l.494-.902c14.673-26.413 9.479-46.006 3.326-63.42l-.728-2.04-1.812-5.02-.354-.993-.694-1.975c-4.438-12.8-7.269-24.86-.038-38.252 2.254-4.178 6.48-8.394 11.587-12.593l.967-.787.491-.393.996-.787 1.012-.785 1.028-.785 1.04-.785 1.053-.783 1.063-.782 1.61-1.172 1.624-1.169 1.088-.777 6.538-4.65 2.074-1.489 1.53-1.112 1.004-.739 1.481-1.104 1.446-1.099.942-.73.463-.364.912-.726c5.107-4.109 9.17-8.096 10.981-11.899 5.91-12.405 8.646-21.423 10.387-28.518l.306-1.27.287-1.228.271-1.19.864-3.892.351-1.552.236-1 .119-.492.243-.964c1.892-7.307 4.546-12.69 13.866-20.114 5.98-4.762 14.202-6.267 23.292-6.696l1.19-.05c.398-.015.798-.028 1.2-.04l1.208-.028 1.216-.02 1.837-.015 1.851-.001 1.24.005 7.885.072 1.87.01 1.87-.003c7.156-.031 14.225-.374 20.641-1.924.298-.072.593-.146.886-.221l.872-.233.431-.12.855-.25a50.666 50.666 0 0 0 2.099-.685l.83-.299c2.345-.868 4.657-1.925 7.126-3.25l.879-.478.444-.248.902-.514.457-.265.93-.55.471-.285.961-.588.984-.615 1.01-.642 1.036-.67 1.61-1.059 1.113-.743 1.733-1.173 1.201-.822 1.19-.826.579-.407 1.123-.801 1.082-.785.526-.386 1.022-.76.986-.743.479-.365.933-.718 1.34-1.045 1.685-1.333 3.443-2.75 1.063-.838.692-.537.68-.52.67-.502.66-.484a51.75 51.75 0 0 1 1.308-.914l.65-.43c4.869-3.162 9.724-4.806 18.259-4.806Zm-.77 70.33c-83.37 0-150.96 67.59-150.96 150.96s67.59 150.96 150.96 150.96 150.96-67.59 150.96-150.96-67.59-150.96-150.96-150.96Z"
        />
        <path
          fill="#FFF"
          stroke="#FFF"
          strokeWidth="12"
          d="M1466.87 2124.31c84.5 0 153 68.5 153 153s-68.5 153-153 153-153-68.5-153-153 68.5-153 153-153"
        />
        <path
          fill="#EA5757"
          d="M1466.67 2148.9c70.8 0 128.2 57.4 128.2 128.2 0 70.8-57.4 128.2-128.2 128.2-70.8 0-128.2-57.4-128.2-128.2 0-70.8 57.4-128.2 128.2-128.2"
        />
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="m1417.8 2258.52 31.45 32.7 65.04-71.4 26.72 24.32-90.73 99.7-58.21-60.02z"
        />
      </g>
    </svg>
  );
}

export function PlayButtonSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      {...props}
    >
      <path d="M32 5.334c-14.72 0-26.667 11.947-26.667 26.667C5.333 46.72 17.28 58.667 32 58.667c14.72 0 26.667-11.946 26.667-26.666S46.72 5.334 32 5.334Zm-5.333 38.667V20l16 12-16 12Z" />
    </svg>
  );
}

export function IntercomSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 28 33"
      {...props}
    >
      <path
        d="M24.003 0A3.992 3.992 0 0 1 28 3.993v20.514c0 .092-.003.184-.01.275l-.008 7.365-8.44-3.647H3.997A3.992 3.992 0 0 1 0 24.507V3.993A3.998 3.998 0 0 1 3.997 0h20.006ZM5.476 20.085c-.732-.673-1.19-.209-1.431.1-.242.307-.233.855-.015 1.265.218.41 4.629 3.034 10.118 3.034 5.488 0 9.564-2.57 9.907-3.034.342-.464.458-.799 0-1.223-.459-.424-.638-.25-1.232.018-.595.268-4.49 2.586-8.76 2.547-4.27-.04-7.855-2.034-8.587-2.707Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

function RedoSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7083 2.29183C10.5 1.0835 8.84167 0.333496 7.00001 0.333496C3.31667 0.333496 0.341675 3.31683 0.341675 7.00016C0.341675 10.6835 3.31667 13.6668 7.00001 13.6668C10.1083 13.6668 12.7 11.5418 13.4417 8.66683H11.7083C11.025 10.6085 9.17501 12.0002 7.00001 12.0002C4.24167 12.0002 2.00001 9.7585 2.00001 7.00016C2.00001 4.24183 4.24167 2.00016 7.00001 2.00016C8.38334 2.00016 9.61667 2.57516 10.5167 3.4835L7.83334 6.16683H13.6667V0.333496L11.7083 2.29183Z"
        fill="#e50063"
      />
    </svg>
  );
}

function RetrySvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="2 -2 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_766_1926)">
        <path
          d="M9.9 20C8.28333 20 6.896 19.475 5.738 18.425C4.57933 17.375 4 16.0667 4 14.5C4 12.9333 4.57933 11.625 5.738 10.575C6.896 9.525 8.28333 9 9.9 9H16.2L13.6 6.4L15 5L20 10L15 15L13.6 13.6L16.2 11H9.9C8.85 11 7.93767 11.3333 7.163 12C6.38767 12.6667 6 13.5 6 14.5C6 15.5 6.38767 16.3333 7.163 17C7.93767 17.6667 8.85 18 9.9 18H17V20H9.9Z"
          fill="#3D3D3C"
        />
      </g>
      <defs>
        <clipPath id="clip0_766_1926">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function ContinueSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 -8 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.975 9.49541L12.9754 9.49502L12.9658 9.48537L11.6343 8.15387L10.3028 6.82236C10.1403 6.65989 9.94801 6.59344 9.76061 6.6058C9.57708 6.61792 9.40946 6.70465 9.28595 6.82815C9.16245 6.95165 9.07572 7.11928 9.06361 7.30281C9.05124 7.49021 9.1177 7.68251 9.28017 7.84498L10.7377 9.3025H10.7279H10.7093H10.6907H10.6721H10.6535H10.6349H10.6163H10.5977H10.5791H10.5605H10.5419H10.5233H10.5047H10.4861H10.4675H10.4489H10.4303H10.4117H10.3931H10.3745H10.3559H10.3373H10.3187H10.3H10.2814H10.2628H10.2442H10.2256H10.207H10.1884H10.1698H10.1512H10.1325H10.1139H10.0953H10.0767H10.0581H10.0395H10.0209H10.0022H9.98363H9.96501H9.94639H9.92777H9.90915H9.89054H9.87192H9.8533H9.83468H9.81606H9.79744H9.77882H9.7602H9.74158H9.72295H9.70433H9.68571H9.66708H9.64846H9.62984H9.61121H9.59259H9.57396H9.55534H9.53671H9.51809H9.49946H9.48083H9.46221H9.44358H9.42495H9.40632H9.3877H9.36907H9.35044H9.33181H9.31318H9.29455H9.27592H9.25729H9.23866H9.22002H9.20139H9.18276H9.16413H9.1455H9.12686H9.10823H9.0896H9.07096H9.05233H9.03369H9.01506H8.99642H8.97779H8.95915H8.94052H8.92188H8.90324H8.88461H8.86597H8.84733H8.82869H8.81006H8.79142H8.77278H8.75414H8.7355H8.71686H8.69822H8.67958H8.66094H8.6423H8.62366H8.60502H8.58638H8.56774H8.5491H8.53045H8.51181H8.49317H8.47453H8.45588H8.43724H8.4186H8.39995H8.38131H8.36267H8.34402H8.32538H8.30673H8.28809H8.26944H8.2508H8.23215H8.21351H8.19486H8.17621H8.15757H8.13892H8.12027H8.10163H8.08298H8.06433H8.04569H8.02704H8.00839H7.98974H7.97109H7.95244H7.9338H7.91515H7.8965H7.87785H7.8592H7.84055H7.8219H7.80325H7.7846H7.76595H7.7473H7.72865H7.71H7.69135H7.6727H7.65405H7.63539H7.61674H7.59809H7.57944H7.56079H7.54214H7.52348H7.50483H7.48618H7.46753H7.44887H7.43022H7.41157H7.39292H7.37426H7.35561H7.33696H7.3183H7.29965H7.28099H7.26234H7.24369H7.22503H7.20638H7.18772H7.16907H7.15042H7.13176H7.11311H7.09445H7.0758H7.05714H7.03849H7.01983H7.00118H6.98252H6.96387H6.94521H6.92656H6.9079H6.88925H6.87059H6.85193H6.83328H6.81462H6.79597H6.77731H6.75866H6.74H6.72134H6.70269H6.68403H6.66538H6.64672H6.62806H6.60941H6.59075H6.57209H6.55344H6.53478H6.51613H6.49747H6.47881H6.46016H6.4415H6.42284H6.40419H6.38553H6.36688H6.34822H6.32956H6.31091H6.29225H6.27359H6.25494H6.23628H6.21762H6.19897H6.18031H6.16165H6.143H6.12434H6.10569H6.08703H6.06837H6.04972H6.03106H6.0124H5.99375H5.97509H5.95644H5.93778H5.91912H5.90047H5.88181H5.86316H5.8445H5.82585H5.80719H5.78853H5.76988H5.75122H5.73257H5.71391H5.69526H5.6766H5.65795H5.63929H5.62064H5.60198H5.58333H5.56467H5.54602H5.52736H5.50871H5.49005H5.4714H5.45275H5.43409H5.41544H5.39678H5.37813H5.35948H5.34082H5.32217H5.30352H5.28486H5.26621H5.24756H5.2289H5.21025H5.1916H5.17295H5.15429H5.13564H5.11699H5.09834H5.07968H5.06103H5.04238H5.02373H5.00508H4.98643H4.96778H4.94913H4.93048H4.91182H4.89317H4.87452H4.85587H4.83722H4.81857H4.79992H4.78128H4.76263H4.74398H4.72533H4.70668H4.68803H4.66938H4.65073H4.63209H4.61344H4.59479H4.57614H4.5575H4.53885H4.5202H4.50156H4.48291H4.46426H4.44562H4.42697H4.40833H4.38968H4.37104H4.35239H4.33375H4.3151H4.29646H4.27781H4.25917H4.24053H4.22188H4.20324H4.1846H4.16595H4.14731H4.12867H4.11003H4.09139H4.07275H4.0541H4.03546H4.01682H3.99818H3.97954H3.9609H3.94226H3.92362H3.90498H3.88635H3.86771H3.84907H3.83043H3.81179H3.79316H3.77452H3.75588H3.73724H3.71861H3.69997H3.68134H3.6627H3.64407H3.62543H3.6068H3.58816H3.56953H3.55089H3.53226H3.51363H3.495H3.47636H3.45773H3.4391H3.42047H3.40184H3.38321H3.36458H3.34595H3.32732H3.30869H3.29006H3.27143H3.2528H3.23417H3.21554H3.19692H3.17829H3.15966H3.14104H3.12241H3.10379H3.08516H3.06654H3.04791H3.02929H3.01066H2.99204H2.97342H2.95479H2.93617H2.91755H2.89893H2.88031H2.86169H2.84307H2.82445H2.80583H2.78721H2.76859H2.74997H2.73135H2.71273H2.69412H2.6755H2.65688H2.63827H2.61965H2.60104H2.58242H2.56381H2.54519H2.52658H2.50797H2.48935H2.47074H2.45213H2.43352H2.41491H2.3963H2.37769H2.35908H2.34047H2.32186H2.30325H2.28464H2.26603H2.24743H2.22882H2.21021H2.19161H2.173H2.1544H2.1358H2.11719H2.09859H2.07999H2.06138H2.04278H2.02418H2.00558H1.98698H1.96838H1.94978H1.93118H1.91258H1.89398H1.87539H1.85679H1.83819H1.8196H1.801H1.78241H1.76381H1.74522H1.72662H1.70803H1.68944H1.67085H1.65225H1.63366H1.61507H1.59648H1.57789H1.5593C1.40281 9.3025 1.22601 9.35117 1.11723 9.45133C0.942178 9.57357 0.827472 9.7828 0.853722 10.041C0.926211 13.2585 2.54793 16.2694 5.34985 17.9178C10.4377 20.9561 17.286 18.1778 18.84 12.4092L18.8401 12.409C20.3948 6.59068 15.8963 0.968532 9.99214 0.850389C9.76435 0.843496 9.58195 0.928755 9.45869 1.06934C9.33833 1.20664 9.28255 1.38691 9.28255 1.56189C9.28255 1.73704 9.33834 1.9184 9.45613 2.06012C9.57636 2.20477 9.75568 2.30098 9.98362 2.30811L9.98504 2.30814C13.1252 2.3764 15.9861 4.21902 17.1431 7.14568L17.1434 7.14624C18.2786 9.98428 17.5748 13.3019 15.4395 15.4601C13.2821 17.6173 9.96505 18.2988 7.12628 17.1633L7.12588 17.1632C4.43173 16.0944 2.62983 13.56 2.32662 10.7372H2.33502H2.35239H2.36975H2.38711H2.40447H2.42183H2.43919H2.45655H2.47391H2.49126H2.50862H2.52598H2.54334H2.56069H2.57805H2.5954H2.61276H2.63011H2.64746H2.66482H2.68217H2.69952H2.71687H2.73423H2.75158H2.76893H2.78628H2.80363H2.82098H2.83832H2.85567H2.87302H2.89037H2.90771H2.92506H2.94241H2.95975H2.9771H2.99444H3.01179H3.02913H3.04647H3.06381H3.08116H3.0985H3.11584H3.13318H3.15052H3.16786H3.1852H3.20254H3.21988H3.23722H3.25456H3.2719H3.28923H3.30657H3.32391H3.34125H3.35858H3.37592H3.39325H3.41059H3.42792H3.44526H3.46259H3.47992H3.49726H3.51459H3.53192H3.54925H3.56658H3.58391H3.60125H3.61858H3.63591H3.65324H3.67056H3.68789H3.70522H3.72255H3.73988H3.75721H3.77453H3.79186H3.80919H3.82651H3.84384H3.86117H3.87849H3.89582H3.91314H3.93046H3.94779H3.96511H3.98244H3.99976H4.01708H4.0344H4.05173H4.06905H4.08637H4.10369H4.12101H4.13833H4.15565H4.17297H4.19029H4.20761H4.22493H4.24225H4.25957H4.27689H4.2942H4.31152H4.32884H4.34616H4.36347H4.38079H4.39811H4.41542H4.43274H4.45005H4.46737H4.48469H4.502H4.51931H4.53663H4.55394H4.57126H4.58857H4.60588H4.6232H4.64051H4.65782H4.67514H4.69245H4.70976H4.72707H4.74438H4.76169H4.77901H4.79632H4.81363H4.83094H4.84825H4.86556H4.88287H4.90018H4.91749H4.9348H4.95211H4.96941H4.98672H5.00403H5.02134H5.03865H5.05596H5.07326H5.09057H5.10788H5.12519H5.14249H5.1598H5.17711H5.19441H5.21172H5.22902H5.24633H5.26364H5.28094H5.29825H5.31555H5.33286H5.35016H5.36747H5.38477H5.40208H5.41938H5.43669H5.45399H5.47129H5.4886H5.5059H5.52321H5.54051H5.55781H5.57512H5.59242H5.60972H5.62702H5.64433H5.66163H5.67893H5.69624H5.71354H5.73084H5.74814H5.76544H5.78275H5.80005H5.81735H5.83465H5.85195H5.86925H5.88656H5.90386H5.92116H5.93846H5.95576H5.97306H5.99036H6.00766H6.02496H6.04226H6.05957H6.07687H6.09417H6.11147H6.12877H6.14607H6.16337H6.18067H6.19797H6.21527H6.23257H6.24987H6.26717H6.28447H6.30177H6.31907H6.33637H6.35367H6.37097H6.38827H6.40557H6.42287H6.44017H6.45747H6.47477H6.49207H6.50937H6.52666H6.54396H6.56126H6.57856H6.59586H6.61316H6.63046H6.64776H6.66506H6.68236H6.69966H6.71696H6.73426H6.75156H6.76886H6.78616H6.80346H6.82076H6.83806H6.85536H6.87266H6.88996H6.90726H6.92456H6.94186H6.95916H6.97646H6.99376H7.01106H7.02836H7.04566H7.06296H7.08026H7.09756H7.11486H7.13216H7.14946H7.16676H7.18406H7.20136H7.21867H7.23597H7.25327H7.27057H7.28787H7.30517H7.32247H7.33977H7.35708H7.37438H7.39168H7.40898H7.42628H7.44358H7.46089H7.47819H7.49549H7.51279H7.5301H7.5474H7.5647H7.582H7.59931H7.61661H7.63391H7.65122H7.66852H7.68582H7.70313H7.72043H7.73774H7.75504H7.77234H7.78965H7.80695H7.82426H7.84156H7.85887H7.87617H7.89348H7.91078H7.92809H7.9454H7.9627H7.98001H7.99731H8.01462H8.03193H8.04923H8.06654H8.08385H8.10116H8.11846H8.13577H8.15308H8.17039H8.1877H8.205H8.22231H8.23962H8.25693H8.27424H8.29155H8.30886H8.32617H8.34348H8.36079H8.3781H8.39541H8.41272H8.43003H8.44734H8.46465H8.48197H8.49928H8.51659H8.5339H8.55122H8.56853H8.58584H8.60316H8.62047H8.63778H8.6551H8.67241H8.68973H8.70704H8.72436H8.74167H8.75899H8.7763H8.79362H8.81094H8.82825H8.84557H8.86289H8.8802H8.89752H8.91484H8.93216H8.94948H8.9668H8.98412H9.00143H9.01875H9.03607H9.05339H9.07071H9.08804H9.10536H9.12268H9.14H9.15732H9.17465H9.19197H9.20929H9.22661H9.24394H9.26126H9.27859H9.29591H9.31324H9.33056H9.34789H9.36521H9.38254H9.39987H9.41719H9.43452H9.45185H9.46918H9.4865H9.50383H9.52116H9.53849H9.55582H9.57315H9.59048H9.60781H9.62514H9.64247H9.65981H9.67714H9.69447H9.7118H9.72914H9.74647H9.76381H9.78114H9.79847H9.81581H9.83315H9.85048H9.86782H9.88515H9.90249H9.91983H9.93717H9.95451H9.97184H9.98918H10.0065H10.0239H10.0412H10.0585H10.0759H10.0932H10.1106H10.1279H10.1453H10.1626H10.1799H10.1973H10.2146H10.232H10.2493H10.2667H10.284H10.3014H10.3187H10.3361H10.3534H10.3708H10.3881H10.4054H10.4228H10.4402H10.4575H10.4749H10.4922H10.5096H10.5269H10.5443H10.5616H10.579H10.5963H10.6137H10.631H10.6484H10.6657H10.6682L9.2107 12.1947C9.04763 12.3578 8.98275 12.5509 8.99753 12.7388C9.01198 12.9224 9.10136 13.0895 9.22592 13.2123C9.35044 13.335 9.51841 13.4217 9.70083 13.4339C9.88715 13.4462 10.0773 13.3798 10.2345 13.2162L12.9604 10.4903C13.1161 10.3616 13.1718 10.1762 13.1718 10.0083C13.1718 9.83184 13.1116 9.65942 12.975 9.49541Z"
        fill="#494947"
        stroke="#494947"
        strokeWidth="0.3"
      />
    </svg>
  );
}

function MailSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 -4 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <path
        d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM12 13L20 8V6L12 11L4 6V8L12 13Z"
        fill="#494947"
      />
    </svg>
  );
}

export function HamburgSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_983_2152)">
        <path
          d="M3 17C3 17.5523 3.44772 18 4 18H15C15.5523 18 16 17.5523 16 17C16 16.4477 15.5523 16 15 16H4C3.44772 16 3 16.4477 3 17ZM3 12C3 12.5523 3.44772 13 4 13H12C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11H4C3.44772 11 3 11.4477 3 12ZM4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6H4ZM20.2955 16.2945C20.6847 15.9053 20.6852 15.2743 20.2965 14.8845L17.42 12L20.2965 9.11549C20.6852 8.7257 20.6847 8.09474 20.2955 7.70549C19.9059 7.31586 19.2741 7.31586 18.8845 7.70549L14.59 12L18.8845 16.2945C19.2741 16.6841 19.9059 16.6841 20.2955 16.2945Z"
          fill="#313130"
        />
      </g>
      <defs>
        <clipPath id="clip0_983_2152">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ResubmitSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      {...props}
    >
      <path d="M10.5 18H18V20H10.5C6.91 20 4 17.09 4 13.5S6.91 7 10.5 7H16.17L13.08 3.91L14.5 2.5L20 8L14.5 13.5L13.09 12.09L16.17 9H10.5C8 9 6 11 6 13.5S8 18 10.5 18Z" />
    </svg>
  );
}

export function ActiveUsersSvg(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7635_1766)">
        <path
          d="M4.95 7.59375C5.42739 7.59375 5.88523 7.40608 6.22279 7.07203C6.56036 6.73798 6.75 6.28492 6.75 5.8125C6.75 5.34008 6.56036 4.88702 6.22279 4.55297C5.88523 4.21892 5.42739 4.03125 4.95 4.03125C4.47261 4.03125 4.01477 4.21892 3.67721 4.55297C3.33964 4.88702 3.15 5.34008 3.15 5.8125C3.15 6.28492 3.33964 6.73798 3.67721 7.07203C4.01477 7.40608 4.47261 7.59375 4.95 7.59375ZM4.95 2.69531C5.78543 2.69531 6.58665 3.02373 7.17739 3.60832C7.76813 4.1929 8.1 4.98577 8.1 5.8125C8.1 6.63923 7.76813 7.4321 7.17739 8.01668C6.58665 8.60127 5.78543 8.92969 4.95 8.92969C4.11457 8.92969 3.31335 8.60127 2.72261 8.01668C2.13187 7.4321 1.8 6.63923 1.8 5.8125C1.8 4.98577 2.13187 4.1929 2.72261 3.60832C3.31335 3.02373 4.11457 2.69531 4.95 2.69531ZM4.275 11.6016C2.66062 11.6016 1.35 12.8985 1.35 14.4961V14.9414C1.35 15.3116 1.04906 15.6094 0.675 15.6094C0.300937 15.6094 0 15.3116 0 14.9414V14.4961C0 12.161 1.91531 10.2656 4.275 10.2656H5.625C7.98469 10.2656 9.9 12.161 9.9 14.4961V14.9414C9.9 15.3116 9.59906 15.6094 9.225 15.6094C8.85094 15.6094 8.55 15.3116 8.55 14.9414V14.4961C8.55 12.8985 7.23937 11.6016 5.625 11.6016H4.275ZM13.05 7.59375C13.5274 7.59375 13.9852 7.40608 14.3228 7.07203C14.6604 6.73798 14.85 6.28492 14.85 5.8125C14.85 5.34008 14.6604 4.88702 14.3228 4.55297C13.9852 4.21892 13.5274 4.03125 13.05 4.03125C12.5726 4.03125 12.1148 4.21892 11.7772 4.55297C11.4396 4.88702 11.25 5.34008 11.25 5.8125C11.25 6.28492 11.4396 6.73798 11.7772 7.07203C12.1148 7.40608 12.5726 7.59375 13.05 7.59375ZM13.05 2.69531C13.8854 2.69531 14.6866 3.02373 15.2774 3.60832C15.8681 4.1929 16.2 4.98577 16.2 5.8125C16.2 6.63923 15.8681 7.4321 15.2774 8.01668C14.6866 8.60127 13.8854 8.92969 13.05 8.92969C12.2146 8.92969 11.4134 8.60127 10.8226 8.01668C10.2319 7.4321 9.9 6.63923 9.9 5.8125C9.9 4.98577 10.2319 4.1929 10.8226 3.60832C11.4134 3.02373 12.2146 2.69531 13.05 2.69531ZM14.085 14.2734C15.5025 14.2734 16.65 13.1379 16.65 11.7352C16.65 11.6628 16.5881 11.6016 16.515 11.6016H10.4316C10.1278 11.1089 9.74813 10.6664 9.31219 10.2907C9.40219 10.274 9.49219 10.2656 9.58781 10.2656H16.5178C17.3391 10.2656 18.0028 10.9225 18.0028 11.7352C18.0028 13.8754 16.2506 15.6094 14.0878 15.6094H12.0178C11.7253 15.6094 11.4412 15.5788 11.1684 15.5175C11.2247 15.3338 11.2528 15.1418 11.2528 14.9414V14.4961C11.2528 14.382 11.25 14.2679 11.2416 14.1565C11.4862 14.2345 11.7478 14.2734 12.0178 14.2734H14.0878H14.085Z"
          fill="#6E6E6B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7635_1766">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PercentIconBG(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="123"
      height="98"
      viewBox="0 0 123 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="1"
        d="M5.15381 105.349C5.15381 107.796 6.07901 110.244 7.95925 112.094C11.6899 115.825 17.7485 115.825 21.4791 112.094L116.983 16.5897C118.834 14.7393 119.789 12.292 119.789 9.84473C119.789 7.39743 118.864 4.95013 116.983 3.09974C113.253 -0.630902 107.194 -0.630902 103.464 3.09974L7.95925 98.6041C6.07901 100.455 5.15381 102.902 5.15381 105.349Z"
        fill="#E4E4E4"
      />
      <path
        d="M24.2547 38.4957C29.3206 38.4957 34.1789 36.4833 37.761 32.9012C41.3432 29.3191 43.3556 24.4607 43.3556 19.3948C43.3556 14.329 41.3432 9.47057 37.761 5.88846C34.1789 2.30635 29.3206 0.293945 24.2547 0.293945C19.1888 0.293945 14.3304 2.30635 10.7483 5.88846C7.16622 9.47057 5.15381 14.329 5.15381 19.3948C5.15381 24.4607 7.16622 29.3191 10.7483 32.9012C14.3304 36.4833 19.1888 38.4957 24.2547 38.4957ZM100.658 114.899C105.724 114.899 110.582 112.887 114.165 109.305C117.747 105.723 119.759 100.864 119.759 95.7983C119.759 90.7325 117.747 85.8741 114.165 82.292C110.582 78.7099 105.724 76.6975 100.658 76.6975C95.5923 76.6975 90.7339 78.7099 87.1518 82.292C83.5697 85.8741 81.5573 90.7325 81.5573 95.7983C81.5573 100.864 83.5697 105.723 87.1518 109.305C90.7339 112.887 95.5923 114.899 100.658 114.899Z"
        fill="#E4E4E4"
      />
    </svg>
  );
}

export function ClockIconBG(props: IconProps & SVGAttributes<SVGElement>) {
  return (
    <svg
      width="111"
      height="96"
      viewBox="0 0 111 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7538_1958)">
        <path
          opacity="0.4"
          d="M0 65C0 82.2391 6.8482 98.7721 19.0381 110.962C31.2279 123.152 47.7609 130 65 130C82.2391 130 98.7721 123.152 110.962 110.962C123.152 98.7721 130 82.2391 130 65C130 47.7609 123.152 31.2279 110.962 19.0381C98.7721 6.8482 82.2391 0 65 0C47.7609 0 31.2279 6.8482 19.0381 19.0381C6.8482 31.2279 0 47.7609 0 65ZM58.9062 30.4688C58.9316 27.0664 61.6484 24.375 65 24.375C66.6758 24.375 68.1992 25.0605 69.3164 26.1523C69.875 26.7109 70.3066 27.3711 70.6113 28.082C70.7637 28.4375 70.8906 28.8184 70.9668 29.2246C71.0176 29.4277 71.043 29.6309 71.0684 29.834C71.0938 30.0371 71.0938 30.2402 71.0938 30.4688C71.0938 40.8789 71.0938 51.3145 71.0938 61.75L92.752 76.1719C94.5039 77.3398 95.4688 79.2695 95.4688 81.25C95.4688 82.418 95.1387 83.5859 94.4531 84.627C93.2852 86.3789 91.3555 87.3438 89.375 87.3438C88.207 87.3438 87.0391 87.0137 85.998 86.3281C77.873 80.9199 69.748 75.4863 61.623 70.0781C59.9219 68.9355 58.9062 67.0312 58.9062 65C58.9062 53.498 58.9062 41.9707 58.9062 30.4688Z"
          fill="#F2F2F1"
        />
        <path
          d="M65 24.375C61.623 24.375 58.9062 27.0918 58.9062 30.4688V65C58.9062 67.0312 59.9219 68.9355 61.623 70.0781L85.9981 86.3281C88.791 88.207 92.5742 87.4453 94.4531 84.6269C96.332 81.8086 95.5703 78.0508 92.7519 76.1719L71.0938 61.75V30.4688C71.0938 27.0918 68.377 24.375 65 24.375Z"
          fill="#F2F2F1"
        />
      </g>
      <defs>
        <clipPath id="clip0_7538_1958">
          <rect width="130" height="130" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const ResubmitIcon = styled(ResubmitSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const DecagramIcon = styled(
  DecagramCheckIcon,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TuneRoundedIcon = styled(
  TuneRoundedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const SubscriptionsIcon = styled(
  SubscriptionsIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const SubscriptionsOutlinedIcon = styled(
  SubscriptionsOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TopicIcon = styled(TopicIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const TopicOutlinedIcon = styled(
  TopicOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FileTreeIcon = styled(
  FileTreeIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FileTreeOutlinedIcon = styled(
  FileTreeOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const HeadGearIcon = styled(HeadGearSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const WaveFormIcon = styled(WaveFormSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const HamburgIcon = styled(HamburgSvg, withTransientProps)<IconProps>`
  ${base}
`;

export function BigSpringLogoSvg(props: IconProps) {
  return <BigSpringBaseSvg wordMark {...props} />;
}

export function BigSpringLogoV2Svg(props: IconProps) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="110 0 204 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <linearGradient
          id="paint0_linear_1168_6974"
          x1="35.116"
          y1="46.9151"
          x2="59.285"
          y2="4.79244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005BEA" />
          <stop offset="1" stopColor="#00C6FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1168_6974"
          x1="33.6145"
          y1="32.6149"
          x2="-2.73096"
          y2="92.1246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#21D4FD" />
          <stop offset="1" stopColor="#B721FF" />
        </linearGradient>
      </defs>
      <path
        d="M186.415 35.1l3.651-2.473a6.593 6.593 0 001.969 2.417 4.845 4.845 0 002.821.759 4.601 4.601 0 003.075-.979 3.881 3.881 0 001.106-3.12V29.23h-.077a4.605 4.605 0 01-1.958 1.714 6.453 6.453 0 01-3.02.726 8.566 8.566 0 01-3.524-.689 8.512 8.512 0 01-2.926-2.07 10.636 10.636 0 01-2.599-7.593 10.448 10.448 0 012.677-7.55 8.452 8.452 0 012.847-2.062 8.5 8.5 0 013.447-.729 6.278 6.278 0 012.949.569 6.235 6.235 0 012.339 1.87h.066v-1.9h4.724V31.11a8.382 8.382 0 01-.546 3.574 8.45 8.45 0 01-1.998 3.02 9.466 9.466 0 01-6.582 2.285 10.009 10.009 0 01-5.255-1.34 7.819 7.819 0 01-3.142-3.55h-.044zm12.677-11.781v-4.044a3.828 3.828 0 00-1.172-2.835 4.23 4.23 0 00-3.131-1.165 4.429 4.429 0 00-3.562 1.56 6.566 6.566 0 00-1.361 4.484 6.57 6.57 0 001.383 4.483 4.55 4.55 0 003.54 1.56 4.24 4.24 0 003.131-1.175 3.855 3.855 0 001.172-2.868zm-33.928 7.802V11.517h4.702v1.89h.077a6.396 6.396 0 012.213-1.737 6.672 6.672 0 013.009-.703 6.878 6.878 0 012.801.427 6.839 6.839 0 012.387 1.518 7.394 7.394 0 011.88 5.374V31.12h-4.801V19.473a4.964 4.964 0 00-.785-3.044 3.212 3.212 0 00-2.71-1.011 3.828 3.828 0 00-2.821 1.01 3.69 3.69 0 00-1.007 2.715v11.978h-4.945zm-9.226-22.56h4.901V4h-4.879l-.022 4.56zm0 22.56h4.901V11.517h-4.879l-.022 19.604zm-12.766 0v-19.78h4.624v2.088h.078a4.404 4.404 0 011.67-1.792 4.514 4.514 0 012.423-.67 4.45 4.45 0 011.792.374l-.741 4.703a4.664 4.664 0 00-1.549-.308c-2.272 0-3.407 1.506-3.407 4.517V31.11l-4.89.011zm-21.981 8.319V11.517h4.668v1.879h.078l.188-.275c.175-.21.372-.401.586-.572a8.06 8.06 0 011.04-.747c.48-.262.994-.458 1.527-.582a7.79 7.79 0 012.057-.264 8.327 8.327 0 013.399.735 8.282 8.282 0 012.796 2.056 10.514 10.514 0 012.666 7.56 10.746 10.746 0 01-2.588 7.594 8.129 8.129 0 01-2.806 2.071 8.18 8.18 0 01-3.422.71 7.37 7.37 0 01-2.014-.264 6.235 6.235 0 01-1.493-.605 9.747 9.747 0 01-.974-.703 4.437 4.437 0 01-.608-.615l-.144-.253h-.077V39.44h-4.879zm4.89-20.165v4.044a3.855 3.855 0 001.172 2.868 4.23 4.23 0 003.131 1.176 4.55 4.55 0 003.54-1.56 6.57 6.57 0 001.383-4.484 6.56 6.56 0 00-1.361-4.484 4.429 4.429 0 00-3.562-1.56 4.232 4.232 0 00-3.131 1.165 3.845 3.845 0 00-1.172 2.835zm-27.424 3.132l5.299-1.154a9.494 9.494 0 001.593 4.395A4.452 4.452 0 00109.155 27a6.604 6.604 0 003.396-.758 2.487 2.487 0 001.261-2.253 2.717 2.717 0 00-.287-1.354 2.738 2.738 0 00-.918-1.041 24.424 24.424 0 00-5.532-2.198 13.18 13.18 0 01-5.774-3.066 6.23 6.23 0 01-1.693-4.396 6.836 6.836 0 012.368-5.22 9.208 9.208 0 016.438-2.198c2.256-.06 4.478.562 6.372 1.78a7.865 7.865 0 013.319 5.308l-4.835 1.253a5.183 5.183 0 00-1.179-2.042 5.24 5.24 0 00-4.315-1.635 5.253 5.253 0 00-2.249.743 2.394 2.394 0 00-.952 1.967 1.957 1.957 0 001.107 1.77l.143.076a43.777 43.777 0 004.425 1.704l1.029.351a15 15 0 015.941 3.21 6.567 6.567 0 011.582 4.67 7.268 7.268 0 01-2.611 5.714 10.266 10.266 0 01-6.98 2.275c-2.603.119-5.16-.71-7.191-2.33a10.27 10.27 0 01-3.319-6.923h-.044zM78.38 35.099l3.65-2.472a6.602 6.602 0 001.958 2.417 4.87 4.87 0 002.832.759 4.623 4.623 0 003.076-.979 3.898 3.898 0 001.106-3.12V29.23h-.078a4.604 4.604 0 01-1.958 1.714 6.451 6.451 0 01-3.02.726 8.546 8.546 0 01-3.525-.687 8.495 8.495 0 01-2.924-2.072 10.593 10.593 0 01-2.6-7.593 10.452 10.452 0 012.677-7.55 8.427 8.427 0 012.847-2.064 8.478 8.478 0 013.448-.727 6.23 6.23 0 012.945.566 6.186 6.186 0 012.332 1.874h.077v-1.901h4.68V31.11a8.4 8.4 0 01-.546 3.574 8.446 8.446 0 01-1.999 3.02 9.475 9.475 0 01-6.637 2.285 9.92 9.92 0 01-5.3-1.33 7.819 7.819 0 01-3.14-3.549l.099-.01zm12.677-11.78v-4.044a3.834 3.834 0 00-1.172-2.835 4.229 4.229 0 00-3.164-1.165 4.45 4.45 0 00-3.551 1.56 6.563 6.563 0 00-1.361 4.484 6.564 6.564 0 001.405 4.483 4.527 4.527 0 003.507 1.56 4.262 4.262 0 003.141-1.175 3.877 3.877 0 001.173-2.868h.022zM69.021 8.56h4.89V4h-4.89v4.56zm0 22.561h4.89V11.517h-4.89V31.12zM51.155 15.54h5.41a3.656 3.656 0 002.4-.726 2.67 2.67 0 00.874-2.197 2.873 2.873 0 00-.852-2.198 3.601 3.601 0 00-2.422-.748h-5.41v5.869zm0 10.747h6.15c2.412 0 3.618-1.14 3.618-3.418a3.124 3.124 0 00-.962-2.44 3.8 3.8 0 00-2.622-.856h-6.184v6.714zM46 31.12V5.077h11.118a7.79 7.79 0 013.01.463c.963.35 1.846.888 2.598 1.58a6.657 6.657 0 011.585 2.263c.364.855.544 1.777.528 2.705a5.367 5.367 0 01-.717 2.863 5.414 5.414 0 01-2.126 2.06 6.286 6.286 0 012.755 2.253 6.355 6.355 0 011.106 3.703 7.898 7.898 0 01-.546 3.243 7.94 7.94 0 01-1.821 2.746c-1.52 1.466-4.027 2.198-7.523 2.198L46 31.121z"
        transform="translate(5,5) scale(2)"
        fill="#052555"
      />
      <path
        d="M15.7866 26.1752C6.97201 23.4102 0 23.6095 0 11.5286C0 5.39296 4.97389 0.419074 11.1095 0.419074H39.0681C42.6707 0.395868 46.2664 0.738042 49.8 1.44035C52.8135 2.0145 55.688 3.16472 58.266 4.828C60.5859 6.38934 62.4503 8.53812 63.6693 11.0553C65.0289 14.0646 65.6846 17.3444 65.5866 20.6453C65.7364 24.2981 64.7347 27.9056 62.7231 30.9577C60.8715 33.7282 57.8116 36.3999 54.78 37.7817"
        fill="url(#paint0_linear_1168_6974)"
      />
      <path
        d="M55.3029 37.4315C59.5112 39.5592 63.22 42.5562 66.1843 46.2244C68.7464 49.9771 70.0779 54.4343 69.994 58.9779C70.0811 62.7809 69.2256 66.5463 67.504 69.938C65.9313 72.9194 63.6689 75.4815 60.9054 77.4107C58.027 79.4158 54.8145 80.8919 51.4185 81.7698C47.8442 82.7199 44.1609 83.1972 40.4625 83.1897C18.1157 83.1897 0 65.074 0 42.7271V37.7802C0 29.1866 6.44911 25.3256 15.9858 26.3469C29.5162 28.3223 42.7326 32.0483 55.3029 37.4315Z"
        fill="url(#paint1_linear_1168_6974)"
      />
    </svg>
  );
}

export const ListCheckIcon = styled(
  ListCheckSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FileUploadIcon = styled(
  FileUploadMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FilterIcon = styled(FilterIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ReplayIcon = styled(RedoSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const RetryIcon = styled(RetrySvg, withTransientProps)<IconProps>`
  ${base}
`;

export const ContinueIcon = styled(ContinueSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const MailIcon = styled(MailSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const AccountCircleIcon = styled(
  AccountCircleIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CancelCircleIcon = styled(
  CancelCircleIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CheckCircleIcon = styled(
  CheckCircleIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CheckShieldIcon = styled(
  CheckShieldIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CheckIcon = styled(CheckIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const RadioButtonUncheckedIcon = styled(
  RadioButtonUncheckedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CalendarBlankIcon = styled(
  CalendarBlankIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const WarningIcon = styled(
  WarningIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const QuestionMarkIcon = styled(
  QuestionMarkIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const QuestionMarkOutlinedIcon = styled(
  QuestionMarkOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LinkIcon = styled(LinkIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const LaunchIcon = styled(LaunchIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ChevronDownIcon = styled(
  ChevronDownIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ChevronUpIcon = styled(
  ChevronUpIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ChevronLeftIcon = styled(
  ChevronLeftIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ChevronRightIcon = styled(
  ChevronRightIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CoachIconNew = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.8334 5.83333H15.1667V22.1667H12.8334V5.83333ZM5.83341 14C7.11675 14 8.16675 12.95 8.16675 11.6667C8.16675 10.3833 7.11675 9.33333 5.83341 9.33333C4.55008 9.33333 3.50008 10.3833 3.50008 11.6667C3.50008 12.95 4.55008 14 5.83341 14ZM9.07675 15.8433C8.08508 15.4117 6.98841 15.1667 5.83341 15.1667C4.67841 15.1667 3.58175 15.4117 2.59008 15.8433C1.72675 16.2167 1.16675 17.0567 1.16675 18.0017V18.6667H10.5001V18.0017C10.5001 17.0567 9.94008 16.2167 9.07675 15.8433ZM22.1667 14C23.4501 14 24.5001 12.95 24.5001 11.6667C24.5001 10.3833 23.4501 9.33333 22.1667 9.33333C20.8834 9.33333 19.8334 10.3833 19.8334 11.6667C19.8334 12.95 20.8834 14 22.1667 14ZM25.4101 15.8433C24.4184 15.4117 23.3217 15.1667 22.1667 15.1667C21.0117 15.1667 19.9151 15.4117 18.9234 15.8433C18.0601 16.2167 17.5001 17.0567 17.5001 18.0017V18.6667H26.8334V18.0017C26.8334 17.0567 26.2734 16.2167 25.4101 15.8433Z"
        fill="#555553"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
  path {
    fill: ${({ $active }) => ($active ? "#e50063" : "#959592")};
  }
`;

export const ArrowDropDownIcon = styled(
  ArrowDropDownIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ArrowLeftIcon = styled(
  ArrowLeftIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ArrowRightIcon = styled(
  ArrowRightIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LockIcon = styled(LockIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const EyeIcon = styled(EyeIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const EyeOutlinedIcon = styled(
  EyeOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ErrorOutlineIcon = styled(
  ErrorOutlineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AccountGroupIcon = styled(
  AccountGroupIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AccountGroupOutlinedIcon = styled(
  AccountGroupOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const BookOpenVariantIcon = styled(
  BookOpenVariantIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FileDocumentIcon = styled(
  FileDocumentIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AccountBoxIcon = styled(
  AccountBoxIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ProfileBoxIcon = styled(
  ProfileBoxIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LabelIcon = styled(LabelIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ViewDashboardIcon = styled(
  ViewDashboardIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ViewStreamIcon = styled(
  ViewStreamIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PenIcon = styled(PenIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const VideoCamIcon = styled(
  VideoCamIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const VideoCamOffIcon = styled(
  VideoCamOffIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ImageIcon = styled(ImageIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ImageIconOutlined = styled(
  ImageIconOutlinedMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const SortIcon = styled(SortIconMui)<IconProps>`
  ${base}
`;

export const FirstPageIcon = styled(
  FirstPageIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const KeyboardArrowLeft = styled(
  KeyboardArrowLeftMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const KeyboardArrowRight = styled(
  KeyboardArrowRightMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LastPageIcon = styled(
  LastPageIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PdfIcon = styled(PdfIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const PlusIcon = styled(PlusIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const DeleteIcon = styled(DeleteIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const DownloadForOfflineIcon = styled(
  DownloadForOfflineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FlashCardIcon = styled(
  (props: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_715_9640)">
        <path
          d="M17.8011 2.68726H7.80106C6.70106 2.68726 5.80106 3.58726 5.80106 4.68726V20.6873C5.80106 21.7873 6.70106 22.6873 7.80106 22.6873H17.8011C18.9011 22.6873 19.8011 21.7873 19.8011 20.6873V4.68726C19.8011 3.58726 18.9011 2.68726 17.8011 2.68726ZM17.8011 19.6873C17.8011 20.2395 17.3533 20.6873 16.8011 20.6873H8.80106C8.24877 20.6873 7.80106 20.2395 7.80106 19.6873V5.68726C7.80106 5.13497 8.24877 4.68726 8.80106 4.68726H16.8011C17.3533 4.68726 17.8011 5.13497 17.8011 5.68726V19.6873Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_715_9640">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.801056 0.687256)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LogoutIcon = styled(
  (props: IconProps) => (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="m17 7-1.4 1.4 2.6 2.6H8v2h10.2l-2.6 2.6L17 17l5-5-5-5Z" />
      <path d="M4 19h8v2H4c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h8v2H4v14Z" />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CloseIcon = styled(CloseIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ExpandMoreIcon = styled(
  ExpandMoreIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const EditIcon = styled(EditIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const InfoIcon = styled(InfoIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const InfoOutlinedIcon = styled(
  InfoOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ProScoreSkillIcon = styled(
  ProScoreSkillSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ProScoreRepIcon = styled(
  ProScoreRepIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ProScoreSocialRepIcon = styled(
  ProScoreSocialRepSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const WaitingIcon = styled(WaitingSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const EnvelopeIcon = styled(EnvelopeSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const ProScoreCoinIcon = styled(
  ProScoreCoinSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const DragHandleIcon = styled(
  DragHandleIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const SettingIcon = styled(SettingSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const CoinIcon = styled(CoinSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const BlueAddIcon = styled(
  BlueAddIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const MoreHorizontalDots = styled(
  MoreHorizontalDotsSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ClockIcon = styled(ClockSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const ClockOutlinedIcon = styled(
  ClockOutlinedSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const NoPracticeIcon = styled(
  NoPracticeSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CoachProgressIcon = styled(
  CoachProgressSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CoachSuccessIcon = styled(
  CoachSuccessSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const BigSpringLogoIcon = styled(
  BigSpringLogoSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const BigSpringLogoV2Icon = styled(
  BigSpringLogoV2Svg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const BigSpringMarkIcon = styled(
  BigSpringBaseSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const RepsLogo = styled(RepsLogoBaseSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const BigSpringMarkV2Icon = styled(
  BigSpringBaseV2Svg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FeedbackIcon = styled(
  FeedbackIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FeedbackOutlineIcon = styled(
  FeedbackIconOutlineSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const LearnerIcon = styled(LearnerSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const RepIcon = styled(RepSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const RepIconNew = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_59_549)">
        <path
          d="M21 4.66667V23.3333C21.9028 23.3333 23.3333 23.4742 23.3333 22.1667V5.83333C23.3333 4.52577 21.9028 4.66667 21 4.66667Z"
          fill="#555553"
        />
        <path
          d="M28 8.16667V19.8333C28 21.1409 26.5695 21 25.6667 21V7C26.5695 7 28 6.85911 28 8.16667Z"
          fill="#555553"
        />
        <path
          d="M16.3333 2.33333H2.33333C1.05 2.33333 0 3.38333 0 4.66667V23.3333C0 24.6167 1.05 25.6667 2.33333 25.6667H16.3333C17.6167 25.6667 18.6667 24.6167 18.6667 23.3333V4.66667C18.6667 3.38333 17.6167 2.33333 16.3333 2.33333ZM16.3333 17.745C14.5833 16.8467 11.4333 16.3333 9.33333 16.3333C7.23333 16.3333 4.08333 16.8467 2.33333 17.745V5.83333C2.33333 5.189 2.85567 4.66667 3.5 4.66667H15.1667C15.811 4.66667 16.3333 5.189 16.3333 5.83333V17.745Z"
          fill="#555553"
        />
        <path
          d="M9.33333 14C11.2663 14 12.8333 12.433 12.8333 10.5C12.8333 8.567 11.2663 7 9.33333 7C7.40034 7 5.83333 8.567 5.83333 10.5C5.83333 12.433 7.40034 14 9.33333 14Z"
          fill="#555553"
        />
      </g>
      <defs>
        <clipPath id="clip0_59_549">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
  path {
    fill: ${({ $active }) => ($active ? "#e50063" : "#959592")};
  }
`;

export const CommunityIconNew = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_59_547"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="28"
        height="28"
      >
        <rect width="28" height="28" fill="white" />
      </mask>
      <g mask="url(#mask0_59_547)">
        <path
          d="M0 21V19.1625C0 18.3069 0.432833 17.6213 1.2985 17.1057C2.16339 16.5908 3.28611 16.3333 4.66667 16.3333C4.91944 16.3333 5.1625 16.338 5.39583 16.3473C5.62917 16.3574 5.85278 16.3819 6.06667 16.4208C5.79444 16.8097 5.59028 17.2278 5.45417 17.675C5.31806 18.1222 5.25 18.5986 5.25 19.1042V21H0ZM7 21V19.1042C7 17.8403 7.64672 16.8194 8.94017 16.0417C10.2328 15.2639 11.9194 14.875 14 14.875C16.1 14.875 17.7917 15.2639 19.075 16.0417C20.3583 16.8194 21 17.8403 21 19.1042V21H7ZM22.75 21V19.1042C22.75 18.5986 22.6866 18.1222 22.5598 17.675C22.4338 17.2278 22.2444 16.8097 21.9917 16.4208C22.2056 16.3819 22.4245 16.3574 22.6485 16.3473C22.8717 16.338 23.1 16.3333 23.3333 16.3333C24.7333 16.3333 25.8611 16.5908 26.7167 17.1057C27.5722 17.6213 28 18.3069 28 19.1625V21H22.75ZM4.66667 15.1667C4.025 15.1667 3.47589 14.938 3.01933 14.4807C2.562 14.0241 2.33333 13.475 2.33333 12.8333C2.33333 12.1722 2.562 11.6181 3.01933 11.1708C3.47589 10.7236 4.025 10.5 4.66667 10.5C5.32778 10.5 5.88194 10.7236 6.32917 11.1708C6.77639 11.6181 7 12.1722 7 12.8333C7 13.475 6.77639 14.0241 6.32917 14.4807C5.88194 14.938 5.32778 15.1667 4.66667 15.1667ZM23.3333 15.1667C22.6917 15.1667 22.1422 14.938 21.6848 14.4807C21.2283 14.0241 21 13.475 21 12.8333C21 12.1722 21.2283 11.6181 21.6848 11.1708C22.1422 10.7236 22.6917 10.5 23.3333 10.5C23.9944 10.5 24.5486 10.7236 24.9958 11.1708C25.4431 11.6181 25.6667 12.1722 25.6667 12.8333C25.6667 13.475 25.4431 14.0241 24.9958 14.4807C24.5486 14.938 23.9944 15.1667 23.3333 15.1667ZM14 14C13.0278 14 12.2014 13.6597 11.5208 12.9792C10.8403 12.2986 10.5 11.4722 10.5 10.5C10.5 9.50833 10.8403 8.67689 11.5208 8.00567C12.2014 7.33522 13.0278 7 14 7C14.9917 7 15.8227 7.33522 16.4932 8.00567C17.1644 8.67689 17.5 9.50833 17.5 10.5C17.5 11.4722 17.1644 12.2986 16.4932 12.9792C15.8227 13.6597 14.9917 14 14 14Z"
          fill="#555553"
        />
      </g>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
  path {
    fill: ${({ $active }) => ($active ? "#e50063" : "#959592")};
  }
`;

export const IntercomIcon = styled(IntercomSvg, withTransientProps)<IconProps>`
  ${base}
`;
export const PracticesIcon = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7635_1789)">
        <path
          d="M13.5 3V15C14.0807 15 15 15.0892 15 14.25V3.75C15 2.90943 14.0804 3 13.5 3Z"
          fill="#6E6E6B"
        />
        <path
          d="M18 5.25V12.75C18 13.5906 17.0804 13.5 16.5 13.5V4.5C17.0804 4.5 18 4.40943 18 5.25Z"
          fill="#6E6E6B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5 1.5H10.5C11.325 1.5 12 2.175 12 3V15C12 15.825 11.325 16.5 10.5 16.5H1.5C0.675 16.5 0 15.825 0 15V3C0 2.175 0.675 1.5 1.5 1.5ZM6 10.5C7.35 10.5 9.375 10.83 10.5 11.4075V3.75C10.5 3.33579 10.1642 3 9.75 3H2.25C1.83579 3 1.5 3.33579 1.5 3.75V11.4075C2.625 10.83 4.65 10.5 6 10.5ZM6 12C2.625 12 1.5 13.125 1.5 13.125V14.25C1.5 14.6642 1.83579 15 2.25 15H9.75C10.1642 15 10.5 14.6642 10.5 14.25V13.125C10.5 13.125 9.375 12 6 12Z"
          fill="#6E6E6B"
        />
        <path
          d="M6 9.375C7.45031 9.375 8.625 8.20031 8.625 6.75C8.625 5.29969 7.45031 4.125 6 4.125C4.54969 4.125 3.375 5.29969 3.375 6.75C3.375 8.20031 4.54969 9.375 6 9.375ZM6 5.4375C6.72188 5.4375 7.3125 6.02812 7.3125 6.75C7.3125 7.47188 6.72188 8.0625 6 8.0625C5.27812 8.0625 4.6875 7.47188 4.6875 6.75C4.6875 6.02812 5.27812 5.4375 6 5.4375Z"
          fill="#6E6E6B"
        />
      </g>
      <defs>
        <clipPath id="clip0_7635_1789">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const EmptyIcon = styled(
  () => (
    <svg
      width="90"
      height="81"
      viewBox="0 6 96 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52.8691 80.0004C73.9265 80.0004 90.998 62.8197 90.998 41.552C90.998 20.2842 73.8513 3.10352 52.8691 3.10352C31.8117 3.10352 14.7402 20.2842 14.7402 41.552C14.7402 62.8197 31.8117 80.0004 52.8691 80.0004Z"
        fill="#F1F3F3"
        stroke="#E1E5E6"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M88.5163 16.3478C90.2192 16.3478 91.5997 14.9585 91.5997 13.2447C91.5997 11.5309 90.2192 10.1416 88.5163 10.1416C86.8133 10.1416 85.4329 11.5309 85.4329 13.2447C85.4329 14.9585 86.8133 16.3478 88.5163 16.3478Z"
        fill="#F1F3F3"
      />
      <path
        d="M93.0283 4.23841C94.1913 4.23841 95.1341 3.28961 95.1341 2.11921C95.1341 0.948801 94.1913 0 93.0283 0C91.8654 0 90.9226 0.948801 90.9226 2.11921C90.9226 3.28961 91.8654 4.23841 93.0283 4.23841Z"
        fill="#F1F3F3"
      />
      <path
        d="M16.7707 16.2726C17.9336 16.2726 18.8764 15.3238 18.8764 14.1534C18.8764 12.983 17.9336 12.0342 16.7707 12.0342C15.6077 12.0342 14.6649 12.983 14.6649 14.1534C14.6649 15.3238 15.6077 16.2726 16.7707 16.2726Z"
        fill="#F1F3F3"
      />
      <path
        d="M3.91065 57.1428C6.07045 57.1428 7.82131 55.3808 7.82131 53.2072C7.82131 51.0335 6.07045 49.2715 3.91065 49.2715C1.75086 49.2715 0 51.0335 0 53.2072C0 55.3808 1.75086 57.1428 3.91065 57.1428Z"
        fill="#F1F3F3"
      />
      <path
        d="M78.8145 22.3272L79.4162 71.0689C79.4162 72.734 78.0625 74.0207 76.408 74.0207H29.1793C27.5248 74.0207 26.1711 72.6583 26.1711 71.0689V8.40097C26.1711 6.73588 27.5248 5.44922 29.1793 5.44922H63.3976L78.8145 22.3272Z"
        fill="white"
        stroke="#E1E5E6"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M49.1841 64.2569H39.9339C39.5579 64.2569 39.2571 63.8785 39.2571 63.4243C39.2571 62.9702 39.5579 62.5918 39.9339 62.5918H49.1841C49.5602 62.5918 49.861 62.9702 49.861 63.4243C49.861 63.9541 49.5602 64.2569 49.1841 64.2569Z"
        fill="#E1E5E6"
      />
      <path
        d="M43.9197 64.2569H33.8423C33.4662 64.2569 33.1654 63.8785 33.1654 63.4243C33.1654 62.9702 33.4662 62.5918 33.8423 62.5918H43.9197C44.2957 62.5918 44.5965 62.9702 44.5965 63.4243C44.5965 63.9541 44.2957 64.2569 43.9197 64.2569Z"
        fill="#E1E5E6"
      />
      <path
        d="M56.7797 15.6671H34.1431C33.6166 15.6671 33.1654 15.2129 33.1654 14.6831C33.1654 14.1533 33.6166 13.6992 34.1431 13.6992H56.7797C57.3062 13.6992 57.7574 14.1533 57.7574 14.6831C57.7574 15.2129 57.3062 15.6671 56.7797 15.6671Z"
        fill="#E1E5E6"
      />
      <path
        d="M42.8668 21.1163H34.1431C33.6166 21.1163 33.1654 20.6622 33.1654 20.1324C33.1654 19.6026 33.6166 19.1484 34.1431 19.1484H42.7916C43.3181 19.1484 43.7693 19.6026 43.7693 20.1324C43.7693 20.6622 43.3181 21.1163 42.8668 21.1163Z"
        fill="#E1E5E6"
      />
      <path
        d="M63.3975 5.44922V18.9213C63.3975 20.8135 65.052 22.3272 66.9321 22.3272H78.8145"
        fill="#E1E5E6"
      />
      <path
        d="M52.3081 51.1602H45.7729H42.8991H34.2076C33.8572 51.1602 33.5067 51.5139 33.5067 52.0091C33.5067 52.4335 33.7871 52.858 34.2076 52.858H42.8991H45.7729H52.3081C52.6586 52.858 53.0091 52.5042 53.0091 52.0091C52.939 51.5139 52.6586 51.1602 52.3081 51.1602Z"
        fill="#E1E5E6"
      />
      <path
        d="M51.4865 45.0049H41.8138H38.5194H34.2076C33.8572 45.0049 33.5067 45.3586 33.5067 45.8538C33.5067 46.2782 33.7871 46.7027 34.2076 46.7027H38.5194H41.8138H51.4865C51.837 46.7027 52.1875 46.349 52.1875 45.8538C52.1174 45.3586 51.837 45.0049 51.4865 45.0049Z"
        fill="#E1E5E6"
      />
      <path
        d="M56.2059 38.7803H53.6825H51.1592H34.2076C33.8572 38.7803 33.5067 39.134 33.5067 39.6292C33.5067 40.0536 33.7871 40.4781 34.2076 40.4781H51.1592H53.9629H56.1358C56.4862 40.4781 56.8367 40.1244 56.8367 39.6292C56.9068 39.2047 56.5563 38.7803 56.2059 38.7803Z"
        fill="#E1E5E6"
      />
      <path
        d="M72.1996 52.2236H67.6069H62.4624H53.6669C53.0395 52.2236 52.4121 52.8543 52.4121 53.7373C52.4121 54.4942 52.914 55.2511 53.6669 55.2511H62.4624H67.6069H72.1996C72.827 55.2511 73.4543 54.6203 73.4543 53.7373C73.3289 52.8543 72.827 52.2236 72.1996 52.2236Z"
        fill="#E1E5E6"
      />
      <path
        d="M72.1974 44.6543H60.8626H54.9546H52.9177C52.2892 44.6543 51.6606 45.285 51.6606 46.168C51.6606 46.9249 52.1635 47.6817 52.9177 47.6817H54.9546H60.8626H72.1974C72.8259 47.6817 73.4544 47.051 73.4544 46.168C73.3287 45.285 72.8259 44.6543 72.1974 44.6543Z"
        fill="#E1E5E6"
      />
      <path
        d="M72.3113 37.0859H67.8033H63.2953H56.6704C56.0443 37.0859 55.4182 37.7167 55.4182 38.5997C55.4182 39.3565 55.9191 40.1134 56.6704 40.1134H63.2953H68.3042H72.1861C72.8122 40.1134 73.4383 39.4827 73.4383 38.5997C73.5635 37.8428 72.9374 37.0859 72.3113 37.0859Z"
        fill="#E1E5E6"
      />
      <path
        d="M72.2679 32.626H64.0671H62.0344H34.2076C33.8572 32.626 33.5067 32.9797 33.5067 33.4749C33.5067 33.8993 33.7871 34.3238 34.2076 34.3238H62.0344H64.0671H72.1978C72.6885 34.3238 72.9688 33.9701 72.9688 33.4749C72.9688 33.0504 72.6885 32.626 72.2679 32.626Z"
        fill="#E1E5E6"
      />
      <path
        d="M93.5215 70.5434L85.67 62.5058C84.8647 61.6815 83.7071 61.3723 82.6502 61.5784L80.7377 59.6206C86.1733 52.7165 85.7203 42.5665 79.4794 36.1776C74.2451 30.8192 66.444 29.6342 60.1024 32.6741C58.3409 33.4984 56.68 34.6835 55.1701 36.1776C53.3079 38.0325 51.9993 40.2479 51.194 42.618C50.7914 43.7515 50.4894 44.885 50.3384 46.07C49.5835 51.3769 51.194 56.9929 55.1701 61.0632C55.2708 61.1662 55.3211 61.2178 55.4217 61.3208C58.7435 64.6183 63.0216 66.2155 67.3499 66.2155C71.175 66.2155 75.0001 64.9274 78.1205 62.3513L80.033 64.3091C79.8317 65.3911 80.1337 66.5762 80.939 67.4005L88.7401 75.4381C90.0487 76.7777 92.1625 76.7777 93.4711 75.4381C94.83 74.0985 94.83 71.883 93.5215 70.5434ZM77.0133 58.5386C76.4093 59.1569 75.755 59.6721 75.1007 60.1873C74.4464 60.651 73.7921 61.0117 73.1379 61.3208C69.5141 63.0726 65.2361 63.0726 61.6123 61.3208C60.2031 60.651 58.8945 59.7236 57.7369 58.5386C54.4151 55.1381 53.1569 50.4495 53.9622 46.07C54.1635 44.885 54.5158 43.7 55.0694 42.618C55.7237 41.2269 56.6297 39.8873 57.7369 38.7538C58.4919 37.9809 59.2971 37.3111 60.1527 36.7959C62.3673 35.3533 64.8838 34.6835 67.4002 34.6835C70.9233 34.6835 74.3961 36.0231 77.0636 38.7538C82.3482 44.2152 82.3482 53.0771 77.0133 58.5386Z"
        fill="#E1E5E6"
        stroke="#C1C6C9"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PortfolioIcon = styled(
  PortfolioSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CommunityIcon = styled(
  CommunitySvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const HomeIcon = styled(HomeSvg)<IconProps>`
  ${base}
`;

export const SearchIcon = styled(SearchSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const CreateIcon = styled(CreateSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const RepOutlineIcon = styled(
  RepOutlineSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ToolTipIcon = styled(ToolTipSvg, withTransientProps)<IconProps>`
  ${base}
`;

export const ImageRepOutline = styled(
  ImageRepOutlineSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const VideoRepOutline = styled(
  VideoRepOutlineSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AudioRepOutline = styled(
  MicrophoneOutlineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PlayIcon = styled(PlayIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const PauseIcon = styled(PauseIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ThumbUpOutlineIcon = styled(
  ThumbUpOutlineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ThumbDownOutlineIcon = styled(
  ThumbDownOutlineIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ThumbUpIcon = styled(
  ThumbUpIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ThumbDownIcon = styled(
  ThumbDownIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TranslateIcon = styled(
  TranslateIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TextBoxIcon = styled(
  TextBoxIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TextRepOutline = styled(
  TextBoxOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TagIcon = styled(TagIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const TagOutlinedIcon = styled(
  TagOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CustomVocabulariesIcon = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_186_6199)">
        <path d="M20 4H4C2.89 4 2 4.9 2 6V18C2 19.1 2.89 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.11 4 20 4ZM20 18H4V8H20V18Z" />
        <path d="M6 12H18V10H6V12Z" />
        <path d="M6 16H14V14H6V16Z" />
      </g>
      <defs>
        <clipPath id="clip0_186_6199">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const RepCompleteBadge = styled(
  (props: IconProps) => (
    <VerifiedBadge {...props} color={theme.kinetic.v2.palette.rgb.positive} />
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CoachBadge = styled(
  (props: IconProps) => (
    <VerifiedBadge {...props} color={theme.kinetic.v2.palette.rgb.fluoro} />
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AiLargeIcon = styled(
  AiLargeIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ApprovedIcon = styled(
  ApprovedIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ApprovedOutlinedIcon = styled(
  ApprovedOutlinedIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const KeyIcon = styled(KeyIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const NavBarFeedbackIcon = styled(
  NavBarFeedbackIconSvg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const MagnifyIcon = styled(
  MagnifyIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CopyIcon = styled(CopyIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const SyncIcon = styled(SyncIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const AddCircleOutlineIcon = styled(
  AddCircleOutlineMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const MenuIcon = styled(MenuIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const MenuOpenIcon = styled(
  MenuOpenIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const StoreIcon = styled(StoreIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const StoreOutlinedIcon = styled(
  StoreOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TerminalIcon = styled(
  TerminalIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PersonIcon = styled(PersonIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const PersonOutlinedIcon = styled(
  PersonOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const KeyOutlinedIcon = styled(
  KeyOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const DashboardOutlinedIcon = styled(
  DashboardOutlinedIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ArchiveIcon = styled(
  ArchiveIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ArchiveIconV2 = styled(
  ArchiveIconV2Svg,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const UnarchiveIcon = styled(
  UnarchiveIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const BlurOnIcon = styled(BlurOnIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const MoreVertIcon = styled(
  MoreVertIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TextFieldsIcon = styled(
  TextFieldsIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FormatClearIcon = styled(
  FormatClearIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const MicOnIcon = styled(MicOnIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const MicOffIcon = styled(MicOffIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const ClearIcon = styled(ClearIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const PhotoCameraIcon = styled(
  PhotoCameraIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const FlipCameraIcon = styled(
  FlipCameraIosIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AccessAlarmIcon = styled(
  AccessAlarmIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CollectionsIcon = styled(
  (props: IconProps) => (
    <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_846_8237)">
        <path d="M15.6667 3.33341C16.219 3.33341 16.6667 3.78113 16.6667 4.33341V12.3334C16.6667 12.8857 16.219 13.3334 15.6667 13.3334H7.66675C7.11446 13.3334 6.66675 12.8857 6.66675 12.3334V4.33342C6.66675 3.78113 7.11446 3.33341 7.66675 3.33341H15.6667ZM16.6667 1.66675H6.66675C5.75008 1.66675 5.00008 2.41675 5.00008 3.33341V13.3334C5.00008 14.2501 5.75008 15.0001 6.66675 15.0001H16.6667C17.5834 15.0001 18.3334 14.2501 18.3334 13.3334V3.33341C18.3334 2.41675 17.5834 1.66675 16.6667 1.66675ZM2.50008 5.00008C2.03984 5.00008 1.66675 5.37318 1.66675 5.83342V16.6667C1.66675 17.5834 2.41675 18.3334 3.33341 18.3334H14.1667C14.627 18.3334 15.0001 17.9603 15.0001 17.5001V17.5001C15.0001 17.0398 14.627 16.6667 14.1667 16.6667H4.33342C3.78113 16.6667 3.33341 16.219 3.33341 15.6667V5.83342C3.33341 5.37318 2.96032 5.00008 2.50008 5.00008V5.00008Z" />
        <path d="M12.9167 6.66667L15.8333 11.6667H10L12.9167 6.66667Z" />
        <path d="M9.58333 8.33333L11.6667 11.6667H7.5L9.58333 8.33333Z" />
        <path d="M10.4167 5.83333C10.4167 6.29357 10.0436 6.66667 9.58333 6.66667C9.1231 6.66667 8.75 6.29357 8.75 5.83333C8.75 5.3731 9.1231 5 9.58333 5C10.0436 5 10.4167 5.3731 10.4167 5.83333Z" />
      </g>
      <defs>
        <clipPath id="clip0_846_8237">
          <rect width="20" height="20" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PresentToAllIcon = styled(
  PresentToAllIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PausePresentationIcon = styled(
  PausePresentationIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

// TODO: Evaluate why we have so many different settings icons and if we can leave just one
export const SettingsIcon2 = styled(
  SettingsIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const GetAppIcon = styled(GetAppIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const MagicIcon = styled(MagicIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const BlockIcon = styled(BlockIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const RefreshIcon = styled(
  RefreshIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ErrorIcon = styled(ErrorIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const StickyNoteIcon = styled(
  (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M2.16667 13.8333H9.66667V9.66667H13.8333V2.16667H2.16667V13.8333ZM2.16667 15.5C1.70833 15.5 1.31583 15.3369 0.989167 15.0108C0.663055 14.6842 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663055 1.31583 0.989167 0.989167C1.31583 0.663055 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.6842 0.663055 15.0108 0.989167C15.3369 1.31583 15.5 1.70833 15.5 2.16667V10.5L10.5 15.5H2.16667ZM3.83333 9.66667V8H8V9.66667H3.83333ZM3.83333 6.33333V4.66667H12.1667V6.33333H3.83333Z" />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ExportIcon = styled(ExportIconMui, withTransientProps)<IconProps>`
  ${base}
`;

export const PriorityHighIcon = styled(
  PriorityHighIconMui,
  withTransientProps
)<IconProps>`
  ${base}
`;

export const DeleteOutlinedIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_961_6629"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_961_6629)">
        <path
          d="M7 21C6.45 21 5.97933 20.8043 5.588 20.413C5.196 20.021 5 19.55 5 19V6H4V4H9V3H15V4H20V6H19V19C19 19.55 18.8043 20.021 18.413 20.413C18.021 20.8043 17.55 21 17 21H7ZM17 6H7V19H17V6ZM9 17H11V8H9V17ZM13 17H15V8H13V17Z"
          fill="#313130"
        />
      </g>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PlusIconV2 = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_770_4433)">
        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_770_4433">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ReDoIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="1 4 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_766_1935)">
        <path
          d="M9.9 20C8.28333 20 6.896 19.475 5.738 18.425C4.57933 17.375 4 16.0667 4 14.5C4 12.9333 4.57933 11.625 5.738 10.575C6.896 9.525 8.28333 9 9.9 9H16.2L13.6 6.4L15 5L20 10L15 15L13.6 13.6L16.2 11H9.9C8.85 11 7.93767 11.3333 7.163 12C6.38767 12.6667 6 13.5 6 14.5C6 15.5 6.38767 16.3333 7.163 17C7.93767 17.6667 8.85 18 9.9 18H17V20H9.9Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_766_1935">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CameraIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_770_4453)">
        <path
          d="M18 8.48V6C18 4.9 17.1 4 16 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H16C17.1 20 18 19.1 18 18V15.52L22 17.5V6.5L18 8.48ZM16 9.69V17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17V7C4 6.44772 4.44772 6 5 6H15C15.5523 6 16 6.44772 16 7V9.69Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_770_4453">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const TextIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1194_891)">
        <path
          d="M19 5V19H5V5H19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
          fill="white"
        />
        <path
          d="M14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1194_891">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const DropdownThickIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 9L12 15L18 9"
        stroke="#62625F"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PhotoIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1194_700)">
        <path
          d="M20 4H16.83L15 2H9L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H8.05L9.88 4H14.12L15.95 6H20V18ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1194_700">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const MicroIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1194_689)">
        <path
          d="M12 15C13.66 15 14.99 13.66 14.99 12L15 6C15 4.34 13.66 3 12 3C10.34 3 9 4.34 9 6V12C9 13.66 10.34 15 12 15ZM10.8 5.9C10.8 5.24 11.34 4.7 12 4.7C12.66 4.7 13.2 5.24 13.2 5.9L13.19 12.1C13.19 12.76 12.66 13.3 12 13.3C11.34 13.3 10.8 12.76 10.8 12.1V5.9ZM17.3 12C17.3 15 14.76 17.1 12 17.1C9.24 17.1 6.7 15 6.7 12H5C5 15.41 7.72 18.23 11 18.72V22H13V18.72C16.28 18.24 19 15.42 19 12H17.3Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1194_689">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const PDFIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="mask0_1090_8997" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <path
        d="M11 19H13V14.825L14.6 16.425L16 15L12 11L8 15L9.425 16.4L11 14.825V19ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.196 21.021 4 20.55 4 20V4C4 3.45 4.196 2.979 4.588 2.587C4.97933 2.19567 5.45 2 6 2H14L20 8V20C20 20.55 19.8043 21.021 19.413 21.413C19.021 21.8043 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z"
        fill="white"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const CrossIcon = styled(
  (props: IconProps) => (
    <svg
      width="24"
      height="24"
      viewBox="6 6 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.2426 22.6569L17 18.4143L12.7574 22.6569L11.3431 21.2427L15.5858 17.0001L11.3431 12.7574L12.7574 11.3432L17 15.5859L21.2426 11.3432L22.6569 12.7574L18.4142 17.0001L22.6569 21.2427L21.2426 22.6569Z"
        fill="white"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ArchiveV2Icon = styled(
  (props: IconProps) => (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.66666 3.33325H6.33332V6.09992L5.26666 5.04992L4.31666 5.99992L6.99999 8.66659L9.66666 5.99992L8.71666 5.06659L7.66666 6.11659V3.33325ZM12.3333 0.666586C12.7 0.666586 13.0138 0.79703 13.2747 1.05792C13.536 1.31925 13.6667 1.63325 13.6667 1.99992L13.6667 9.99992C13.6667 10.3666 13.536 10.6804 13.2747 10.9413C13.0138 11.2026 12.7 11.3333 12.3333 11.3333L1.66666 11.3333C1.29999 11.3333 0.98599 11.2026 0.724656 10.9413C0.463767 10.6804 0.333323 10.3666 0.333323 9.99992L0.333323 1.99992C0.333323 1.63325 0.463767 1.31925 0.724656 1.05792C0.98599 0.79703 1.29999 0.666586 1.66666 0.666586L12.3333 0.666586Z"
        fill="#313130"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const ConversationIcon = styled(
  (props: IconProps & SVGAttributes<SVGElement>) => (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_335_11878)">
        <path
          d="M15 4.9707V11.9707H5.17L4.58 12.5607L4 13.1407V4.9707H15ZM16 2.9707H3C2.45 2.9707 2 3.4207 2 3.9707V17.9707L6 13.9707H16C16.55 13.9707 17 13.5207 17 12.9707V3.9707C17 3.4207 16.55 2.9707 16 2.9707ZM21 6.9707H19V15.9707H6V17.9707C6 18.5207 6.45 18.9707 7 18.9707H18L22 22.9707V7.9707C22 7.4207 21.55 6.9707 21 6.9707Z"
          fill={props.fill ? props.fill : "white"}
        />
      </g>
      <defs>
        <clipPath id="clip0_335_11878">
          <rect
            width="24"
            height="24"
            fill={props.fill ? props.fill : "white"}
            transform="translate(0 0.970703)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;

export const AiIcon = styled(
  (props: IconProps) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.10747 7.94064C4.24834 7.96971 4.38745 8.00369 4.52466 8.04243C4.64186 8.0755 4.75767 8.11207 4.87199 8.15197C6.72152 8.79777 8.17692 10.3223 8.79345 12.2596C8.83155 12.3794 8.86646 12.5007 8.89803 12.6235C8.93501 12.7672 8.96746 12.9129 8.99521 13.0605C8.99953 13.0835 9.00375 13.1066 9.00786 13.1297L9.00911 13.1367L9.01076 13.1462L9.02151 13.2089L9.02342 13.2201C9.06589 13.4553 9.38734 13.4553 9.42982 13.2201L9.43195 13.2077L9.43878 13.1676L9.44248 13.1462L9.44413 13.1367L9.44537 13.1297C9.44949 13.1066 9.45371 13.0835 9.45803 13.0605C9.48578 12.9129 9.51823 12.7672 9.5552 12.6235C9.58678 12.5007 9.62169 12.3794 9.65978 12.2596C10.2763 10.3223 11.7317 8.79777 13.5813 8.15197C13.6956 8.11207 13.8114 8.0755 13.9286 8.04243C14.0658 8.00369 14.2049 7.96971 14.3458 7.94064C14.3678 7.93611 14.3898 7.93169 14.4119 7.92738L14.4186 7.92608L14.4277 7.92435L14.4551 7.91915L14.4875 7.91308L14.4982 7.91109C14.7227 7.8666 14.7227 7.52988 14.4982 7.48539L14.4875 7.4834L14.4277 7.47213L14.4186 7.4704L14.4119 7.4691C14.3898 7.46479 14.3678 7.46037 14.3458 7.45584C14.2049 7.42677 14.0658 7.39279 13.9286 7.35405C13.8114 7.32098 13.6956 7.28441 13.5813 7.24451C11.7317 6.59871 10.2763 5.07421 9.65978 3.13686C9.62169 3.01712 9.58678 2.89581 9.5552 2.77303C9.51823 2.62933 9.48578 2.48361 9.45803 2.33602C9.45371 2.31298 9.44949 2.28988 9.44537 2.26675L9.44413 2.25973L9.44248 2.25024L9.43174 2.18755L9.42982 2.17635C9.38734 1.94122 9.06589 1.94122 9.02342 2.17635L9.02151 2.18755L9.02133 2.18864L9.01076 2.25024L9.00911 2.25973L9.00786 2.26675C9.00375 2.28988 8.99953 2.31298 8.99521 2.33602C8.96746 2.48358 8.93501 2.62933 8.89803 2.77303C8.86646 2.89581 8.83155 3.01712 8.79345 3.13686C8.17692 5.07421 6.72152 6.59871 4.87199 7.24451C4.75767 7.28441 4.64186 7.32098 4.52466 7.35405C4.38745 7.39279 4.24832 7.42677 4.10745 7.45584C4.08544 7.46037 4.0634 7.46479 4.04131 7.4691L4.03461 7.4704L4.02555 7.47213L3.9657 7.4834L3.95501 7.48539C3.73053 7.52988 3.73053 7.8666 3.95501 7.91109L3.9657 7.91308L4.02555 7.92435L4.03461 7.92608L4.04131 7.92738C4.0634 7.93169 4.08544 7.93611 4.10747 7.94064Z"
        fill="currentColor"
      />
      <path
        d="M2.09435 12.7951C1.88846 12.6825 1.66497 12.5999 1.42903 12.5527L1.39973 12.547C1.31109 12.5305 1.31109 12.3972 1.39973 12.3807L1.42903 12.375C1.66497 12.3278 1.88846 12.2452 2.09435 12.1326C2.18594 12.0825 2.27404 12.0265 2.35818 11.9651C2.59268 11.7938 2.79656 11.5802 2.96006 11.3346C3.01873 11.2465 3.0722 11.1542 3.12 11.0583C3.22749 10.8426 3.30634 10.6085 3.3514 10.3613L3.35682 10.3307C3.37264 10.2378 3.4998 10.2378 3.51562 10.3307L3.52102 10.3613C3.5661 10.6085 3.64496 10.8426 3.75243 11.0583C3.80024 11.1542 3.85372 11.2465 3.91239 11.3346C4.07587 11.5802 4.27977 11.7938 4.51426 11.9651C4.59841 12.0265 4.68651 12.0825 4.77808 12.1326C4.98399 12.2452 5.20748 12.3278 5.44342 12.375L5.4727 12.3807C5.56135 12.3972 5.56135 12.5305 5.4727 12.547L5.44342 12.5527C5.20748 12.5999 4.98399 12.6825 4.77808 12.7951C4.68651 12.8452 4.59841 12.9012 4.51426 12.9626C4.27977 13.1339 4.07587 13.3475 3.91239 13.5931C3.85372 13.6812 3.80024 13.7735 3.75243 13.8694C3.64496 14.0851 3.5661 14.3192 3.52102 14.5663L3.51562 14.597C3.4998 14.6899 3.37264 14.6899 3.35682 14.597L3.3514 14.5663C3.30634 14.3192 3.22749 14.0851 3.12 13.8694C3.0722 13.7735 3.01873 13.6812 2.96006 13.5931C2.79656 13.3475 2.59268 13.1339 2.35818 12.9626C2.27404 12.9012 2.18594 12.8452 2.09435 12.7951Z"
        fill="currentColor"
      />
    </svg>
  ),
  withTransientProps
)<IconProps>`
  ${base}
`;
